<template>
	<v-container fluid class="pa-0 mt-2">
		<div ref="fullscreenReporte" class="cp-fullscreen-root">
			<VueCtkDateTimePicker v-if="false" v-model="dateNow" label="Hasta" format="YYYY-MM-DD HH:mm"
				formatted="YYYY-MM-DD HH:mm" noHeader overlay />
			
			<div v-if="!showInitialLoading" class="d-flex align-center mb-2 cp-refresh-row">
				<CountDownSearch v-if="yaConsultado" class="cp-refresh-countdown" v-model="consultaData" :permitirDesactivarConsulta="true"
					:pausado="cuentaPausada" :duracion-segundos="600" :recordarProgreso="true" :recargando="isLoading"
					@recargaManual="initialize()" />
				<v-btn v-if="true" class="cp-refresh-button" @click="initialize()" color="error">Actualizar</v-btn>
			</div>
			<div v-if="showReloadingBar" class="cp-top-reload-loading">
				<v-progress-linear color="primary" height="3" indeterminate />
			</div>
			<LoaderData :loading="showInitialLoading" :response="loaderResponse" :error="errorCumplimiento">
				<v-col cols="12">
					<section class="cp-top-layout">
						<div class="cp-left-stack">
							<div class="cp-kpi-grid">
								<article v-for="card in summaryCards" :key="card.key" class="cp-kpi-card"
									:class="`cp-kpi-card--${card.tone}`">
									<div class="cp-kpi-top">
										<div class="cp-kpi-top-main">
											<div class="cp-kpi-icon-pack" :class="`cp-kpi-icon-pack--${card.tone}`">
												<v-icon class="cp-kpi-icon-main">{{ card.icon }}</v-icon>
											</div>
											<p class="cp-kpi-title">{{ card.title }}</p>
										</div>
										<v-btn v-if="card.openable !== false" icon small class="cp-kpi-eye-btn"
											@click.stop="openCardDetail(card.key)">
											<v-icon class="cp-kpi-eye-icon">mdi-eye-outline</v-icon>
										</v-btn>
									</div>
									<div class="cp-kpi-value-row">
										<p class="cp-kpi-value-main" :class="`cp-kpi-value-main--${card.tone}`">{{
											card.primaryValue }}</p>
										<p v-if="card.secondaryValue" class="cp-kpi-value-secondary">/ {{
											card.secondaryValue }}
										</p>
									</div>
									<p v-if="card.caption != ''" class="cp-kpi-caption">{{ card.caption }}</p>
								</article>
							</div>
						</div>

					</section>
				</v-col>

				<section class="cp-programmed-layout">
					<article class="cp-panel cp-panel--programmed">
						<div class="cp-panel-head cp-panel-head-row cp-main-gantt-head">
							<span>Gantt por máquina</span>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="toggleFullscreenReporte">
								{{ isFullscreenReporte ? "Cerrar pantalla completa" : "Pantalla completa" }}
								<v-icon>mdi-overscan</v-icon>
							</v-btn>
							<div class="cp-main-gantt-actions">
								<button v-if="selectedMainGanttView !== 'tiempoReal'" type="button"
									class="cp-progress-toggle cp-toggle-table-btn"
									:class="{ 'cp-progress-toggle--active': showMainGanttTable }"
									@click="showMainGanttTable = !showMainGanttTable">
									{{ showMainGanttTable ? "Ocultar tabla" : "Mostrar tabla" }}
								</button>
							</div>
						</div>
						<div class="cp-gantt-switch cp-gantt-switch--main">
							<!-- <button type="button" class="cp-progress-toggle"
								:class="{ 'cp-progress-toggle--active': selectedMainGanttView === 'real' }"
								@click="selectedMainGanttView = 'real'">
								Real
							</button> -->
							<button type="button" class="cp-progress-toggle"
								:class="{ 'cp-progress-toggle--active': selectedMainGanttView === 'tiempoReal' }"
								@click="selectedMainGanttView = 'tiempoReal'">
								Tiempo Real
							</button>
							<button v-if="true" type="button" class="cp-progress-toggle"
								:class="{ 'cp-progress-toggle--active': selectedMainGanttView === 'teorico' }"
								@click="selectedMainGanttView = 'teorico'">
								Teórico
							</button>
							<span class="cp-gantt-order-note">
								Orden: mayor fin en Real Ajustado (termina más tarde primero)
							</span>
							<label class="cp-gantt-limit-control">
								<span class="cp-gantt-limit-label">Máquinas</span>
								<select v-model.number="mainGanttMachineLimit" class="cp-gantt-limit-select">
									<option :value="0">Todas</option>
									<option v-for="option in mainGanttMachineLimitOptions" :key="`main-gantt-limit-${option}`"
										:value="option">
										{{ option }}
									</option>
								</select>
								<input v-model.number="mainGanttMachineCustomLimit" class="cp-gantt-limit-input" type="number" min="1"
									step="1" placeholder="Personalizada" />
							</label>
						</div>
						<div v-if="selectedMainGanttView === 'real'" class="cp-real-legend">
							<span class="cp-real-legend-item">
								<i class="cp-real-legend-dot cp-real-legend-dot--production"></i>
								Producción
							</span>
							<span class="cp-real-legend-item">
								<i class="cp-real-legend-dot cp-real-legend-dot--dead"></i>
								Tiempo muerto
							</span>
							<span class="cp-real-legend-item">
								<i class="cp-real-legend-dot cp-real-legend-dot--delay"></i>
								Extra
							</span>
							<span class="cp-real-legend-item">
								<i class="cp-real-legend-dot cp-real-legend-dot--late"></i>
								Retraso
							</span>
						</div>

						<div v-if="selectedMainGanttView === 'teorico'">
							<div class="cp-week-machines-row cp-week-machines-row--inline">
								<div class="cp-week-form-grid cp-week-form-grid--inline">
									<div class="cp-week-form-field">
										<label class="cp-week-form-label">Año</label>
										<select v-model.number="programmedWeekYear" class="cp-week-form-select"
											:disabled="isWeekDialogLoading" @change="onProgrammedWeekSelectionChange">
											<option v-for="year in programmedWeekYearOptions" :key="`programmed-year-${year}`"
												:value="year">
												{{ year }}
											</option>
										</select>
									</div>
									<div class="cp-week-form-field">
										<label class="cp-week-form-label">Semana</label>
										<select v-model.number="programmedWeekNumber" class="cp-week-form-select"
											:disabled="isWeekDialogLoading" @change="onProgrammedWeekSelectionChange">
											<option v-for="option in programmedWeekOptions" :key="option.value" :value="option.value"
												:style="option.isCurrent ? 'color: rgba(214, 69, 69, 0.72); font-weight: 700;' : ''">
												{{ option.label }}
											</option>
										</select>
									</div>
								</div>
								<span v-if="isWeekDialogLoading" class="cp-week-loading-text">Consultando semana...</span>
							</div>
							<div v-if="weekDialogError" class="cp-detail-empty">No fue posible consultar la semana seleccionada.</div>
							<div v-if="filteredProgrammedGanttBars.length" class="cp-gantt-wrap">
								<apexchart type="rangeBar" :height="programmedGanttHeight" :options="programmedGanttOptions"
									:series="programmedGanttSeries" />
							</div>
							<div v-else class="cp-detail-empty">Sin datos teóricos para mostrar.</div>
						</div>
						<div v-else-if="selectedMainGanttView === 'real'">
							<div v-if="filteredRealWeekGanttBars.length" class="cp-gantt-wrap">
								<apexchart type="rangeBar" :height="realWeekGanttHeight" :options="realWeekGanttOptions"
									:series="realWeekGanttSeries" />
							</div>
							<div v-else class="cp-detail-empty">Sin datos reales para mostrar.</div>
						</div>
						<div v-else>
							<div class="cp-combined-legend">
								<span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--timeoff"></i>
									Tiempo muerto
								</span>
								<!-- <span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--restartable"></i>yu
									Reanudable
								</span> -->
								<span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--production"></i>
									Producción
								</span>
								<span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--delay-low"></i>
									1%-10% desfase
								</span>
								<span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--delay-mid"></i>
									10%-15% desfase
								</span>
								<!-- <span class="cp-combined-legend-item">
									<i class="cp-combined-legend-dot cp-combined-legend-dot--inop"></i>
									Extra
								</span> -->
							</div>
							<div v-if="filteredCombinedUnifiedBars.length" class="cp-gantt-wrap">
								<apexchart type="rangeBar" :height="combinedUnifiedGanttHeight" :options="combinedUnifiedGanttOptions"
									:series="combinedUnifiedGanttSeries" />
							</div>
							<div v-else-if="!isLoading" class="cp-detail-empty">
								Sin datos de tiempo real para mostrar.
							</div>
						</div>

						<!-- <div v-if="showMainGanttTable && selectedMainGanttView !== 'tiempoReal'"> -->
						<div v-if="false">
							<div class="cp-detail-subtitle">Resumen por máquina</div>

							<div v-if="selectedMainGanttView === 'teorico'">
								<div v-if="programmedMachineRows.length" class="cp-detail-table-wrap">
									<v-data-table :headers="programmedTableHeaders" :items="programmedMachineRows" item-key="machineKey"
										show-expand :expanded.sync="expandedProgrammedRows" disable-pagination hide-default-footer dense
										class="cp-expected-datatable cp-programmed-table">
										<template v-slot:item.visibility="{ item }">
											<v-btn icon small @click.stop="toggleProgrammedMachineVisibility(item.machineKey)">
												<v-icon :color="item.visible ? '#2e9d53' : '#d64545'">
													{{ item.visible ? "mdi-eye-outline" : "mdi-eye-off-outline" }}
												</v-icon>
											</v-btn>
										</template>
										<template v-slot:item.machineLabel="{ item }">
											{{ item.machineLabel }}
										</template>
										<template v-slot:item.slackSec="{ item }">
											{{ formatDuration(item.slackSec) }}
										</template>
										<template v-slot:item.overlapSec="{ item }">
											{{ formatDuration(item.overlapSec) }}
										</template>
										<template v-slot:item.productionSec="{ item }">
											{{ formatDuration(item.productionSec) }}
										</template>
										<template v-slot:expanded-item="{ headers, item }">
											<td :colspan="headers.length" class="cp-ops-cell">
												<div v-if="item.details && item.details.length" class="cp-ops-wrap">
													<table class="cp-ops-table">
														<thead>
															<tr>
																<th></th>
																<th>ODT</th>
																<th>Día</th>
																<th>Tipo fragmento</th>
																<th>Área</th>
																<th>Molde</th>
																<th>Artículo</th>
																<th>Inicio esperado</th>
																<th>Fin esperado</th>
																<th>Duración</th>
																<th>Operaciones</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="detail in item.details" :key="detail.uid">
																<td class="cp-ops-visibility-cell">
																	<v-btn icon x-small class="cp-odt-eye-btn"
																		@click.stop="toggleProgrammedOdtVisibility(item.machineKey, detail.visibilityKey)">
																		<v-icon small :color="detail.visible !== false ? '#2e9d53' : '#d64545'">
																			{{ detail.visible !== false ?
																				"mdi-eye-outline" : "mdi-eye-off-outline" }}
																		</v-icon>
																	</v-btn>
																</td>
																<td>{{ detail.odtLabel }}</td>
																<td>{{ detail.dayLabel }}</td>
																<td>{{ detail.fragmentType || "-" }}</td>
																<td>{{ detail.areaSummary }}</td>
																<td>{{ detail.moldSummary }}</td>
																<td>{{ detail.articleSummary }}</td>
																<td>{{ formatDateTime(detail.startMs) }}</td>
																<td>{{ formatDateTime(detail.endMs) }}</td>
																<td>{{ formatDuration(detail.durationSec) }}</td>
																<td>{{ formatNumber(detail.operationsCount) }}</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div v-else class="cp-detail-empty">Sin detalle esperado para mostrar.
												</div>
											</td>
										</template>
									</v-data-table>
								</div>
								<div v-else class="cp-detail-empty">Sin detalle teórico por máquina para mostrar.</div>
							</div>

							<div v-else>
								<div v-if="realMachineRows.length" class="cp-detail-table-wrap">
									<v-data-table :headers="realTableHeaders" :items="realMachineRows" item-key="machineKey" show-expand
										:expanded.sync="expandedRealRows" disable-pagination hide-default-footer dense
										class="cp-expected-datatable cp-programmed-table">
										<template v-slot:item.visibility="{ item }">
											<v-btn icon small @click.stop="toggleRealMachineVisibility(item.machineKey)">
												<v-icon :color="item.visible ? '#2e9d53' : '#d64545'">
													{{ item.visible ? "mdi-eye-outline" : "mdi-eye-off-outline" }}
												</v-icon>
											</v-btn>
										</template>
										<template v-slot:item.machineLabel="{ item }">
											{{ item.machineLabel }}
										</template>
										<template v-slot:item.shiftedSec="{ item }">
											{{ formatDuration(item.shiftedSec) }}
										</template>
										<template v-slot:item.errorSec="{ item }">
											{{ formatDuration(item.errorSec) }}
										</template>
										<template v-slot:item.delaySec="{ item }">
											{{ formatDuration(item.delaySec) }}
										</template>
										<template v-slot:item.advanceSec="{ item }">
											{{ formatDuration(item.advanceSec) }}
										</template>
										<template v-slot:expanded-item="{ headers, item }">
											<td :colspan="headers.length" class="cp-ops-cell">
												<div v-if="item.operations.length" class="cp-ops-wrap">
													<table class="cp-ops-table">
														<thead>
															<tr>
																<th>Área</th>
																<th>Molde</th>
																<th>Artículo</th>
																<th>ODT</th>
																<th>Máquina</th>
																<th>TC</th>
																<th>Piezas a producir</th>
																<th>Esperadas</th>
																<th>OK</th>
																<th>Faltantes</th>
																<th>Tipo fragmento</th>
																<th>Inicio real</th>
																<th>Fin real</th>
																<th>Tiempo producción</th>
																<th>Tiempo desfase</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="op in item.operations" :key="op.uid">
																<td>{{ op.area }}</td>
																<td>{{ op.mold }}</td>
																<td>{{ op.article }}</td>
																<td>{{ op.odtLabel }}</td>
																<td>{{ op.machineModel }}</td>
																<td>{{ op.tc > 0 ? formatNumber(op.tc) : "-" }}</td>
																<td>{{ op.piecesToProduce > 0 ?
																	formatNumber(op.piecesToProduce) : "-" }}</td>
																<td>{{ op.expectedUntil > 0 ?
																	formatNumber(op.expectedUntil) : "-" }}</td>
																<td>{{ op.okUntil > 0 ? formatNumber(op.okUntil) : "-"
																}}</td>
																<td>{{ op.missingPieces > 0 ?
																	formatNumber(op.missingPieces) : "-" }}</td>
																<td>{{ op.fragmentType || "-" }}</td>
																<td>{{ formatDateTime(op.startMs) }}</td>
																<td>{{ formatDateTime(op.endMs) }}</td>
																<td>{{ formatDuration(op.productionSec) }}</td>
																<td>{{ formatDuration(op.delaySec) }}</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div v-else class="cp-detail-empty">Sin operaciones reales para mostrar.
												</div>
											</td>
										</template>
									</v-data-table>
								</div>
								<div v-else class="cp-detail-empty">Sin detalle real por máquina para mostrar.</div>
							</div>
						</div>
					</article>
				</section>

				</LoaderData>

				<v-dialog v-model="dialogs.combinedFragment" max-width="1100">
					<v-card class="cp-detail-dialog">
						<v-card-title class="cp-detail-title">Detalle de fragmento (Tiempo Real)</v-card-title>
						<v-card-text>
							<div class="cp-detail-summary">
								<span><b>Máquina:</b> {{ selectedCombinedFragment.machineModel || "-" }}</span>
								<span><b>Línea:</b> {{ selectedCombinedFragment.lane || "-" }}</span>
								<span><b>Tipo:</b> {{ selectedCombinedFragment.fragmentType || "-" }}</span>
								<span><b>Subtipo:</b> {{ selectedCombinedFragment.fragmentSubtype || "-" }}</span>
								<span><b>ODT:</b> {{ selectedCombinedFragment.odt || "-" }}</span>
									<span><b>Inicio:</b> {{ formatDateTimeWithWeekday(selectedCombinedFragment.startMs) }}</span>
									<span><b>Fin:</b> {{ formatDateTimeWithWeekday(selectedCombinedFragment.endMs) }}</span>
								<span><b>Duración:</b> {{ formatDuration(selectedCombinedFragment.durationSec) }}</span>
							</div>
							<div class="cp-detail-table-wrap"
								v-if="selectedCombinedFragment.operationDetailRows && selectedCombinedFragment.operationDetailRows.length">
								<table class="cp-detail-table cp-detail-table--gantt">
									<thead>
										<tr>
											<!-- <th>Ref</th> -->
											<th v-if="gamemode">Operación</th>
											<th>Área</th>
											<th>Molde</th>
											<th>Artículo</th>
											<th>TC</th>
											<th>Esperadas</th>
											<th>OK</th>
											<th>No OK</th>
											<th>Totales</th>
											<th>Inicio</th>
											<th>Fin</th>
											<th>Duración</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="op in selectedCombinedFragment.operationDetailRows" :key="op.uid">
											<!-- <td>{{ op.pieceLabel || "-" }}</td> -->
											<td v-if="gamemode">{{ op.operationLabel || "-" }}</td>
											<td>{{ op.area || "-" }}</td>
											<td>{{ op.mold || "-" }}</td>
											<td>{{ op.articleName || "-" }}</td>
											<td>{{ op.tc > 0 ? formatNumber(op.tc) : "-" }}</td>
											<td>{{ formatNumber(op.piecesExpected) }}</td>
											<td>{{ formatNumber(op.piecesOk) }}</td>
											<td>{{ formatNumber(op.piecesNoOk) }}</td>
											<td>{{ formatNumber(op.piecesTotal) }}</td>
												<td>{{ op.startMs > 0 ? formatDateTimeWithWeekday(op.startMs) : "-" }}</td>
												<td>{{ op.endMs > 0 ? formatDateTimeWithWeekday(op.endMs) : "-" }}</td>
											<td>{{ op.durationSec > 0 ? formatDuration(op.durationSec) : "-" }}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div v-else class="cp-detail-empty">Sin operaciones para mostrar.</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn text color="primary" @click="dialogs.combinedFragment = false">Cerrar</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="dialogs.active" max-width="820">
					<v-card class="cp-detail-dialog">
					<v-card-title class="cp-detail-title">Máquinas activas</v-card-title>
					<v-card-text>
						<div class="cp-detail-summary">
							<span><b>Activas:</b> {{ cardCounters.active }}</span>
							<span><b>Total máquinas:</b> {{ cardCounters.withProgram }}</span>
						</div>
						<div class="cp-detail-table-wrap" v-if="cardDetails.active.length">
							<table class="cp-detail-table">
								<thead>
									<tr>
										<th>Máquina</th>
										<th>Área</th>
										<th>ODTs activas</th>
										<th>Moldes activos</th>
										<th>Artículos en operación</th>
										<th>Fin último paro</th>
										<th>Tiempo desde último paro</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in cardDetails.active" :key="item.uid">
										<td>{{ item.machineDisplay }}</td>
										<td>{{ item.area }}</td>
										<td>
											<ul v-if="item.odtList && item.odtList.length" class="cp-cell-list">
												<li v-for="odt in item.odtList" :key="`${item.uid}-odt-${odt}`">{{ odt
												}}</li>
											</ul>
											<span v-else>-</span>
										</td>
										<td>
											<ul v-if="item.moldList && item.moldList.length" class="cp-cell-list">
												<li v-for="mold in item.moldList" :key="`${item.uid}-mold-${mold}`">{{
													mold }}</li>
											</ul>
											<span v-else>-</span>
										</td>
										<td>
											<ul v-if="item.operationArticleList && item.operationArticleList.length" class="cp-cell-list">
												<li v-for="article in item.operationArticleList" :key="`${item.uid}-article-${article}`">{{
													article }}
												</li>
											</ul>
											<span v-else>-</span>
										</td>
										<td>{{ item.lastStopEndMs > 0 ? formatDateTime(item.lastStopEndMs) : "-" }}</td>
										<td>{{ item.lastStopEndMs > 0 ? formatDuration(item.timeSinceLastStopSec) : "-"
										}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="cp-detail-empty">Sin datos para mostrar.</div>
						<div class="cp-detail-subtitle mt-4">Máquinas reportando piezas sin ODT</div>
						<div class="cp-detail-table-wrap" v-if="cardDetails.piecesWithoutOdt.length">
							<table class="cp-detail-table">
								<thead>
									<tr>
										<th>Máquina</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in cardDetails.piecesWithoutOdt" :key="item.uid">
										<td>{{ item.nombreInstancia }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="cp-detail-empty">Sin máquinas reportando piezas sin ODT.</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn text color="primary" @click="dialogs.active = false">Cerrar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogs.stopped" max-width="820">
				<v-card class="cp-detail-dialog">
					<v-card-title class="cp-detail-title">Máquinas en paro</v-card-title>
					<v-card-text>
						<div class="cp-detail-summary">
							<span><b>En paro total:</b> {{ cardCounters.stopped }}</span>
							<span><b>Con producción:</b> {{ cardCounters.stoppedWithPieces }}</span>
							<span><b>Sin actividad:</b> {{ cardCounters.noActivity }}</span>
						</div>
						<div class="cp-detail-table-wrap" v-if="cardDetails.stopped.length">
							<table class="cp-detail-table">
								<thead>
									<tr>
										<th>Área</th>
										<th>Máquina</th>
										<th>Causa de paro</th>
										<th>Subcausa de paro</th>
										<th>Tiempo de paro</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in cardDetails.stopped" :key="item.uid">
										<td>{{ item.area }}</td>
										<td>{{ item.machineDisplay }}</td>
										<td>{{ item.stopCause }}</td>
										<td>{{ item.stopSubCause }}</td>
										<td>{{ item.stopTimeSec > 0 ? formatDuration(item.stopTimeSec) : "-" }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="cp-detail-empty">Sin datos para mostrar.</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn text color="primary" @click="dialogs.stopped = false">Cerrar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogs.idle" max-width="820">
				<v-card class="cp-detail-dialog">
					<v-card-title class="cp-detail-title">Máquinas sin programa de producción</v-card-title>
					<v-card-text>
						<div class="cp-detail-summary">
							<span><b>Sin programa:</b> {{ cardCounters.idle }}</span>
							<span><b>Total:</b> {{ cardCounters.total }}</span>
						</div>
						<div class="cp-detail-table-wrap" v-if="cardDetails.idle.length">
							<table class="cp-detail-table">
								<thead>
									<tr>
										<th>Área</th>
										<th>Máquina</th>
										<th>Tiempo desde la última operación</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in cardDetails.idle" :key="item.uid">
										<td>{{ item.area }}</td>
										<td>{{ item.machineDisplay }}</td>
										<td>{{ item.timeSinceLastOperationSec > 0 ?
											formatDuration(item.timeSinceLastOperationSec) :
											"-" }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="cp-detail-empty">Sin datos para mostrar.</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn text color="primary" @click="dialogs.idle = false">Cerrar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

				<v-dialog v-model="dialogs.restarts" max-width="820">
					<v-card class="cp-detail-dialog">
						<v-card-title class="cp-detail-title">Reinicios por máquina</v-card-title>
						<v-card-text>
							<div class="cp-detail-summary">
								<span><b>Total reinicios:</b> {{ formatNumber(cardCounters.restarts) }}</span>
								<span><b>Máquinas reportadas:</b> {{ sortedRestartDetails.length }}</span>
							</div>
							<div class="cp-restart-sort-controls">
								<span class="cp-restart-sort-label">Orden:</span>
								<button
									type="button"
									class="cp-progress-toggle"
									:class="{ 'cp-progress-toggle--active': restartSortDirection === 'desc' }"
									@click="restartSortDirection = 'desc'"
								>
									Mayor a menor
								</button>
								<button
									type="button"
									class="cp-progress-toggle"
									:class="{ 'cp-progress-toggle--active': restartSortDirection === 'asc' }"
									@click="restartSortDirection = 'asc'"
								>
									Menor a mayor
								</button>
							</div>
							<div class="cp-detail-table-wrap" v-if="sortedRestartDetails.length">
								<table class="cp-detail-table">
									<thead>
										<tr>
											<th>Máquina</th>
											<th>Reinicios</th>
											<th>Detalles</th>
										</tr>
									</thead>
										<tbody>
											<tr v-for="item in sortedRestartDetails" :key="item.uid">
												<td>{{ item.machineDisplay || "-" }}</td>
												<td>{{ formatNumber(getRestartCount(item)) }}</td>
												<td class="cp-restart-action-cell">
													<v-btn
														small
														text
														color="primary"
														@click="openRestartMachineDetail(item)"
													>
														Ver detalles
													</v-btn>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div v-else class="cp-detail-empty">Sin datos para mostrar.</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn text color="primary" @click="dialogs.restarts = false">Cerrar</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="dialogs.restartDetail" max-width="900">
					<v-card class="cp-detail-dialog cp-restart-detail-dialog">
						<v-card-title class="cp-detail-title">Detalle de reinicios</v-card-title>
						<v-card-text class="cp-restart-detail-body">
							<div class="cp-detail-summary cp-restart-detail-summary">
								<span><b>Máquina:</b> {{ selectedRestartMachine.machineDisplay || "-" }}</span>
								<span><b>Total reinicios:</b> {{ formatNumber(getRestartCount(selectedRestartMachine)) }}</span>
								<span><b>ODTs:</b> {{ formatNumber(selectedRestartMachine.odts.length) }}</span>
							</div>
							<div v-if="selectedRestartMachine.odts && selectedRestartMachine.odts.length">
								<v-tabs
									v-if="selectedRestartMachine.odts.length > 1"
									v-model="restartDetailTab"
									background-color="transparent"
									class="cp-restart-tabs"
									show-arrows
								>
									<v-tab v-for="odt in selectedRestartMachine.odts" :key="odt.uid">
										{{ odt.odtLabel || "-" }}
									</v-tab>
								</v-tabs>
								<div v-else class="cp-restart-single-odt">
									{{ selectedRestartOdt.odtLabel || "-" }}
								</div>

								<div class="cp-restart-selected-odt">
									<div class="cp-restart-odt-summary-row">
										<div class="cp-restart-odt-label cp-restart-odt-label--active">{{ selectedRestartOdt.odtLabel || "-" }}</div>
										<div class="cp-restart-odt-count">
											<b>Reinicios:</b> {{ formatNumber(selectedRestartOdt.totalReinicios) }}
										</div>
									</div>

									<div class="cp-restart-meta-grid">
										<section class="cp-restart-meta-card">
											<div class="cp-restart-meta-title">Moldes</div>
											<div v-if="selectedRestartOdt.moldes && selectedRestartOdt.moldes.length" class="cp-restart-chip-list">
												<span v-for="mold in selectedRestartOdt.moldes" :key="mold.uid" class="cp-restart-chip">
													{{ mold.label }}
												</span>
											</div>
											<div v-else class="cp-detail-empty cp-detail-empty--compact">Sin moldes para mostrar.</div>
										</section>
										<section class="cp-restart-meta-card">
											<div class="cp-restart-meta-title">Artículos</div>
											<div v-if="selectedRestartOdt.articulos && selectedRestartOdt.articulos.length" class="cp-restart-chip-list">
												<span v-for="article in selectedRestartOdt.articulos" :key="article.uid" class="cp-restart-chip cp-restart-chip--article">
													{{ article.label }}
												</span>
											</div>
											<div v-else class="cp-detail-empty cp-detail-empty--compact">Sin artículos para mostrar.</div>
										</section>
									</div>

									<section class="cp-restart-meta-card cp-restart-chart-card">
										<div class="cp-restart-meta-title">Paros por causa / subcausa</div>
										<div v-if="selectedRestartOdt.paros && selectedRestartOdt.paros.length" class="cp-restart-chart-wrap">
											<apexchart
												type="pie"
												:height="restartParosPieHeight"
												:options="restartParosPieOptions"
												:series="restartParosPieSeries"
											/>
										</div>
										<div v-else class="cp-detail-empty cp-detail-empty--compact">Sin paros para graficar.</div>
									</section>
								</div>
							</div>
							<div v-else class="cp-detail-empty">Sin ODTs para mostrar.</div>
						</v-card-text>
						<v-card-actions>
							<v-btn color="purple" dark @click="goBackToRestartMachines">Volver a máquinas</v-btn>
							<v-spacer />
							<v-btn text color="primary" @click="dialogs.restartDetail = false">Cerrar</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

		</div>
	</v-container>
</template>

<script>
import CountDownSearch from "../../CountDownSearch.vue";
import LoaderData from "../../LoaderData.vue";
import axios from "axios";

export default {
	components: {
		CountDownSearch,
		LoaderData,
	},
	props: {
		active: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		const currentYear = new Date().getFullYear();
		return {
			isLoading: false,
			errorCumplimiento: false,
			consultaData: true,
			cuentaPausada: false,
			yaConsultado: false,
			bootstrapped: false,
			selectedMainGanttView: "tiempoReal",
			mainGanttMachineLimit: 0,
			mainGanttMachineCustomLimit: null,
				showMainGanttTable: true,
						dialogs: {
							combinedFragment: false,
							active: false,
							stopped: false,
							idle: false,
						restarts: false,
						restartDetail: false,
					},
					selectedCombinedFragment: {
						machineModel: "-",
						lane: "-",
					fragmentType: "-",
					fragmentSubtype: "-",
					odt: "-",
					startMs: 0,
					endMs: 0,
						durationSec: 0,
						operationDetailRows: [],
					},
					selectedRestartMachine: {
						uid: "",
						machineName: "-",
						machineDisplay: "-",
						totalReinicios: 0,
						odts: [],
					},
					restartSortDirection: "desc",
					restartDetailTab: 0,
				cardCounters: {
					active: 0,
					withProgram: 0,
				stopped: 0,
				stoppedWithPieces: 0,
				noActivity: 0,
				idle: 0,
				restarts: 0,
				total: 0,
			},
			cardDetails: {
				active: [],
				stopped: [],
				noActivity: [],
				idle: [],
				restarts: [],
				piecesWithoutOdt: [],
			},
			summaryCards: [
				{
					key: "active",
					title: "Maquinas activas",
					primaryValue: "0",
					secondaryValue: "",
					caption: "",
					icon: "mdi-cog-outline",
					tone: "blue",
				},
				// {
				// 	key: "idle",
				// 	title: "Máquinas sin orden de trabajo activa",
				// 	primaryValue: "0",
				// 	secondaryValue: "",
				// 	caption: "",
				// 	icon: "mdi-speedometer",
				// 	tone: "slate",
				// },
				// {
				// 	key: "stopped",
				// 	title: "Maquinas en paro",
				// 	primaryValue: "0",
				// 	secondaryValue: "",
				// 	caption: "",
				// 	icon: "mdi-alert-outline",
				// 	tone: "amber",
				// },
			],
			programmedMachineRows: [],
			programmedGanttBars: [],
			realMachineRows: [],
			realWeekGanttBars: [],
			combinedUnifiedBars: [],
			expandedProgrammedRows: [],
			expandedRealRows: [],
			programmedWeekYear: currentYear,
			programmedWeekNumber: 0,
			programmedWeekEndpoint: "/MaquinaInstancias/GrafoProgramado",
				programmedWeekLastQuery: {
					startApi: "",
					endApi: "",
				},
				isWeekDialogLoading: false,
				weekDialogError: false,
			isFullscreenReporte: false,
			dateNow: null,
			fechaFinJornada: null,
		};
	},
	computed: {
		gamemode() {
			return localStorage.getItem("gamemode") === "true";
		},
		showInitialLoading() {
			return this.isLoading && !this.yaConsultado;
		},
		showReloadingBar() {
			return this.isLoading && this.yaConsultado;
		},
			loaderResponse() {
				if (!this.yaConsultado) return [];
				return {
					summaryCards: this.summaryCards,
				};
			},
			sortedRestartDetails() {
				const rows = this.toArray(this.cardDetails.restarts).slice();
				return rows.sort((a, b) => {
					const countA = this.getRestartCount(a);
					const countB = this.getRestartCount(b);
					if (countA !== countB) {
						return this.restartSortDirection === "asc"
							? countA - countB
							: countB - countA;
					}
					return `${a?.machineDisplay || ""}`.localeCompare(`${b?.machineDisplay || ""}`);
				});
			},
			selectedRestartOdt() {
				const odts = this.toArray(this.selectedRestartMachine.odts);
				if (!odts.length) {
					return {
						uid: "",
						odtId: 0,
						odtKey: "",
						odtLabel: "-",
						totalReinicios: 0,
						moldes: [],
						articulos: [],
						paros: [],
					};
				}
				const index = Math.min(Math.max(this.toNumber(this.restartDetailTab), 0), odts.length - 1);
				return odts[index] || odts[0];
			},
			restartParoCauseGroups() {
				const groups = new Map();
				this.toArray(this.selectedRestartOdt?.paros).forEach((paro, index) => {
					const causeName = `${paro?.typeName || ""}`.trim();
					const subCauseName = `${paro?.subTypeName || ""}`.trim();
					const causeLabel = causeName || "Sin causa";
					const subCauseLabel = subCauseName;
					const label = subCauseLabel ? `${causeLabel} / ${subCauseLabel}` : causeLabel;
					const key = label || `Paro ${index + 1}`;
					const seconds = this.toNumber(paro?.durationSec);
					const count = this.toNumber(paro?.count);
					const current = groups.get(key) || {
						label: key,
						totalSeconds: 0,
						totalCount: 0,
						parosCount: 0,
					};
					current.totalSeconds += seconds;
					current.totalCount += count;
					current.parosCount += 1;
					groups.set(key, current);
				});
				return Array.from(groups.values()).sort((a, b) => {
					if (b.totalSeconds !== a.totalSeconds) return b.totalSeconds - a.totalSeconds;
					return `${a.label}`.localeCompare(`${b.label}`);
				});
			},
			restartParosPieSeries() {
				return this.restartParoCauseGroups.map((group) => group.totalSeconds);
			},
			restartParosPieHeight() {
				const count = this.restartParoCauseGroups.length;
				return Math.max(320, count * 36 + 240);
			},
			restartParosPieOptions() {
				const vm = this;
				const labels = this.restartParoCauseGroups.map((group) => group.label);
				return {
					chart: {
						type: "pie",
						fontFamily: "Montserrat, Segoe UI, sans-serif",
						toolbar: {
							show: false,
						},
					},
					labels,
					colors: [
						"#1b8f6a",
						"#2f80d6",
						"#f0ac22",
						"#8e6cff",
						"#e56b6f",
						"#20c997",
						"#5c7cfa",
						"#f59f00",
					],
					legend: {
						position: "bottom",
						fontSize: "12px",
						fontFamily: "Montserrat, Segoe UI, sans-serif",
						markers: {
							width: 10,
							height: 10,
							radius: 999,
						},
					},
					dataLabels: {
						enabled: true,
						formatter(value, opts) {
							const totalSeconds = vm.toNumber(opts?.w?.config?.series?.[opts?.seriesIndex]);
							return vm.formatHoursMinutes(totalSeconds);
						},
						style: {
							fontSize: "11px",
							colors: ["#2a3f5d"],
						},
					},
					tooltip: {
						custom({ dataPointIndex }) {
							const group = vm.restartParoCauseGroups[dataPointIndex] || {};
							return `<div style="padding:8px 10px;font-size:12px;">
								<div><b>${group?.label || "-"}</b></div>
								<div><b>Duración:</b> ${vm.formatHoursMinutes(group?.totalSeconds)}</div>
								<div><b>Paros:</b> ${vm.formatNumber(group?.parosCount)}</div>
								<div><b>Cantidad:</b> ${vm.formatNumber(group?.totalCount)}</div>
							</div>`;
						},
					},
					noData: {
						text: "Sin datos",
					},
				};
			},
			programmedTableHeaders() {
			return [
				{ text: "", value: "visibility", align: "center", sortable: false, width: 56 },
				{ text: "Máquina", value: "machineLabel", sortable: false },
				{ text: "Tiempo de holgura", value: "slackSec", sortable: false },
				{ text: "Tiempo ODTs solapadas", value: "overlapSec", sortable: false },
				{ text: "Tiempo de producción esperada", value: "productionSec", sortable: false },
				{ text: "", value: "data-table-expand", align: "center", sortable: false, width: 56 },
			];
		},
		programmedVisibleMachineKeys() {
			return new Set(
				this.programmedMachineRows
					.filter((row) => row?.visible !== false)
					.map((row) => `${row?.machineKey || ""}`)
					.filter(Boolean)
			);
		},
		programmedVisibleOdtKeys() {
			const keys = new Set();
			this.programmedMachineRows
				.filter((row) => row?.visible !== false)
				.forEach((row) => {
					this.toArray(row?.details).forEach((detail) => {
						if (detail?.visible === false) return;
						const key = `${detail?.visibilityKey || ""}`;
						if (key) keys.add(key);
					});
				});
			return keys;
		},
		programmedVisibleGanttBarsRaw() {
			if (!this.programmedVisibleMachineKeys.size) return [];
			return this.programmedGanttBars.filter((item) => {
				const machineKey = `${item?.machineKey || ""}`;
				if (!this.programmedVisibleMachineKeys.has(machineKey)) return false;
				const odtVisibilityKey = `${item?.odtVisibilityKey || ""}`;
				if (!odtVisibilityKey) return true;
				return this.programmedVisibleOdtKeys.has(odtVisibilityKey);
			});
		},
		filteredProgrammedGanttBars() {
			return this.orderAndLimitMainGanttBars(this.programmedVisibleGanttBarsRaw);
		},
		programmedGanttMachineTotal() {
			const keys = new Set(
				this.programmedVisibleGanttBarsRaw.map((item, index) =>
					this.getMainGanttBarMachineKey(item, index)
				)
			);
			return keys.size;
		},
		programmedGanttMachineCount() {
			const names = new Set(this.filteredProgrammedGanttBars.map((item) => `${item.x || ""}`));
			return names.size;
		},
		programmedGanttHeight() {
			return Math.max(220, this.programmedGanttMachineCount * 56 + 60);
		},
		programmedGanttSeries() {
			return [
				{
					name: "Programado",
					data: this.filteredProgrammedGanttBars,
				},
			];
		},
			programmedGanttOptions() {
				const vm = this;
				return {
					chart: {
						type: "rangeBar",
						fontFamily: "Montserrat, Segoe UI, sans-serif",
						toolbar: {
							show: false,
							tools: {
								selection: false,
								zoom: false,
								zoomin: false,
								zoomout: false,
								pan: false,
								reset: false,
							},
						},
						selection: { enabled: false },
						zoom: { enabled: false },
					},
				plotOptions: {
					bar: {
						horizontal: true,
						rangeBarGroupRows: true,
						barHeight: "62%",
						borderRadius: 5,
					},
				},
				grid: {
					borderColor: "#e1e9f4",
					strokeDashArray: 4,
				},
				xaxis: {
					type: "datetime",
					labels: {
						datetimeUTC: false,
						style: {
							colors: "#4a5e7a",
							fontSize: "11px",
						},
					},
				},
				yaxis: {
					labels: {
						style: {
							colors: "#2a3f5d",
							fontWeight: 600,
							fontSize: "12px",
						},
					},
				},
					dataLabels: { enabled: false },
				tooltip: {
					custom({ seriesIndex, dataPointIndex, w }) {
						const point = w.config.series?.[seriesIndex]?.data?.[dataPointIndex] || {};
						const startMs = vm.toNumber(point?.y?.[0]);
						const endMs = vm.toNumber(point?.y?.[1]);
						const durationSec = endMs > startMs ? Math.round((endMs - startMs) / 1000) : 0;
						const areaSummary = `${point?.areaSummary || "-"}`.trim() || "-";
						const moldSummary = `${point?.moldSummary || "-"}`.trim() || "-";
						const articleSummary = `${point?.articleSummary || "-"}`.trim() || "-";
						const fragmentType = `${point?.fragmentType || "-"}`.trim() || "-";
						const areaHtml = vm.formatTooltipSummaryHtml(areaSummary, point?.areaItems);
						const moldHtml = vm.formatTooltipSummaryHtml(moldSummary, point?.moldItems);
						const articleHtml = vm.formatTooltipSummaryHtml(articleSummary, point?.articleItems);
						const operationsCount = vm.toNumber(point?.operationsCount);
						const tcDisplay = `${point?.tcDisplay || "-"}`.trim() || "-";
						const piecesToProduce = vm.toNumber(point?.piecesToProduce);
						const piecesExpected = vm.toNumber(point?.piecesExpected);
						const hasOperations = operationsCount > 0;
						return `<div style="padding:8px 10px;font-size:12px;">
							<div><b>${point?.x || "-"}</b></div>
							<div><b>ODT:</b> ${point?.odtLabel || "-"}</div>
							<div><b>Tramo:</b> ${point?.dayLabel || "-"}</div>
							<div><b>Tipo:</b> ${fragmentType}</div>
							<div><b>Area:</b> ${areaHtml}</div>
							<div><b>Molde:</b> ${moldHtml}</div>
							<div><b>Articulo:</b> ${articleHtml}</div>
							<div><b>Operaciones:</b> ${hasOperations ? vm.formatNumber(operationsCount) : "-"}</div>
							<div><b>TC:</b> ${tcDisplay}</div>
							<div><b>Piezas a producir:</b> ${hasOperations ? vm.formatNumber(piecesToProduce) : "-"}</div>
							<div><b>Piezas esperadas:</b> ${hasOperations ? vm.formatNumber(piecesExpected) : "-"}</div>
							<div><b>Inicio:</b> ${vm.formatDateTime(startMs)}</div>
							<div><b>Fin:</b> ${vm.formatDateTime(endMs)}</div>
							<div><b>Duracion:</b> ${vm.formatDuration(durationSec)}</div>
						</div>`;
					},
				},
				legend: { show: false },
				noData: {
					text: "Sin datos",
				},
			};
		},
		realTableHeaders() {
			return [
				{ text: "", value: "visibility", align: "center", sortable: false, width: 56 },
				{ text: "Máquina", value: "machineLabel", sortable: false },
				{ text: "Tiempo desplazado", value: "shiftedSec", sortable: false },
				// { text: "Tiempo de error", value: "errorSec", sortable: false },
				{ text: "Tiempo de desfase", value: "delaySec", sortable: false },
				{ text: "Tiempo de producción", value: "advanceSec", sortable: false },
				{ text: "", value: "data-table-expand", align: "center", sortable: false, width: 56 },
			];
		},
		realVisibleMachineKeys() {
			return new Set(
				this.realMachineRows
					.filter((row) => row?.visible !== false)
					.map((row) => `${row?.machineKey || ""}`)
					.filter(Boolean)
			);
		},
		realVisibleWeekGanttBarsRaw() {
			if (!this.realVisibleMachineKeys.size) return [];
			return this.realWeekGanttBars.filter((item) => this.realVisibleMachineKeys.has(`${item?.machineKey || ""}`));
		},
		filteredRealWeekGanttBars() {
			return this.orderAndLimitMainGanttBars(this.realVisibleWeekGanttBarsRaw);
		},
		realWeekGanttMachineTotal() {
			const keys = new Set(
				this.realVisibleWeekGanttBarsRaw.map((item, index) =>
					this.getMainGanttBarMachineKey(item, index)
				)
			);
			return keys.size;
		},
		filteredCombinedUnifiedBars() {
			return this.orderAndLimitCombinedUnifiedBars(this.combinedUnifiedBars);
		},
		combinedUnifiedMachineTotal() {
			const keys = new Set(
				this.combinedUnifiedBars
					.filter((item) => item?.isSpacer !== true)
					.map((item, index) => this.getMainGanttBarMachineKey(item, index))
			);
			return keys.size;
		},
			mainGanttMachineLimitOptions() {
				const total = Math.max(
					this.programmedGanttMachineTotal,
					this.realWeekGanttMachineTotal,
					this.combinedUnifiedMachineTotal
				);
				if (total <= 0) return [];
				const base = [5, 10, 15, 20, 25, 30, 40, 50];
				const options = base.filter((value) => value > 0 && value < total);
				if (!options.includes(total)) options.push(total);
			return options;
		},
		mainGanttMachineEffectiveLimit() {
			const customLimit = Math.max(0, Math.round(this.toNumber(this.mainGanttMachineCustomLimit)));
			if (customLimit > 0) return customLimit;
			const selectedLimit = Math.max(0, Math.round(this.toNumber(this.mainGanttMachineLimit)));
			return selectedLimit > 0 ? selectedLimit : 0;
		},
		programmedWeekYearOptions() {
			const nowYear = new Date().getFullYear();
			return [nowYear - 2, nowYear - 1, nowYear, nowYear + 1];
		},
			programmedWeekOptions() {
				const year = Math.max(2000, Math.round(this.toNumber(this.programmedWeekYear)));
				const totalWeeks = this.getIsoWeeksInYear(year);
				const nowWeek = this.getIsoWeekInfo(new Date());
				return Array.from({ length: totalWeeks }, (_row, index) => {
				const weekNumber = index + 1;
				const range = this.getIsoWeekRange(year, weekNumber);
				const isCurrent = nowWeek.isoYear === year && nowWeek.isoWeek === weekNumber;
				return {
					value: weekNumber,
					isCurrent,
						label: `Semana ${String(weekNumber).padStart(2, "0")} (${range.startLabel} - ${range.endLabel})${isCurrent ? " (en curso)" : ""}`,
					};
				});
			},
			realWeekGanttMachineCount() {
			const names = new Set(this.filteredRealWeekGanttBars.map((item) => `${item.x || ""}`));
			return names.size;
		},
		realWeekGanttHeight() {
			return Math.max(220, this.realWeekGanttMachineCount * 56 + 60);
		},
		realWeekGanttSeries() {
			return [
				{
					name: "Real",
					data: this.filteredRealWeekGanttBars,
				},
			];
		},
		combinedUnifiedMachineCount() {
			const names = new Set(this.filteredCombinedUnifiedBars.map((item) => `${item.x || ""}`));
			return names.size;
		},
		combinedUnifiedGanttHeight() {
			return Math.max(300, this.combinedUnifiedMachineCount * 34 + 72);
		},
		combinedUnifiedGanttSeries() {
			return [
				{
					name: "Gantt combinado",
					data: this.filteredCombinedUnifiedBars,
				},
			];
		},
			combinedUnifiedGanttOptions() {
				const vm = this;
				const nowMarkerMs = this.toTimeMs(this.dateNow) > 0 ? this.toTimeMs(this.dateNow) : Date.now();
				const endShiftMs = this.toTimeMs(this.fechaFinJornada);
				const xAxisAnnotations = [
					{
						x: nowMarkerMs,
						borderColor: "#d64545",
						strokeDashArray: 4,
						label: {
							text: "Ahora",
							position: "top",
							orientation: "horizontal",
							offsetY: -10,
							style: {
								background: "#d64545",
								color: "#ffffff",
								fontSize: "10px",
								fontWeight: 700,
							},
						},
					},
				];
				if (endShiftMs > 0) {
					xAxisAnnotations.push({
						x: endShiftMs,
						borderColor: "#1f78d1",
						borderWidth: 4,
						strokeDashArray: 0,
						label: {
							text: "Fin Jornada",
							position: "top",
							orientation: "horizontal",
							offsetY: -28,
							style: {
								background: "#1f78d1",
								color: "#ffffff",
								fontSize: "10px",
								fontWeight: 700,
							},
						},
					});
				}
				return {
					chart: {
						type: "rangeBar",
						fontFamily: "Montserrat, Segoe UI, sans-serif",
						events: {
							dataPointSelection(_event, _chartContext, config) {
								vm.openCombinedFragmentDialogFromChart(config);
							},
						},
						toolbar: {
							show: false,
						tools: {
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false,
						},
					},
					selection: { enabled: false },
					zoom: { enabled: false },
				},
					plotOptions: {
						bar: {
							horizontal: true,
							rangeBarGroupRows: true,
							barHeight: "94%",
							borderRadius: 4,
						},
					},
					grid: {
						borderColor: "#e1e9f4",
						strokeDashArray: 4,
						padding: {
							top: 32,
						},
						yaxis: {
							lines: {
								show: false,
						},
					},
				},
				xaxis: {
					type: "datetime",
					labels: {
						datetimeUTC: false,
						style: {
							colors: "#4a5e7a",
							fontSize: "11px",
						},
					},
				},
					yaxis: {
						labels: {
							formatter(value) {
								const text = `${value || ""}`;
								if (text.startsWith("__gap__")) return "";
								return text;
							},
							style: {
								colors: "#2a3f5d",
								fontWeight: 700,
							fontSize: "12px",
						},
					},
				},
					dataLabels: {
						enabled: true,
						formatter(_value, opts) {
							const point = opts?.w?.config?.series?.[opts?.seriesIndex]?.data?.[opts?.dataPointIndex] || {};
							if (point?.isSpacer || point?.isTiempoMuerto) return "";
							const lane = `${point?.lane || ""}`.trim().toLowerCase();
							if (lane !== "real ajustado") return "";
							const odt = `${point?.odt || ""}`.trim();
							if (!odt || odt.toLowerCase() === "sin odt") return "";
							const moldRaw = `${point?.moldLabel || ""}`.trim();
							const moldCode = moldRaw
								? `${moldRaw}`.split(" / ")[0].split(" - ")[0].trim()
								: "";
							const piecesExpected = vm.toNumber(point?.piecesExpected);
							const piecesDone = vm.toNumber(point?.piecesOk);
							const piecesLabel = `${vm.formatNumber(piecesDone)} / ${vm.formatNumber(piecesExpected)}`;
							return moldCode ? `${moldCode} ${piecesLabel}` : piecesLabel;
						},
						style: {
							colors: ["#374151"],
							fontSize: "10px",
							fontWeight: 700,
						},
						background: {
							enabled: true,
							opacity: 1,
							borderRadius: 0,
							padding: 2,
							foreColor: "#ffffff",
						},
					},
					annotations: {
						xaxis: xAxisAnnotations,
					},
					stroke: {
						show: true,
						width: 1,
						colors: ["transparent"],
					},
					tooltip: {
					custom({ seriesIndex, dataPointIndex, w }) {
						const point = w.config.series?.[seriesIndex]?.data?.[dataPointIndex] || {};
						if (point?.isSpacer) return "";
						const startMs = vm.toNumber(point?.y?.[0]);
						const endMs = vm.toNumber(point?.y?.[1]);
						const durationSec = endMs > startMs ? Math.round((endMs - startMs) / 1000) : 0;
							if (Boolean(point?.isTiempoMuerto)) {
								return `<div style="padding:8px 10px;font-size:12px;">
										<div><b>${point?.machineModel || "-"}</b></div>
										<div><b>Inicio:</b> ${vm.formatDateTime(startMs)}</div>
										<div><b>Fin:</b> ${vm.formatDateTime(endMs)}</div>
										<div><b>Duración:</b> ${vm.formatDurationHoursOnly(durationSec)}</div>
									</div>`;
							}
						const areaHtml = vm.formatTooltipSummaryHtml(point?.areaLabel, point?.areaItems);
						const articleHtml = vm.formatTooltipSummaryHtml(point?.articleLabel, point?.articleItems);
						const moldHtml = vm.formatTooltipSummaryHtml(point?.moldLabel, point?.moldItems);
						const operationPieceRowsHtml = vm.formatOperationPieceRowsTooltipHtml(point?.operationPieceRows);
						const articleTcRowsHtml = vm.formatArticleTcRowsTooltipHtml(point?.articleTcItems);
							return `<div style="padding:8px 10px;font-size:12px;">
									<div><b>${point?.machineModel || "-"}</b></div>
									<div><b>ODT:</b> ${point?.odt || "-"}</div>
									<div><b>Área:</b> ${areaHtml}</div>
								<div><b>Artículo:</b> ${articleHtml}</div>
								<div><b>Molde:</b> ${moldHtml}</div>
								${operationPieceRowsHtml}
								${articleTcRowsHtml}
								<div><b>Inicio:</b> ${vm.formatDateTime(startMs)}</div>
								<div><b>Fin:</b> ${vm.formatDateTime(endMs)}</div>
								<div><b>Duración:</b> ${vm.formatDurationHoursOnly(durationSec)}</div>
							</div>`;
					},
				},
				legend: { show: false },
				noData: { text: "Sin datos" },
			};
		},
		realWeekGanttOptions() {
			const vm = this;
			const nowMarkerMs = vm.toTimeMs(vm.dateNow) > 0 ? vm.toTimeMs(vm.dateNow) : Date.now();
			return {
				chart: {
					type: "rangeBar",
					fontFamily: "Montserrat, Segoe UI, sans-serif",
					toolbar: {
						show: false,
						tools: {
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false,
						},
					},
					selection: { enabled: false },
					zoom: { enabled: false },
				},
				plotOptions: {
					bar: {
						horizontal: true,
						rangeBarGroupRows: true,
						barHeight: "62%",
						borderRadius: 5,
					},
				},
				colors: ["#1b8f6a"],
				grid: {
					borderColor: "#e1e9f4",
					strokeDashArray: 4,
				},
				xaxis: {
					type: "datetime",
					labels: {
						datetimeUTC: false,
						style: {
							colors: "#4a5e7a",
							fontSize: "11px",
						},
					},
				},
				yaxis: {
					labels: {
						style: {
							colors: "#2a3f5d",
							fontWeight: 600,
							fontSize: "12px",
						},
					},
				},
				dataLabels: { enabled: false },
				tooltip: {
					custom({ seriesIndex, dataPointIndex, w }) {
						const point = w.config.series?.[seriesIndex]?.data?.[dataPointIndex] || {};
						const startMs = vm.toNumber(point?.y?.[0]);
						const endMs = vm.toNumber(point?.y?.[1]);
						const durationSec = endMs > startMs ? Math.round((endMs - startMs) / 1000) : 0;
						const piecesExpected = vm.toNumber(point?.piecesExpected);
						const piecesDone = vm.toNumber(point?.piecesDone);
						const sameSeries = vm.toArray(w?.config?.series?.[seriesIndex]?.data);
						const sameMachineAndOdt = sameSeries.filter((item) =>
							`${item?.x || ""}` === `${point?.x || ""}` &&
							`${item?.odtLabel || ""}` === `${point?.odtLabel || ""}`
						);
						const odtPiecesDone = sameMachineAndOdt.reduce((maxDone, item) => {
							return Math.max(maxDone, vm.toNumber(item?.piecesDone));
						}, 0);
						const shouldUseOdtFallback = `${point?.timeType || ""}` === "Producción";
						const piecesDoneDisplay =
							piecesDone > 0 ? piecesDone : shouldUseOdtFallback ? odtPiecesDone : 0;
						const cavitiesCount = vm.toNumber(point?.cavitiesCount);
						const tcDisplay = `${point?.tcDisplay || "-"}`.trim() || "-";
						const articles = `${point?.articlesSummary || "-"}`.trim() || "-";
						const molds = `${point?.moldsSummary || "-"}`.trim() || "-";
						const articlesHtml = vm.formatTooltipSummaryHtml(articles, point?.articleItems);
						const moldsHtml = vm.formatTooltipSummaryHtml(molds, point?.moldItems);
						const articleTcRowsHtml = vm.formatArticleTcRowsTooltipHtml(point?.articleTcItems);
						const expectedLabel = piecesExpected > 0 ? vm.formatNumber(piecesExpected) : "-";
						const doneLabel = piecesDoneDisplay > 0 ? vm.formatNumber(piecesDoneDisplay) : "-";
						return `<div style="padding:8px 10px;font-size:12px;">
								<div><b>${point?.x || "-"}</b></div>
								<div><b>Tipo:</b> ${point?.timeType || "-"}</div>
								<div><b>ODT:</b> ${point?.odtLabel || "-"}</div>
							<div><b>Artículos:</b> ${articlesHtml}</div>
							${articleTcRowsHtml}
							<div><b>Moldes:</b> ${moldsHtml}</div>
							<div><b>Cavidades:</b> ${cavitiesCount > 0 ? vm.formatNumber(cavitiesCount) : "-"}</div>
							<div><b>TC:</b> ${tcDisplay}</div>
							<div><b>Piezas esperadas:</b> ${expectedLabel}</div>
							<div><b>Piezas hechas:</b> ${doneLabel}</div>
							<div><b>Inicio:</b> ${vm.formatDateTime(startMs)}</div>
							<div><b>Fin:</b> ${vm.formatDateTime(endMs)}</div>
							<div><b>Duración:</b> ${vm.formatDuration(durationSec)}</div>
						</div>`;
					},
				},
				annotations: {
					xaxis: [
						{
							x: nowMarkerMs,
							borderColor: "#d64545",
							strokeDashArray: 3,
							label: {
								text: "Ahora",
								style: {
									background: "#d64545",
									color: "#ffffff",
									fontSize: "10px",
									fontWeight: 700,
								},
							},
						},
					],
				},
				legend: { show: false },
				noData: {
					text: "Sin datos",
				},
			};
		},
	},
	watch: {
		active(newValue) {
			if (newValue) this.ensureData(true);
		},
	},
	methods: {
		async initialize() {
			if (this.isLoading) return;

			this.isLoading = true;
			this.errorCumplimiento = false;
			try {
				const [estatusResult] = await Promise.allSettled([this.getMaquinasEstatus()]);

				if (estatusResult.status !== "fulfilled") {
					throw estatusResult.reason;
				}

				const payload = estatusResult.value;

				this.applyReporteData(payload && typeof payload === "object" ? payload : {});
				this.yaConsultado = true;
			} catch (error) {
				this.errorCumplimiento = true;
				console.error("Error en initialize:", error);
			} finally {
				this.isLoading = false;
			}
		},

		async toggleFullscreenReporte() {
			const el = this.$refs.fullscreenReporte;
			if (!el) return;

			const anyEl = el;
			const anyDoc = document;
			const isFullscreen = !!(
				document.fullscreenElement ||
				anyDoc.webkitFullscreenElement ||
				anyDoc.msFullscreenElement
			);

			if (!isFullscreen) {
				if (anyEl.requestFullscreen) return anyEl.requestFullscreen();
				if (anyEl.webkitRequestFullscreen) return anyEl.webkitRequestFullscreen();
				if (anyEl.msRequestFullscreen) return anyEl.msRequestFullscreen();
				return;
			}

			if (document.exitFullscreen) return document.exitFullscreen();
			if (anyDoc.webkitExitFullscreen) return anyDoc.webkitExitFullscreen();
			if (anyDoc.msExitFullscreen) return anyDoc.msExitFullscreen();
		},
		syncFullscreenReporte() {
			const anyDoc = document;
			const fullscreenElement =
				document.fullscreenElement ||
				anyDoc.webkitFullscreenElement ||
				anyDoc.msFullscreenElement;
			this.isFullscreenReporte = !!fullscreenElement && fullscreenElement === this.$refs.fullscreenReporte;
		},
			async ensureData(force = false) {
				if (this.isLoading) return;
				if (this.bootstrapped && !force) return;
				await this.initialize();
				this.bootstrapped = true;
			},
			openCombinedFragmentDialogFromChart(config) {
				const seriesIndex = this.toNumber(config?.seriesIndex);
				const dataPointIndex = this.toNumber(config?.dataPointIndex);
				const point = config?.w?.config?.series?.[seriesIndex]?.data?.[dataPointIndex];
				this.openCombinedFragmentDialog(point);
			},
			openCombinedFragmentDialog(point) {
				if (!point || point?.isSpacer) return;
				const startMs = this.toNumber(point?.y?.[0]);
				const endMs = this.toNumber(point?.y?.[1]);
				const durationSec = endMs > startMs ? Math.round((endMs - startMs) / 1000) : 0;
				this.selectedCombinedFragment = {
					machineModel: `${point?.machineModel || "-"}`.trim() || "-",
					lane: `${point?.lane || "-"}`.trim() || "-",
					fragmentType: `${point?.fragmentType || "-"}`.trim() || "-",
					fragmentSubtype: `${point?.fragmentSubtype || "-"}`.trim() || "-",
					odt: `${point?.odt || "-"}`.trim() || "-",
					startMs,
					endMs,
					durationSec,
					operationDetailRows: this.toArray(point?.operationDetailRows),
				};
				this.dialogs.combinedFragment = true;
			},
			async onProgrammedWeekSelectionChange() {
				if (this.isWeekDialogLoading) return;
				const year = Math.max(2000, Math.round(this.toNumber(this.programmedWeekYear)));
				const totalWeeks = this.getIsoWeeksInYear(year);
				let week = Math.max(1, Math.round(this.toNumber(this.programmedWeekNumber)));
				if (week > totalWeeks) week = totalWeeks;
				this.programmedWeekNumber = week;

				const range = this.getIsoWeekRange(year, week);
				const startApi = this.formatApiDateTime(range.startDate);
				const endApi = this.formatApiDateTime(range.endDate);
				this.programmedWeekLastQuery = {
					startApi,
					endApi,
				};
				this.weekDialogError = false;

				if (!this.programmedWeekEndpoint) return;

				this.isWeekDialogLoading = true;
				try {
					const response = await axios.get(this.programmedWeekEndpoint, {
						params: {
							FechaInicio: startApi,
							FechaFin: endApi,
						},
					});
					const payload = this.normalizeResponse(response);
					const grafoProgramado =
						payload?.grafoProgramado ||
						payload?.GrafoProgramado ||
						payload ||
						{};
					const source =
						grafoProgramado?.porMaquina || grafoProgramado?.PorMaquina
							? { grafoProgramado }
							: payload || {};
					const nextProgrammedMachineRows = this.buildProgrammedMachineRows(source);
					const nextProgrammedGanttBars = this.buildProgrammedGanttBars(source);
					this.programmedMachineRows = this.applyProgrammedOdtVisibilityPreference(
						this.applyMachineVisibilityPreference(
							nextProgrammedMachineRows,
							this.getProgrammedVisibilityStorageKey()
						)
					);
					this.programmedGanttBars = nextProgrammedGanttBars;
				} catch (error) {
					this.weekDialogError = true;
					console.error("Error consultando gantt teórico por semana:", error);
				} finally {
					this.isWeekDialogLoading = false;
				}
			},
		getIsoWeeksInYear(year) {
			const safeYear = Math.max(2000, Math.round(this.toNumber(year)));
			const dec28 = new Date(safeYear, 11, 28);
			return Math.max(1, this.getIsoWeekInfo(dec28).isoWeek);
		},
		getIsoWeekInfo(dateValue) {
			const date = new Date(dateValue || Date.now());
			date.setHours(0, 0, 0, 0);
			const dayIndex = (date.getDay() + 6) % 7; // 0 = lunes
			date.setDate(date.getDate() - dayIndex + 3); // jueves de la semana ISO
			const isoYear = date.getFullYear();
			const firstThursday = new Date(isoYear, 0, 4);
			const firstThursdayDay = (firstThursday.getDay() + 6) % 7;
			firstThursday.setDate(firstThursday.getDate() - firstThursdayDay + 3);
			const isoWeek = 1 + Math.round((date - firstThursday) / (7 * 24 * 60 * 60 * 1000));
			return { isoYear, isoWeek };
		},
		getIsoWeekRange(year, week) {
			const safeYear = Math.max(2000, Math.round(this.toNumber(year)));
			const safeWeek = Math.max(1, Math.round(this.toNumber(week)));
			const jan4 = new Date(safeYear, 0, 4);
			jan4.setHours(0, 0, 0, 0);
			const jan4Day = (jan4.getDay() + 6) % 7; // 0 = lunes
			const weekOneMonday = new Date(jan4);
			weekOneMonday.setDate(jan4.getDate() - jan4Day);

			const startDate = new Date(weekOneMonday);
			startDate.setDate(weekOneMonday.getDate() + (safeWeek - 1) * 7);
			startDate.setHours(0, 0, 0, 0);

			const endDate = new Date(startDate);
			endDate.setDate(startDate.getDate() + 6);
			endDate.setHours(23, 59, 59, 0);

			return {
				startDate,
				endDate,
				startLabel: this.formatWeekDate(startDate),
				endLabel: this.formatWeekDate(endDate),
			};
		},
		formatWeekDate(dateValue) {
			const date = new Date(dateValue || "");
			const ms = date.getTime();
			if (!Number.isFinite(ms)) return "-";
			const day = String(date.getDate()).padStart(2, "0");
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const year = date.getFullYear();
			return `${day}/${month}/${year}`;
		},
		formatApiDateTime(dateValue) {
			const date = new Date(dateValue || "");
			const ms = date.getTime();
			if (!Number.isFinite(ms)) return "";
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			const hour = String(date.getHours()).padStart(2, "0");
			const minute = String(date.getMinutes()).padStart(2, "0");
			const second = String(date.getSeconds()).padStart(2, "0");
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
		},
		toArray(value) {
			return Array.isArray(value) ? value : [];
		},
		toNumber(value) {
			const n = Number(value);
			return Number.isFinite(n) ? n : 0;
		},
		toTimeMs(value) {
			const raw = `${value || ""}`.trim();
			if (!raw) return 0;
			const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
			const ms = new Date(normalized).getTime();
			return Number.isFinite(ms) ? ms : 0;
		},
		toBool(value) {
			if (typeof value === "boolean") return value;
			if (typeof value === "number") return value === 1;
			if (typeof value === "string") {
				const normalized = value.trim().toLowerCase();
				return normalized === "true" || normalized === "1";
			}
			return false;
		},
		getMainGanttBarMachineKey(item, index = 0) {
			const machineKey = `${item?.machineKey || ""}`.trim();
			if (machineKey) return machineKey;
			const machineLabel = `${item?.x || ""}`.trim();
			if (machineLabel) return `machine-${machineLabel}`;
			return `machine-${index}`;
		},
		isCombinedUnifiedRealAdjustedItem(item) {
			return `${item?.lane || ""}`.trim().toLowerCase() === "real ajustado";
		},
		orderAndLimitMainGanttBars(items) {
			const source = this.toArray(items);
			if (!source.length) return [];
			const grouped = new Map();
			source.forEach((item, index) => {
				const machineKey = this.getMainGanttBarMachineKey(item, index);
				const label = `${item?.x || machineKey}`;
				const endMs = this.toNumber(item?.y?.[1]);
				const startMs = this.toNumber(item?.y?.[0]);
				if (!grouped.has(machineKey)) {
					grouped.set(machineKey, {
						key: machineKey,
						label,
						latestEndMs: endMs,
						workSec: 0,
					});
				}
				const bucket = grouped.get(machineKey);
				bucket.latestEndMs = Math.max(this.toNumber(bucket?.latestEndMs), endMs);
				bucket.workSec += Math.max(0, Math.round((endMs - startMs) / 1000));
			});

			const orderedMachines = Array.from(grouped.values()).sort((a, b) => {
				if (b.latestEndMs !== a.latestEndMs) return b.latestEndMs - a.latestEndMs;
				if (b.workSec !== a.workSec) return b.workSec - a.workSec;
				return `${a.label}`.localeCompare(`${b.label}`);
			});

			const rawLimit = this.toNumber(this.mainGanttMachineEffectiveLimit);
			const limit = rawLimit > 0 ? rawLimit : orderedMachines.length;
			const selectedMachines = orderedMachines.slice(0, Math.max(1, limit));
			const rankMap = new Map(selectedMachines.map((machine, rank) => [machine.key, rank]));
			const selectedKeys = new Set(rankMap.keys());

			return source
				.filter((item, index) => selectedKeys.has(this.getMainGanttBarMachineKey(item, index)))
				.sort((a, b) => {
					const keyA = this.getMainGanttBarMachineKey(a);
					const keyB = this.getMainGanttBarMachineKey(b);
					const rankA = this.toNumber(rankMap.get(keyA));
					const rankB = this.toNumber(rankMap.get(keyB));
					if (rankA !== rankB) return rankA - rankB;
					const startA = this.toNumber(a?.y?.[0]);
					const startB = this.toNumber(b?.y?.[0]);
					if (startA !== startB) return startA - startB;
					const endA = this.toNumber(a?.y?.[1]);
					const endB = this.toNumber(b?.y?.[1]);
					if (endA !== endB) return endA - endB;
					return `${a?.odtLabel || ""}`.localeCompare(`${b?.odtLabel || ""}`);
				});
		},
		orderAndLimitCombinedUnifiedBars(items) {
			const source = this.toArray(items);
			if (!source.length) return [];

			const grouped = new Map();
			source.forEach((item, index) => {
				const machineKey = this.getMainGanttBarMachineKey(item, index);
				const endMs = this.toNumber(item?.y?.[1]);
				const startMs = this.toNumber(item?.y?.[0]);
				if (!grouped.has(machineKey)) {
					grouped.set(machineKey, {
						key: machineKey,
						label: `${item?.machineModel || item?.x || machineKey}`,
						latestEndMs: 0,
						workSec: 0,
					});
				}
				if (item?.isSpacer === true || !this.isCombinedUnifiedRealAdjustedItem(item)) return;
				const bucket = grouped.get(machineKey);
				bucket.latestEndMs = Math.max(this.toNumber(bucket?.latestEndMs), endMs);
				bucket.workSec += Math.max(0, Math.round((endMs - startMs) / 1000));
			});

			const orderedMachines = Array.from(grouped.values()).sort((a, b) => {
				if (b.latestEndMs !== a.latestEndMs) return b.latestEndMs - a.latestEndMs;
				if (b.workSec !== a.workSec) return b.workSec - a.workSec;
				return `${a.label}`.localeCompare(`${b.label}`);
			});

			const rawLimit = this.toNumber(this.mainGanttMachineEffectiveLimit);
			const limit = rawLimit > 0 ? rawLimit : orderedMachines.length;
			const selectedMachines = orderedMachines.slice(0, Math.max(1, limit));
			const rankMap = new Map(selectedMachines.map((machine, rank) => [machine.key, rank]));
			const selectedKeys = new Set(rankMap.keys());

			return source
				.filter((item, index) => selectedKeys.has(this.getMainGanttBarMachineKey(item, index)))
				.sort((a, b) => {
					const keyA = this.getMainGanttBarMachineKey(a);
					const keyB = this.getMainGanttBarMachineKey(b);
					const rankA = this.toNumber(rankMap.get(keyA));
					const rankB = this.toNumber(rankMap.get(keyB));
					if (rankA !== rankB) return rankA - rankB;
					const rowOrderA = this.toNumber(a?.rowOrder);
					const rowOrderB = this.toNumber(b?.rowOrder);
					if (rowOrderA !== rowOrderB) return rowOrderA - rowOrderB;
					const startA = this.toNumber(a?.y?.[0]);
					const startB = this.toNumber(b?.y?.[0]);
					if (startA !== startB) return startA - startB;
					const endA = this.toNumber(a?.y?.[1]);
					const endB = this.toNumber(b?.y?.[1]);
					if (endA !== endB) return endA - endB;
					return `${a?.odt || ""}`.localeCompare(`${b?.odt || ""}`);
				});
		},
		shortText(text, max = 10) {
			const safe = `${text || ""}`.trim();
			return safe.length > max ? safe.slice(0, max) : safe;
		},
		getOdtLabel(odt, odtIndex = 0) {
			const odtKey = `${odt?.clave || odt?.Clave || ""}`.trim();
			if (odtKey) return odtKey;
			const odtId = this.toNumber(odt?.idTrabajoOrden ?? odt?.IdTrabajoOrden);
			return odtId > 0 ? `ODT ${odtId}` : `ODT ${odtIndex + 1}`;
		},
		getProgrammedFragmentTypeLabel(rawType) {
			const safeRaw = `${rawType || ""}`.trim();
			const normalized = safeRaw.toLowerCase();
			if (!normalized) return "Producción";
			if (normalized === "produccion") return "Producción";
			return safeRaw;
		},
		getProgrammedOdtColor(positionIndex = 0) {
			const palette = [
				"#2f80d6",
				"#1b8f6a",
				"#f0ac22",
				"#8b5cf6",
				"#d64545",
				"#0ea5a4",
				"#c2672a",
				"#4f46e5",
				"#16a34a",
				"#e11d48",
				"#0ea5e9",
				"#a16207",
			];
			const safeIndex = Math.max(0, Math.trunc(this.toNumber(positionIndex)));
			return palette[safeIndex % palette.length];
		},
		buildProgrammedSegmentVisibilityKey(machineKey, odt, startMs, endMs, segmentIndex = 0) {
			const odtLabel = this.getOdtLabel(odt, segmentIndex);
			return `${machineKey}|${odtLabel}|${this.toNumber(startMs)}|${this.toNumber(endMs)}`;
		},
			getOperationDisplayLabel(op, opIndex = 0) {
				const articleName = `${op?.nombreArticulo || op?.NombreArticulo || op?.articulo || op?.Articulo || ""}`.trim();
				if (articleName) return articleName;
				const operationId = this.toNumber(op?.idOperacion ?? op?.IdOperacion);
				return operationId > 0 ? `Op ${operationId}` : `Op ${opIndex + 1}`;
			},
		buildOperationDetailRows(operations) {
				const source = this.toArray(operations).map((op, opIndex) => {
					const detailsNoOk = this.toArray(op?.detallesNoOk || op?.DetallesNoOk);
					const noOkFromDetails = detailsNoOk.reduce(
						(sum, item) => sum + this.toNumber(item?.piezasReportadas ?? item?.PiezasReportadas),
						0
					);
					const operationId = this.toNumber(op?.idOperacion ?? op?.IdOperacion);
					const articleName = `${op?.nombreArticulo || op?.NombreArticulo || op?.articulo || op?.Articulo || ""}`.trim();
					const nestedArticle = op?.articuloObj || op?.ArticuloObj || op?.articuloData || op?.ArticuloData || op?.articuloInfo || op?.ArticuloInfo || op?.articuloRef || op?.ArticuloRef || {};
					const articleCode = `${op?.codigoArticulo || op?.CodigoArticulo || op?.claveArticulo || op?.ClaveArticulo || op?.codigoDeArticulo || op?.CodigoDeArticulo || op?.codigo || op?.Codigo || op?.clave || op?.Clave || nestedArticle?.codigo || nestedArticle?.Codigo || nestedArticle?.clave || nestedArticle?.Clave || ""}`.trim();
					const articleDisplay = articleCode
						? `[${articleCode}] ${articleName || `Artículo ${articleCode}`}`.trim()
						: articleName;
					const area = `${op?.area || op?.Area || ""}`.trim();
					const mold = `${op?.molde || op?.Molde || op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`.trim();
					const startMs = this.toTimeMs(op?.inicio || op?.Inicio);
					const endMs = this.toTimeMs(op?.fin || op?.Fin);
					const durationSecFromPayload = this.toNumber(op?.duracionSegundos ?? op?.DuracionSegundos);
					const durationSec = durationSecFromPayload > 0
						? durationSecFromPayload
						: endMs > startMs ? Math.round((endMs - startMs) / 1000) : 0;
					return {
						uid: `combined-op-${operationId || opIndex}-${startMs}-${endMs}`,
						operationId,
						operationLabel: operationId > 0 ? `Op ${operationId}` : `Op ${opIndex + 1}`,
						opIndex,
						articleName: articleDisplay,
						articleKey: articleName.toLowerCase(),
						area: area || "-",
						mold: mold || "-",
						tc: this.toNumber(op?.tc ?? op?.TC),
						piecesExpected: this.toNumber(
							op?.piezasEsperadas ??
							op?.PiezasEsperadas ??
							op?.piezasProducir ??
							op?.PiezasProducir
						),
						piecesOk: this.toNumber(
							op?.piezasOkHechas ??
							op?.PiezasOkHechas ??
							op?.piezasOk ??
							op?.PiezasOk
						),
						piecesNoOk: this.toNumber(
							op?.piezasNoOkHechas ??
							op?.PiezasNoOkHechas ??
							op?.piezasNoOk ??
							op?.PiezasNoOk
						) + noOkFromDetails,
						piecesTotal: this.toNumber(
							op?.piezasTotalesHechas ??
							op?.PiezasTotalesHechas ??
							op?.piezasTotales ??
							op?.PiezasTotales
						),
						startMs,
						endMs,
						durationSec,
					};
				});
				if (!source.length) return [];
				const uniqueArticles = Array.from(
					new Set(
						source
							.map((item) => item?.articleKey || "")
							.filter(Boolean)
					)
				);
				const hasArticleInAll = source.every((item) => Boolean(item?.articleKey));
				const useCavityLabel = source.length > 1 && hasArticleInAll && uniqueArticles.length === 1;
				return source.map((item, index) => ({
					...item,
					pieceLabel: useCavityLabel
						? `Cav ${index + 1}`
						: item?.articleName || item?.operationLabel || `Op ${item.opIndex + 1}`,
				}));
			},
		extractArticleCodeFromLabel(label) {
			const text = `${label || ""}`.trim();
			if (!text) return "";
			const match = text.match(/\[([^\]]+)\]/);
			return `${match?.[1] || ""}`.trim();
		},
		normalizeArticleLabel(label) {
			const text = `${label || ""}`.trim();
			return text
				.replace(/\[[^\]]+\]/g, "")
				.replace(/\s+/g, " ")
				.trim()
				.toLowerCase();
		},
		buildCombinedTheoreticalArticleCodeLookup(fragments) {
			const map = new Map();
			this.toArray(fragments).forEach((fragment) => {
				const odtLabelRaw = `${fragment?.nombreODT || fragment?.NombreODT || fragment?.clave || fragment?.Clave || fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
				const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
				const odtLabel = odtLabelRaw || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
				const rows = this.buildOperationDetailRows(fragment?.operaciones || fragment?.Operaciones);
				rows.forEach((row) => {
					const code = this.extractArticleCodeFromLabel(row?.articleName);
					if (!code) return;
					const opId = this.toNumber(row?.operationId);
					const normalized = this.normalizeArticleLabel(row?.articleName);
					if (opId > 0) map.set(`op|${odtLabel}|${opId}`, code);
					if (normalized) map.set(`name|${odtLabel}|${normalized}`, code);
				});
			});
			return map;
		},
		applyCombinedRealArticleCodeFallback(operationDetailRows, odtLabel, codeLookup) {
			const lookup = codeLookup instanceof Map ? codeLookup : new Map();
			return this.toArray(operationDetailRows).map((row) => {
				const current = `${row?.articleName || ""}`.trim();
				if (!current) return row;
				if (this.extractArticleCodeFromLabel(current)) return row;
				const opId = this.toNumber(row?.operationId);
				const normalized = this.normalizeArticleLabel(current);
				let code = "";
				if (opId > 0) code = `${lookup.get(`op|${odtLabel}|${opId}`) || ""}`.trim();
				if (!code && normalized) code = `${lookup.get(`name|${odtLabel}|${normalized}`) || ""}`.trim();
				if (!code) return row;
				return {
					...row,
					articleName: `[${code}] ${current}`.trim(),
				};
			});
		},
		buildOperationPieceRows(operations) {
			return this.buildOperationDetailRows(operations).map((item) => ({
					label: `${item?.pieceLabel || "-"}`.trim() || "-",
					piecesExpected: this.toNumber(item?.piecesExpected),
					piecesOk: this.toNumber(item?.piecesOk),
					piecesNoOk: this.toNumber(item?.piecesNoOk),
					tc: this.toNumber(item?.tc),
				}));
			},
		formatOperationPieceRowsTooltipHtml(operationPieceRows) {
			const rows = this.toArray(operationPieceRows);
			if (!rows.length) return "";
			return rows.map((row) => {
				const safeLabel = this.escapeHtml(`${row?.label || "-"}`.trim() || "-");
				const tc = this.toNumber(row?.tc);
				const tcLabel = tc > 0 ? this.formatNumber(tc) : "-";
				const expectedLabel = this.formatNumber(row?.piecesExpected);
				const okLabel = this.formatNumber(row?.piecesOk);
				const noOkLabel = this.formatNumber(row?.piecesNoOk);
				return `<div style="margin:4px 0 6px;padding:4px 6px;border-radius:6px;background:#f4f8fd;">
					<div><b>${safeLabel}</b> <span style="color:#5f7089;">(TC: ${tcLabel})</span></div>
					<div style="margin-top:2px;">
						<span style="color:#2e9d53;"><b>OK:</b> ${okLabel}</span>
						<span style="margin:0 8px;color:#8fa0b8;">|</span>
						<span style="color:#d64545;"><b>No OK:</b> ${noOkLabel}</span>
						<span style="margin:0 8px;color:#8fa0b8;">|</span>
						<span style="color:#334a68;"><b>Esperadas:</b> ${expectedLabel}</span>
					</div>
				</div>`;
			}).join("");
		},
		formatArticleTcRowsTooltipHtml(articleTcItems) {
			const rows = this.toArray(articleTcItems);
			if (!rows.length) return "";
			return rows.map((row) => {
				const article = this.escapeHtml(`${row?.article || "-"}`.trim() || "-");
				const tc = this.toNumber(row?.tc);
				const tcLabel = tc > 0 ? this.formatNumber(tc) : "-";
				return `<div><b>TC ${article}:</b> ${tcLabel}</div>`;
			}).join("");
		},
		getRealFragmentTypeLabel(rawType, options = {}) {
			const normalized = `${rawType || ""}`.trim().toLowerCase();
			const isDead = Boolean(options?.isDead);
			const isTheoretical = Boolean(options?.isTheoretical);
			if (isDead || normalized === "tiempomuerto" || normalized === "tiempo muerto") return "Tiempo muerto";
			if (isTheoretical) return "Producción teórica";
			if (
				normalized === "cambio de molde y ajuste de procesos" ||
				normalized.includes("cambio de molde")
			) {
				return "Cambio de Molde y ajuste de procesos";
			}
			if (normalized === "retraso") return "Retraso";
			if (normalized === "extra" || normalized === "desfase") return "Extra";
			if (normalized === "produccion" || normalized === "odt") return "Producción";
			if (!normalized) return options?.isRed ? "Retraso" : "Producción";
			return `${rawType}`.trim() || "Producción";
		},
		resolveCombinedUnifiedFragmentState(fragment) {
			const rawType = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim();
			const rawSubtype = `${fragment?.subtipoFragmento || fragment?.SubtipoFragmento || ""}`.trim();
			const tipo = rawType.toLowerCase();
			const subtipo = rawSubtype.toLowerCase();
			const isTiempoMuerto =
				this.toBool(fragment?.tiempoMuerto ?? fragment?.TiempoMuerto) ||
				this.toBool(fragment?.esTiempoMuerto ?? fragment?.EsTiempoMuerto) ||
				tipo === "tiempomuerto" ||
				tipo === "tiempo muerto";
			const isInoperante =
				this.toBool(fragment?.inoperante ?? fragment?.Inoperante) ||
				tipo === "en espera de actividad" ||
				tipo.startsWith("en espera de actividad ") ||
				tipo === "espera de actividad" ||
				tipo.startsWith("espera de actividad ") ||
				tipo === "inoperante" ||
				tipo.startsWith("inoperante ") ||
				tipo === "paro" ||
				tipo.startsWith("paro ");
			const isCambioMolde =
				this.toBool(fragment?.cambioMolde ?? fragment?.CambioMolde) ||
				tipo === "cambio de molde" ||
				tipo.includes("cambio de molde");
			const isAjusteProcesos =
				this.toBool(fragment?.ajusteProcesos ?? fragment?.AjusteProcesos) ||
				tipo === "ajuste de procesos" ||
				tipo.includes("ajuste de procesos");
			const isMoldeAjuste =
				this.toBool(fragment?.moldeAjuste ?? fragment?.MoldeAjuste) ||
				isCambioMolde ||
				isAjusteProcesos;
			const isProduccion =
				this.toBool(fragment?.produccion ?? fragment?.Produccion) ||
				tipo === "produccion";
			const isExtra =
				this.toBool(fragment?.extra ?? fragment?.Extra) ||
				tipo === "extra" ||
				tipo === "desfase";
			const isReanudable =
				this.toBool(fragment?.reanudable ?? fragment?.Reanudable) ||
				tipo === "reanudable" ||
				tipo.startsWith("reanudable ") ||
				subtipo === "reanudable" ||
				subtipo.startsWith("reanudable ");
			const isRetraso =
				this.toBool(fragment?.esRetraso ?? fragment?.EsRetraso) ||
				this.toBool(fragment?.retraso ?? fragment?.Retraso) ||
				tipo === "retraso";
			let typeLabel = rawType;
			if (isRetraso) {
				typeLabel = "Extra";
			} else if (!typeLabel) {
				if (isTiempoMuerto) typeLabel = "Tiempo muerto";
				else if (isInoperante) typeLabel = "En espera de actividad";
				else if (isExtra) typeLabel = "Extra";
				else if (isReanudable) typeLabel = rawSubtype || "Reanudable";
				else if (isCambioMolde && isAjusteProcesos) typeLabel = "Cambio de Molde y ajuste de procesos";
				else if (isCambioMolde) typeLabel = "Cambio de Molde";
				else if (isAjusteProcesos) typeLabel = "Ajuste de procesos";
				else if (isMoldeAjuste) typeLabel = "Cambio de Molde y ajuste de procesos";
				else if (isProduccion) typeLabel = "Produccion";
				else typeLabel = "Produccion";
			}
			return {
				typeLabel,
				isTiempoMuerto,
				isInoperante,
				isMoldeAjuste,
				isCambioMolde,
				isAjusteProcesos,
				isProduccion,
				isExtra,
				isReanudable,
				isRetraso,
				isRed: this.toBool(fragment?.esRojo ?? fragment?.EsRojo),
			};
		},
		getCombinedFragmentOdtKey(fragment, fallbackIndex = 0) {
			const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
			const odtName = `${fragment?.nombreODT || fragment?.NombreODT || fragment?.claveODT || fragment?.ClaveODT || fragment?.clave || fragment?.Clave || ""}`.trim();
			if (odtId <= 0 && !odtName) return "";
			return `${odtId > 0 ? odtId : 0}|${odtName || `ODT-${fallbackIndex + 1}`}`;
		},
		getCombinedOperationActivityStartMs(operation) {
			const op = operation && typeof operation === "object" ? operation : {};
			let minMs = Number.MAX_SAFE_INTEGER;
			const pushCandidate = (value) => {
				const ms = this.toTimeMs(value);
				if (ms > 0) minMs = Math.min(minMs, ms);
			};

			const directFields = [
				"inicioReal",
				"InicioReal",
				"inicio",
				"Inicio",
				"fechaInicioProduccion",
				"FechaInicioProduccion",
				"fechaInicio",
				"FechaInicio",
				"inicioPrimerParo",
				"InicioPrimerParo",
				"fechaInicioPrimerParo",
				"FechaInicioPrimerParo",
				"fechaPrimeraPieza",
				"FechaPrimeraPieza",
				"fechaPrimeraPiezaNoOk",
				"FechaPrimeraPiezaNoOk",
			];
			directFields.forEach((field) => pushCandidate(op?.[field]));

			const opDate = op?.fecha || op?.Fecha;
			const opTime = op?.hora || op?.Hora || op?.horaInicio || op?.HoraInicio;
			if (opDate && opTime) pushCandidate(`${opDate} ${opTime}`);

			const eventCollectionFields = [
				"paros",
				"Paros",
				"piezas",
				"Piezas",
				"piezasNoOk",
				"PiezasNoOk",
				"piezasNoOK",
				"PiezasNoOK",
				"eventos",
				"Eventos",
			];
			const eventTimeFields = [
				"inicio",
				"Inicio",
				"fechaInicio",
				"FechaInicio",
				"fechaHora",
				"FechaHora",
				"fechaRegistro",
				"FechaRegistro",
				"timestamp",
				"Timestamp",
				"fecha",
				"Fecha",
			];
			eventCollectionFields.forEach((field) => {
				this.toArray(op?.[field]).forEach((event) => {
					eventTimeFields.forEach((eventField) => pushCandidate(event?.[eventField]));
					const eventDate = event?.fecha || event?.Fecha;
					const eventTime = event?.hora || event?.Hora || event?.horaInicio || event?.HoraInicio;
					if (eventDate && eventTime) pushCandidate(`${eventDate} ${eventTime}`);
				});
			});

			return Number.isFinite(minMs) && minMs < Number.MAX_SAFE_INTEGER ? minMs : 0;
		},
		resolveCombinedFragmentStartMs(fragment) {
			const baseStartMs = this.toTimeMs(
				fragment?.inicio ||
				fragment?.Inicio ||
				fragment?.inicioReal ||
				fragment?.InicioReal ||
				fragment?.fechaInicioProduccion ||
				fragment?.FechaInicioProduccion
			);
			const operationStartMs = this.toArray(fragment?.operaciones || fragment?.Operaciones).reduce(
				(minValue, operation) => {
					const activityStartMs = this.getCombinedOperationActivityStartMs(operation);
					if (activityStartMs <= 0) return minValue;
					return Math.min(minValue, activityStartMs);
				},
				Number.MAX_SAFE_INTEGER
			);
			let resolvedStartMs = baseStartMs > 0 ? baseStartMs : 0;
			if (Number.isFinite(operationStartMs) && operationStartMs < Number.MAX_SAFE_INTEGER) {
				resolvedStartMs = resolvedStartMs > 0
					? Math.min(resolvedStartMs, operationStartMs)
					: operationStartMs;
			}
			return resolvedStartMs;
		},
		buildCombinedAdjustedRealLaneFragments(machine) {
			const adjustedSource = this.toArray(
				machine?.fragmentosRealesAjustados || machine?.FragmentosRealesAjustados
			);

			const normalizeSegments = (fragments) => this.toArray(fragments)
				.map((fragment, index) => {
					const startMs = this.resolveCombinedFragmentStartMs(fragment);
					const endMs = this.toTimeMs(
						fragment?.fin ||
						fragment?.Fin ||
						fragment?.finReal ||
						fragment?.FinReal ||
						fragment?.fechaFinProduccion ||
						fragment?.FechaFinProduccion
					);
					if (startMs <= 0 || endMs <= startMs) return null;
					const state = this.resolveCombinedUnifiedFragmentState(fragment);
					const rawType = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim().toLowerCase();
					const rawSubtype = `${fragment?.subtipoFragmento || fragment?.SubtipoFragmento || ""}`.trim().toLowerCase();
					const isProductionLike =
						Boolean(state?.isProduccion) ||
						rawType === "produccion" ||
						rawSubtype === "produccion";
					return {
						fragment: { ...(fragment || {}) },
						index,
						startMs,
						endMs,
						state,
						isDead: Boolean(state?.isTiempoMuerto),
						isProductionLike,
						odtKey: this.getCombinedFragmentOdtKey(fragment, index),
					};
				})
				.filter(Boolean)
				.sort((a, b) => {
					if (a.startMs !== b.startMs) return a.startMs - b.startMs;
					if (a.endMs !== b.endMs) return a.endMs - b.endMs;
					return this.toNumber(a?.index) - this.toNumber(b?.index);
				});

				const adjustedSegments = normalizeSegments(adjustedSource);
				if (!adjustedSegments.length) return [];
				const finalSegments = adjustedSegments.map((segment) => ({
					...segment,
					fragment: { ...(segment?.fragment || {}) },
				}));

			const uniqueSegments = [];
			const seen = new Set();
			finalSegments
				.filter((segment) => this.toNumber(segment?.startMs) > 0 && this.toNumber(segment?.endMs) > this.toNumber(segment?.startMs))
				.sort((a, b) => {
					if (a.startMs !== b.startMs) return a.startMs - b.startMs;
					if (a.endMs !== b.endMs) return a.endMs - b.endMs;
					return `${a?.odtKey || ""}`.localeCompare(`${b?.odtKey || ""}`);
				})
				.forEach((segment) => {
					const segmentKey = [
						`${segment?.odtKey || ""}`.trim(),
						`${segment?.state?.typeLabel || segment?.fragment?.tipoFragmento || ""}`.trim(),
						this.toNumber(segment?.startMs),
						this.toNumber(segment?.endMs),
						`${segment?.fragment?.subtipoFragmento || segment?.fragment?.SubtipoFragmento || ""}`.trim(),
					].join("|");
					if (seen.has(segmentKey)) return;
					seen.add(segmentKey);
					uniqueSegments.push(segment);
				});

			return uniqueSegments.map((segment) => {
				const startMs = this.toNumber(segment?.startMs);
				const endMs = this.toNumber(segment?.endMs);
				const durationSec = Math.max(0, Math.round((endMs - startMs) / 1000));
				const fragment = { ...(segment?.fragment || {}) };
				const startIso = new Date(startMs).toISOString();
				const endIso = new Date(endMs).toISOString();
				fragment.inicio = startIso;
				fragment.Inicio = startIso;
				fragment.fin = endIso;
				fragment.Fin = endIso;
				fragment.duracionSegundos = durationSec;
				fragment.DuracionSegundos = durationSec;
				return fragment;
			});
		},
		getCombinedUnifiedFragmentColor(fragmentState) {
			if (fragmentState?.isTiempoMuerto) return "#ffffff";
			if (fragmentState?.isRetraso || fragmentState?.isInoperante || fragmentState?.isExtra) return "#d64545";
			if (fragmentState?.isReanudable) return "#8b5e3c";
			if (fragmentState?.isMoldeAjuste) return "#63b46a";
			return "#63b46a";
		},
		getCombinedUnifiedDesfaseBand(piecesExpected, piecesMissing) {
			const expected = this.toNumber(piecesExpected);
			const missing = this.toNumber(piecesMissing);
			if (expected <= 0 || missing <= 0) return "";
			const percent = (missing / expected) * 100;
			if (percent >= 1 && percent <= 10) return "1%-10% desfase";
			if (percent > 10 && percent <= 15) return "10%-15% desfase";
			return "";
		},
		getCombinedUnifiedFragmentVisual(fragmentState, piecesExpected, piecesMissingByOdt) {
			if (fragmentState?.isTiempoMuerto) return { fillColor: "#ffffff", typeLabel: "Tiempo muerto" };
			if (fragmentState?.isReanudable) return { fillColor: "#8b5e3c", typeLabel: fragmentState?.typeLabel || "Reanudable" };
			if (fragmentState?.isRetraso || fragmentState?.isInoperante || fragmentState?.isExtra) {
				const desfaseBand = this.getCombinedUnifiedDesfaseBand(piecesExpected, piecesMissingByOdt);
				if (desfaseBand === "1%-10% desfase") return { fillColor: "#f0ac22", typeLabel: desfaseBand };
				if (desfaseBand === "10%-15% desfase") return { fillColor: "#e67e22", typeLabel: desfaseBand };
				return { fillColor: "#d64545", typeLabel: fragmentState?.typeLabel || "Extra" };
			}
			if (fragmentState?.isMoldeAjuste) return { fillColor: "#63b46a", typeLabel: fragmentState?.typeLabel || "Producción" };
			return { fillColor: "#63b46a", typeLabel: fragmentState?.typeLabel || "Producción" };
		},
		getRealAdjustedColorFragmentoVisual(colorFragmentoRaw, fallbackTypeLabel = "Producción") {
			const color = `${colorFragmentoRaw || ""}`.trim().toLowerCase();
			if (color === "verde") return { fillColor: "#63b46a", typeLabel: "Producción" };
			if (color === "amarillo" || color === "marillo") return { fillColor: "#f0ac22", typeLabel: "1%-10% desfase" };
			if (color === "rojo") return { fillColor: "#d64545", typeLabel: "10%-15% desfase" };
			return { fillColor: "#63b46a", typeLabel: `${fallbackTypeLabel || "Producción"}`.trim() || "Producción" };
		},
			buildCombinedUnifiedGanttBars(data) {
				const ganttTiempoReal = data?.ganttTiempoReal || data?.GanttTiempoReal || {};
				const machines = this.toArray(
					ganttTiempoReal?.porMaquina ||
					ganttTiempoReal?.PorMaquina ||
					data?.porMaquina ||
					data?.PorMaquina
				);
				if (!machines.length) return [];

						const orderedMachines = machines
							.map((machine, index) => {
								const machineModelCode = `${machine?.modeloMaquina || machine?.ModeloMaquina || ""}`.trim();
								const model = machineModelCode || `Maq ${index + 1}`;
								const adjustedRealFragments = this.buildCombinedAdjustedRealLaneFragments(machine);
								const fechaFinJornadaMs = this.toTimeMs(this.fechaFinJornada);
							const maxAdjustedRealEnd = adjustedRealFragments.reduce((maxValue, fragment) => {
								return Math.max(maxValue, this.toTimeMs(fragment?.fin || fragment?.Fin));
							}, 0);
						const adjustedRealWorkSec = adjustedRealFragments.reduce((sum, fragment) => {
							const startMs = this.toTimeMs(fragment?.inicio || fragment?.Inicio);
							const endMs = this.toTimeMs(fragment?.fin || fragment?.Fin);
							if (startMs <= 0 || endMs <= startMs) return sum;
							return sum + Math.max(0, Math.round((endMs - startMs) / 1000));
						}, 0);
						const forceRealAdjustedRed =
							fechaFinJornadaMs > 0 &&
							adjustedRealFragments.some((fragment) => {
								const endMs = this.toTimeMs(fragment?.fin || fragment?.Fin);
								return endMs > fechaFinJornadaMs;
							});
							return {
								machine,
								model,
								index,
								adjustedRealFragments,
								forceRealAdjustedRed,
								maxEnd: maxAdjustedRealEnd,
								workSec: adjustedRealWorkSec,
							};
						})
					.sort((a, b) => {
						if (b.maxEnd !== a.maxEnd) return b.maxEnd - a.maxEnd;
						if (b.workSec !== a.workSec) return b.workSec - a.workSec;
						return `${a.model}`.localeCompare(`${b.model}`);
					});

					const globalMinStart = orderedMachines.reduce((minValue, item) => {
						const theorics = this.toArray(item?.machine?.fragmentosTeoricos || item?.machine?.FragmentosTeoricos);
						const adjustedTheorics = this.toArray(
							item?.machine?.fragmentosTeoricosAjustados || item?.machine?.FragmentosTeoricosAjustados
						);
						const reals = this.toArray(item?.machine?.fragmentosReales || item?.machine?.FragmentosReales);
						const adjustedReals = this.toArray(
							item?.machine?.fragmentosRealesAjustados || item?.machine?.FragmentosRealesAjustados
						);
						const fragments = [...theorics, ...adjustedTheorics, ...reals, ...adjustedReals];
						const localMin = fragments.reduce((innerMin, fragment) => {
							const startMs = this.toTimeMs(fragment?.inicio || fragment?.Inicio);
							if (startMs <= 0) return innerMin;
						return Math.min(innerMin, startMs);
					}, Number.MAX_SAFE_INTEGER);
					return Math.min(minValue, localMin);
				}, Number.MAX_SAFE_INTEGER);
				const gapStartMs = Number.isFinite(globalMinStart) && globalMinStart > 0 ? globalMinStart : Date.now();

				const bars = [];
				orderedMachines.forEach((item, machineOrder) => {
					const machine = item.machine;
					const machineModel = `${item.model}`;
					const machineId = this.toNumber(machine?.idMaquina ?? machine?.IdMaquina);
					const machineKey = machineId > 0 ? `${machineId}` : `${machineOrder + 1}`;
					const theoreticalCodeLookup = this.buildCombinedTheoreticalArticleCodeLookup(
						machine?.fragmentosTeoricosAjustados || machine?.FragmentosTeoricosAjustados
					);

					const pushLaneBars = (fragmentsInput, lane, rowOrder) => {
						const fragments = this.toArray(fragmentsInput)
							.map((fragment, fragmentIndex) => ({ fragment, fragmentIndex }))
							.sort((a, b) => {
								const aStart = this.toTimeMs(a?.fragment?.inicio || a?.fragment?.Inicio);
								const bStart = this.toTimeMs(b?.fragment?.inicio || b?.fragment?.Inicio);
								if (aStart !== bStart) return aStart - bStart;
								return this.toTimeMs(a?.fragment?.fin || a?.fragment?.Fin) - this.toTimeMs(b?.fragment?.fin || b?.fragment?.Fin);
							});

						fragments.forEach(({ fragment, fragmentIndex }) => {
							const startMs = this.toTimeMs(fragment?.inicio || fragment?.Inicio);
							const endMs = this.toTimeMs(fragment?.fin || fragment?.Fin);
							if (startMs <= 0 || endMs <= startMs) return;

							const fragmentState = this.resolveCombinedUnifiedFragmentState(fragment);
							const isRealAdjustedLane = `${lane}`.toLowerCase() === "real ajustado";
							const fragmentSubtype = `${fragment?.subtipoFragmento || fragment?.SubtipoFragmento || "-"}`.trim() || "-";
							const operations = this.toArray(fragment?.operaciones || fragment?.Operaciones);
							const odtLabelRaw = `${fragment?.nombreODT || fragment?.NombreODT || fragment?.clave || fragment?.Clave || fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
							const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
							const odtLabel = odtLabelRaw || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
							let operationDetailRows = this.buildOperationDetailRows(operations);
							if (isRealAdjustedLane) {
								operationDetailRows = this.applyCombinedRealArticleCodeFallback(
									operationDetailRows,
									odtLabel,
									theoreticalCodeLookup
								);
							}
							const piecesExpected = operationDetailRows.reduce((sum, op) => sum + this.toNumber(op?.piecesExpected), 0);
							const piecesOk = operationDetailRows.reduce((sum, op) => sum + this.toNumber(op?.piecesOk), 0);
							const piecesNoOk = operationDetailRows.reduce((sum, op) => sum + this.toNumber(op?.piecesNoOk), 0);
							const operationPieceRows = operationDetailRows.map((op) => ({
								label: `${op?.pieceLabel || "-"}`.trim() || "-",
								piecesExpected: this.toNumber(op?.piecesExpected),
								piecesOk: this.toNumber(op?.piecesOk),
								piecesNoOk: this.toNumber(op?.piecesNoOk),
								tc: this.toNumber(op?.tc),
							}));
							const articleTcItems = operationDetailRows.map((op) => ({
								article: `${op?.articleName || op?.pieceLabel || "-"}`.trim() || "-",
								tc: this.toNumber(op?.tc),
							}));
							const piecesMissingByOdt = operationDetailRows.reduce((sum, op) => {
								const expected = this.toNumber(op?.piecesExpected);
								const ok = this.toNumber(op?.piecesOk);
								return sum + Math.max(0, expected - ok);
							}, 0);
							const fragmentVisual = this.getCombinedUnifiedFragmentVisual(
								fragmentState,
								piecesExpected,
								piecesMissingByOdt
							);
							const realAdjustedFragmentVisual = isRealAdjustedLane
								? this.getRealAdjustedColorFragmentoVisual(
									fragment?.colorFragmento || fragment?.ColorFragmento,
									fragmentVisual?.typeLabel
								)
								: null;
							const articleItems = Array.from(
								new Set(
									operationDetailRows
										.map((op) => `${op?.articleName || ""}`.trim())
										.filter(Boolean)
								)
							);
							const fragmentArticle = `${fragment?.articulo || fragment?.Articulo || ""}`.trim();
							if (!articleItems.length && fragmentArticle) articleItems.push(fragmentArticle);
							const moldItems = Array.from(
								new Set(
									operationDetailRows
										.map((op) => `${op?.mold || ""}`.trim())
										.filter(Boolean)
								)
							);
							const fragmentMold = `${fragment?.molde || fragment?.Molde || ""}`.trim();
							if (!moldItems.length && fragmentMold) moldItems.push(fragmentMold);
							const areaItems = Array.from(
								new Set(
									operationDetailRows
										.map((op) => `${op?.area || ""}`.trim())
										.filter(Boolean)
								)
							);
							const fragmentArea = `${fragment?.area || fragment?.Area || ""}`.trim();
							if (!areaItems.length && fragmentArea) areaItems.push(fragmentArea);
								bars.push({
									uid: `combined-main-${machineKey}-${lane}-${fragmentIndex}`,
									x: `${machineModel} - ${lane}`,
									y: [startMs, endMs],
								machineKey,
								rowOrder,
								machineModel,
								lane,
								isSpacer: false,
								isTiempoMuerto: fragmentState.isTiempoMuerto,
								fragmentType: isRealAdjustedLane && !fragmentState?.isTiempoMuerto
									? realAdjustedFragmentVisual?.typeLabel
									: fragmentVisual.typeLabel,
								fragmentSubtype,
								odt: odtLabel,
								areaLabel: areaItems.length === 1 ? areaItems[0] : areaItems.length > 1 ? "Multiples" : "-",
								areaItems,
								articleLabel: articleItems.length === 1 ? articleItems[0] : articleItems.length > 1 ? "Multiples" : "-",
								articleItems,
								moldLabel: moldItems.length === 1 ? moldItems[0] : moldItems.length > 1 ? "Multiples" : "-",
								moldItems,
								operationsCount: operations.length,
								piecesExpected,
								piecesOk,
								piecesNoOk,
								piecesMissingByOdt,
								operationPieceRows,
								articleTcItems,
								operationDetailRows,
								fillColor:
									isRealAdjustedLane && item?.forceRealAdjustedRed && !fragmentState?.isTiempoMuerto
										? "#d64545"
										: (isRealAdjustedLane && !fragmentState?.isTiempoMuerto
											? realAdjustedFragmentVisual?.fillColor
											: fragmentVisual.fillColor),
								strokeColor: fragmentState.isTiempoMuerto ? "#d4dee8" : "transparent",
							});
						});
					};

						pushLaneBars(
							machine?.fragmentosTeoricosAjustados || machine?.FragmentosTeoricosAjustados,
							"Teorico Ajustado",
							1
						);
						const adjustedRealFragments = this.toArray(item?.adjustedRealFragments);
						if (adjustedRealFragments.length) {
							pushLaneBars(adjustedRealFragments, "Real Ajustado", 2);
					}

					const isLastMachine = machineOrder === orderedMachines.length - 1;
					if (!isLastMachine) {
						bars.push({
							uid: `combined-main-gap-${machineKey}`,
							x: `__gap__${machineKey}`,
							y: [gapStartMs, gapStartMs + 1],
							machineKey,
							rowOrder: 3,
							machineModel,
							lane: "Gap",
							isSpacer: true,
							fillColor: "rgba(0,0,0,0)",
							strokeColor: "transparent",
						});
					}
				});

				return this.removeTrailingDeadTimeRows(bars);
			},
		getTcDisplay(tcValues, fallbackTc = 0) {
			const values = this.toArray(tcValues)
				.map((value) => this.toNumber(value))
				.filter((value) => value > 0);
			const safeFallback = this.toNumber(fallbackTc);
			if (!values.length && safeFallback > 0) values.push(safeFallback);
			const uniqueValues = Array.from(new Set(values.map((value) => Number(value.toFixed(4)))));
			if (!uniqueValues.length) return "-";
			if (uniqueValues.length === 1) return this.formatNumber(uniqueValues[0]);
			return `[${uniqueValues.map((value) => this.formatNumber(value)).join(" / ")}]`;
		},
		removeTrailingDeadTimeRows(rows) {
			const source = this.toArray(rows);
			if (!source.length) return source;
			const isDeadTimeRow = (row) => {
				if (!row || row?.isSpacer === true) return false;
				if (this.toBool(row?.isTiempoMuerto ?? row?.esTiempoMuerto)) return true;
				const rawType = `${row?.timeType || row?.fragmentType || row?.tipoFragmento || ""}`
					.trim()
					.toLowerCase();
				return rawType === "tiempo muerto" || rawType === "tiempomuerto";
			};
			const grouped = new Map();
			source.forEach((row, index) => {
				const machineKey = `${row?.machineKey || row?.x || "machine-unknown"}`;
				const lane = `${row?.lane || ""}`.trim();
				// En el gantt combinado, evaluar el "último tramo" por línea (Teorico/Real),
				// no por máquina completa, para ocultar correctamente el tiempo muerto final.
				const groupKey = lane && lane.toLowerCase() !== "gap"
					? `${machineKey}|${lane}`
					: machineKey;
				if (!grouped.has(groupKey)) grouped.set(groupKey, []);
				grouped.get(groupKey).push({ row, index });
			});

			const removeIndexes = new Set();
			grouped.forEach((items) => {
				if (!items.length) return;
				const validItems = items.filter((item) => item?.row?.isSpacer !== true);
				if (!validItems.length) return;
				// Si toda la linea/carril es tiempo muerto, mantenerla visible.
				// Solo recortar tiempo muerto final cuando tambien exista trabajo real.
				const hasAnyNonDead = validItems.some((item) => !isDeadTimeRow(item?.row));
				if (!hasAnyNonDead) return;
				const maxEnd = Math.max(
					...validItems.map((item) => this.toNumber(item?.row?.y?.[1]))
				);
				if (maxEnd <= 0) return;
				const maxEndRows = validItems.filter((item) => this.toNumber(item?.row?.y?.[1]) === maxEnd);
				const hasNonDeadAtEnd = maxEndRows.some(
					(item) => !isDeadTimeRow(item?.row)
				);
				if (hasNonDeadAtEnd) return;
				maxEndRows.forEach((item) => {
					if (isDeadTimeRow(item?.row)) removeIndexes.add(item.index);
				});
			});

			if (!removeIndexes.size) return source;
			return source.filter((_row, index) => !removeIndexes.has(index));
		},
			formatDateTime(value) {
				const ms = this.toNumber(value);
				if (ms <= 0) return "-";
				return new Date(ms).toLocaleString("es-MX", {
					year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
					hour12: false,
				});
			},
			formatDateTimeWithWeekday(value) {
				const ms = this.toNumber(value);
				if (ms <= 0) return "-";
				const weekday = new Date(ms).toLocaleDateString("es-MX", {
					weekday: "long",
				});
				const weekdayLabel = `${weekday || ""}`
					.trim()
					.replace(/^\w/, (char) => char.toUpperCase());
				const dateTimeLabel = this.formatDateTime(ms);
				return weekdayLabel ? `${weekdayLabel} ${dateTimeLabel}` : dateTimeLabel;
			},
			getRestartCount(source) {
				if (!source || typeof source !== "object") return 0;
				if (source.totalReinicios !== undefined && source.totalReinicios !== null) {
					return this.toNumber(source.totalReinicios);
				}
				if (source.TotalReinicios !== undefined && source.TotalReinicios !== null) {
					return this.toNumber(source.TotalReinicios);
				}
				return 0;
			},
			normalizeResponse(response) {
				const payload = response?.data;
				return payload?.Data || payload?.data || payload?.Result || payload?.result || payload || null;
			},
		buildFechaConsultaQuery() {
			const value = `${this.dateNow ?? ""}`.trim();
			return value ? `?fechaConsulta=${encodeURIComponent(value)}` : "";
		},
		getDataArray(data, keys) {
			for (const key of keys) {
				const rows = data?.[key];
				if (Array.isArray(rows)) return rows;
			}
			return [];
		},
		getRowArray(row, keys) {
			for (const key of keys) {
				const rows = row?.[key];
				if (Array.isArray(rows)) return rows;
			}
			return [];
		},
		buildMachineCatalog(data) {
			const map = new Map();
			const ganttEsperado = data?.ganttEsperado || data?.GanttEsperado || {};
			const ganttReal = data?.ganttReal || data?.GanttReal || {};
			const genDos = this.getDataArray(data, ["genDos", "GenDos"]);
			const allMachines = [
				...this.getDataArray(data, ["maquinasEnUso", "MaquinasEnUso"]),
				...this.getDataArray(data, ["maquinasSinUso", "MaquinasSinUso"]),
				...this.getDataArray(data, [
					"maquinasConParoEnCurso",
					"MaquinasConParoEnCurso",
					"maquinasConparoEnCurso",
					"MaquinasConparoEnCurso",
					"maquinasConParoEnCursoConPiezas",
					"MaquinasConParoEnCursoConPiezas",
					"maquinasConParoEnCursoSinPiezas",
					"MaquinasConParoEnCursoSinPiezas",
				]),
				...this.getDataArray(data, ["detallesPorMaquina", "DetallesPorMaquina"]),
				...this.toArray(ganttEsperado?.porMaquina || ganttEsperado?.PorMaquina),
				...this.toArray(ganttReal?.porMaquina || ganttReal?.PorMaquina),
				...genDos,
			];

			allMachines.forEach((machine) => {
				const id = this.toNumber(
					machine?.IdMaquinaIns ??
					machine?.idMaquinaIns ??
					machine?.idMaquina ??
					machine?.IdMaquina
				);
				if (id > 0 && !map.has(id)) {
					map.set(id, {
						...machine,
						nombre:
							machine?.nombre ||
							machine?.Nombre ||
							machine?.nombreMaquina ||
							machine?.NombreMaquina ||
							`Maq ${id}`,
						modelo:
							machine?.modelo ||
							machine?.Modelo ||
							machine?.modeloMaquina ||
							machine?.ModeloMaquina ||
							"-",
					});
				}
			});

			return map;
		},
		buildUniqueCount(rows) {
			const ids = new Set();
			this.toArray(rows).forEach((row) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				if (id > 0) ids.add(id);
			});
			return ids.size;
		},
		buildMachineIdSet(rows) {
			const ids = new Set();
			this.toArray(rows).forEach((row) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				if (id > 0) ids.add(id);
			});
			return ids;
		},
		buildProductionPiecesByMachine(data) {
			const piecesMap = new Map();
			const detailsByMachine = this.getDataArray(data, ["detallesPorMaquina", "DetallesPorMaquina"]);
			if (detailsByMachine.length) {
				detailsByMachine.forEach((machineRow) => {
					const id = this.toNumber(machineRow?.idMaquinaIns ?? machineRow?.IdMaquinaIns);
					if (id <= 0) return;
					const odts = this.toArray(machineRow?.odTs || machineRow?.ODTs || machineRow?.odts);
					const pieces = odts.reduce((sum, odt) => {
						return sum + this.toNumber(odt?.totalPiezas ?? odt?.TotalPiezas);
					}, 0);
					piecesMap.set(id, pieces);
				});
				return piecesMap;
			}

			this.getDataArray(data, ["operacionesConActividad", "OperacionesConActividad"]).forEach((op) => {
				const id = this.toNumber(op?.IdMaquinaIns ?? op?.idMaquinaIns);
				if (id <= 0) return;
				const pieces = this.toNumber(op?.PiezasHechas ?? op?.piezasHechas);
				piecesMap.set(id, (piecesMap.get(id) || 0) + pieces);
			});
			return piecesMap;
		},
		buildActivityPresenceIds(data, piecesByMachine) {
			const ids = new Set();
			const detailsByMachine = this.getDataArray(data, ["detallesPorMaquina", "DetallesPorMaquina"]);
			if (detailsByMachine.length) {
				detailsByMachine.forEach((machineRow) => {
					const id = this.toNumber(machineRow?.idMaquinaIns ?? machineRow?.IdMaquinaIns);
					if (id > 0) ids.add(id);
				});
				return ids;
			}

			this.getDataArray(data, ["operacionesConActividad", "OperacionesConActividad"]).forEach((op) => {
				const id = this.toNumber(op?.IdMaquinaIns ?? op?.idMaquinaIns);
				if (id > 0) ids.add(id);
			});

			if (!ids.size) {
				piecesByMachine.forEach((_pieces, id) => {
					if (id > 0) ids.add(id);
				});
			}
			return ids;
		},
		buildMachineRowsByIds(ids, catalog) {
			return Array.from(ids)
				.filter((id) => id > 0)
				.map((id) => {
					const row = catalog.get(id);
					if (row) return row;
					return {
						idMaquinaIns: id,
						nombre: `Maq ${id}`,
						area: "-",
						marca: "-",
						modelo: "-",
					};
				});
		},
		buildMachineDetails(rows) {
			const unique = new Map();
			const pushUnique = (target, value) => {
				const text = `${value || "-"}`.trim();
				if (!text || text === "-" || text.toLowerCase() === "null") return;
				if (!target.includes(text)) target.push(text);
			};
			const mergeUniqueList = (base, incoming) => {
				const next = this.toArray(base).slice();
				this.toArray(incoming).forEach((value) => pushUnique(next, value));
				return next;
			};
			const getOdtList = (row) => {
				const values = [];
				const appendOdt = (clave, id) => {
					const key = `${clave || ""}`.trim();
					const odtId = this.toNumber(id);
					if (key && odtId > 0) {
						pushUnique(values, `${key} (ODT ${this.formatNumber(odtId)})`);
						return;
					}
					if (key) {
						pushUnique(values, key);
						return;
					}
					if (odtId > 0) {
						pushUnique(values, `ODT ${this.formatNumber(odtId)}`);
					}
				};

				appendOdt(
					row?.claveODT ?? row?.ClaveODT ?? row?.claveOdt ?? row?.ClaveOdt,
					row?.idTrabajoOrden ?? row?.IdTrabajoOrden
				);

				this.toArray(row?.trabajoOrdenesActivas || row?.TrabajoOrdenesActivas).forEach((odt) => {
					appendOdt(
						odt?.claveODT ?? odt?.ClaveODT ?? odt?.claveOdt ?? odt?.ClaveOdt,
						odt?.idTrabajoOrden ?? odt?.IdTrabajoOrden
					);
				});

				this.toArray(row?.operacionesActivas || row?.OperacionesActivas).forEach((op) => {
					appendOdt(
						op?.claveODT ?? op?.ClaveODT ?? op?.claveOdt ?? op?.ClaveOdt,
						op?.idTrabajoOrden ?? op?.IdTrabajoOrden
					);
				});

				return values;
			};
			const getMoldList = (row) => {
				const values = [];
				const appendMold = (moldValue, moldId) => {
					const mold = `${moldValue || ""}`.trim();
					const id = this.toNumber(moldId);
					if (mold && mold !== "-" && mold.toLowerCase() !== "s/d") {
						pushUnique(values, mold);
						return;
					}
					if (id > 0) pushUnique(values, `Molde ${this.formatNumber(id)}`);
				};

				appendMold(row?.molde ?? row?.Molde, row?.idMolde ?? row?.IdMolde);

				this.toArray(row?.moldesActivos || row?.MoldesActivos).forEach((mold) => {
					appendMold(mold?.claveMolde ?? mold?.ClaveMolde, mold?.idMolde ?? mold?.IdMolde);
				});

				this.toArray(row?.operacionesActivas || row?.OperacionesActivas).forEach((op) => {
					appendMold(
						op?.claveMolde ?? op?.ClaveMolde ?? op?.molde ?? op?.Molde,
						op?.idMolde ?? op?.IdMolde
					);
				});

				return values;
			};
			const getOperationArticleList = (row) => {
				const values = [];
				const appendArticle = (articleValue, operationId) => {
					const article = `${articleValue || ""}`.trim();
					const opId = this.toNumber(operationId);
					if (!article || article === "-" || article.toLowerCase() === "null") return;
					if (opId > 0) {
						pushUnique(values, `${article} (Op ${this.formatNumber(opId)})`);
						return;
					}
					pushUnique(values, article);
				};

				this.toArray(row?.operacionesActivas || row?.OperacionesActivas).forEach((op) => {
					appendArticle(
						op?.articulo ?? op?.Articulo ?? op?.nombreArticulo ?? op?.NombreArticulo,
						op?.idOperacion ?? op?.IdOperacion
					);
				});

				if (!values.length) {
					appendArticle(row?.articulo ?? row?.Articulo, 0);
				}

				return values;
			};

			this.toArray(rows).forEach((row, index) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				const name = `${row?.Nombre || row?.nombre || `Maq ${index + 1}`}`;
				const area = `${row?.Area || row?.area || "-"}`;
				const brand = `${row?.Marca || row?.marca || "-"}`;
				const model = `${row?.Modelo || row?.modelo || "-"}`;
				const article = `${row?.Articulo || row?.articulo || "-"}`;
				const mold = `${row?.Molde || row?.molde || "-"}`;
				const odtList = getOdtList(row);
				const moldList = getMoldList(row);
				const operationArticleList = getOperationArticleList(row);
				const lastStopEndMs = this.toTimeMs(row?.finUltimoParo ?? row?.FinUltimoParo);
				const timeSinceLastStopSec = this.toNumber(row?.tiempoDesdeUltimoParo ?? row?.TiempoDesdeUltimoParo);
				const timeSinceLastOperationSec = this.toNumber(
					row?.tiempoDesdeUltimaPieza ??
					row?.TiempoDesdeUltimaPieza ??
					row?.tiempoDesdeUltimaOperacion ??
					row?.TiempoDesdeUltimaOperacion
				);
				const machineDisplay = model && model !== "-" ? model : name;
				const uid = id > 0 ? `id-${id}` : `row-${index}-${name}`;
				if (!unique.has(uid)) {
					unique.set(uid, {
						uid,
						id,
						name,
						machineDisplay,
						area,
						brand,
						model,
						article,
						mold,
						odtList,
						moldList,
						operationArticleList,
						lastStopEndMs,
						timeSinceLastStopSec,
						timeSinceLastOperationSec,
					});
				} else {
					const existing = unique.get(uid);
					existing.odtList = mergeUniqueList(existing.odtList, odtList);
					existing.moldList = mergeUniqueList(existing.moldList, moldList);
					existing.operationArticleList = mergeUniqueList(
						existing.operationArticleList,
						operationArticleList
					);
					if (
						this.toNumber(existing.lastStopEndMs) <= 0 &&
						this.toNumber(lastStopEndMs) > 0
					) {
						existing.lastStopEndMs = lastStopEndMs;
					}
					if (
						this.toNumber(existing.timeSinceLastStopSec) <= 0 &&
						this.toNumber(timeSinceLastStopSec) > 0
					) {
						existing.timeSinceLastStopSec = timeSinceLastStopSec;
					}
				}
			});
			return Array.from(unique.values()).sort((a, b) => a.name.localeCompare(b.name));
		},
		buildStoppedDetails(rows) {
			const unique = new Map();
			this.toArray(rows).forEach((row, index) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				const name = `${row?.Nombre || row?.nombre || `Maq ${index + 1}`}`;
				const model = `${row?.Modelo || row?.modelo || "-"}`;
				const machineDisplay = model && model !== "-" ? model : name;
				const area = `${row?.Area || row?.area || "-"}`;
				const mold = `${row?.Molde || row?.molde || "S/D"}`;
				const paroEnCurso = row?.paroEnCurso || row?.ParoEnCurso || {};
				const stopCause = `${row?.causaParo || row?.CausaParo || row?.causa || row?.Causa || paroEnCurso?.causa || paroEnCurso?.Causa || "-"}`;
				const stopSubCause = `${row?.subcausaParo || row?.SubcausaParo || row?.subCausaParo || row?.SubCausaParo || row?.subCausa || row?.SubCausa || paroEnCurso?.subCausa || paroEnCurso?.SubCausa || "-"}`;
				const stopTimeSec = this.toNumber(
					row?.tiempoParoSegundos ??
					row?.TiempoParoSegundos ??
					row?.tiempoParoSeg ??
					row?.TiempoParoSeg ??
					row?.duracionParoSeg ??
					row?.DuracionParoSeg ??
					row?.tiempoParo ??
					row?.TiempoParo ??
					row?.duracionSeg ??
					row?.DuracionSeg ??
					paroEnCurso?.duracionSeg ??
					paroEnCurso?.DuracionSeg
				);
				const uid = id > 0 ? `id-${id}` : `row-${index}-${name}`;
				const existing = unique.get(uid);
				if (existing) {
					if ((existing.stopCause === "-" || !existing.stopCause) && stopCause && stopCause !== "-") {
						existing.stopCause = stopCause;
					}
					if ((existing.stopSubCause === "-" || !existing.stopSubCause) && stopSubCause && stopSubCause !== "-") {
						existing.stopSubCause = stopSubCause;
					}
					if (stopTimeSec > existing.stopTimeSec) {
						existing.stopTimeSec = stopTimeSec;
					}
					return;
				}
				unique.set(uid, {
					uid,
					id,
					area,
					machineDisplay,
					mold,
					stopCause,
					stopSubCause,
					stopTimeSec,
				});
			});
			return Array.from(unique.values()).sort((a, b) => `${a.machineDisplay}`.localeCompare(`${b.machineDisplay}`));
		},
		buildRestartDetails(rows) {
			const source = this.toArray(rows);
			return source
				.map((row, machineIndex) => {
					const machineId = this.toNumber(row?.IdMaquina);
					const machineName = `${row?.NombreMaquina || row?.nombreMaquina || row?.Nombre || row?.nombre || row?.Maquina || row?.maquina || row?.MachineName || row?.machineName || row?.Descripcion || row?.descripcion || ""}`.trim() || `Maq ${machineIndex + 1}`;
					const machineModel = `${row?.ModeloMaquina || row?.modeloMaquina || row?.Modelo || row?.modelo || row?.MachineModel || row?.machineModel || ""}`.trim();
					const machineDisplay = machineModel ? `${machineName} - ${machineModel}` : machineName;
					const odts = this.getRowArray(row, ["ODTs", "odts", "OdTs", "odTs"]).map((odt, odtIndex) => {
						const odtId = this.toNumber(odt?.IdTrabajoOrden);
						const odtKey = `${odt?.ClaveODT || odt?.claveODT || odt?.Clave || odt?.clave || odt?.NombreODT || odt?.nombreODT || ""}`.trim();
						const odtLabel = odtKey
							? odtId > 0
								? `${odtKey} (ODT ${odtId})`
								: odtKey
							: (odtId > 0 ? `ODT ${odtId}` : `ODT ${odtIndex + 1}`);
						const moldes = this.getRowArray(odt, ["Moldes", "moldes"]).map((mold, moldIndex) => {
							const code = `${mold?.Codigo || mold?.codigo || mold?.Clave || mold?.clave || ""}`.trim();
							const name = `${mold?.Nombre || mold?.nombre || ""}`.trim();
							return {
								uid: `restart-mold-${machineId || machineIndex}-${odtId || odtIndex}-${mold?.IdMolde || mold?.idMolde || moldIndex}`,
								idMolde: this.toNumber(mold?.IdMolde ?? mold?.idMolde),
								code,
								name,
								label: [code, name].filter(Boolean).join(" - ") || `Molde ${moldIndex + 1}`,
							};
						});
						const articulos = this.getRowArray(odt, ["Articulos", "articulos"]).map((article, articleIndex) => {
							const code = `${article?.Codigo || article?.codigo || article?.Clave || article?.clave || ""}`.trim();
							const name = `${article?.Nombre || article?.nombre || ""}`.trim();
							return {
								uid: `restart-article-${machineId || machineIndex}-${odtId || odtIndex}-${article?.IdArticulo || article?.idArticulo || articleIndex}`,
								idArticulo: this.toNumber(article?.IdArticulo ?? article?.idArticulo),
								code,
								name,
								label: [code, name].filter(Boolean).join(" - ") || `Artículo ${articleIndex + 1}`,
							};
						});
						const paros = this.getRowArray(odt, ["Paros", "paros"]).map((paro, paroIndex) => {
							const typeCode = `${paro?.CodigoParoTipo || paro?.codigoParoTipo || ""}`.trim();
							const typeName = `${paro?.NombreParoTipo || paro?.nombreParoTipo || ""}`.trim();
							const subTypeCode = `${paro?.CodigoSubParoTipo || paro?.codigoSubParoTipo || ""}`.trim();
							const subTypeName = `${paro?.NombreSubParoTipo || paro?.nombreSubParoTipo || ""}`.trim();
							const durationSec = this.toNumber(paro?.SegundosParo ?? paro?.segundosParo);
							const count = this.toNumber(paro?.CantidadParos ?? paro?.cantidadParos);
							return {
								uid: `restart-paro-${machineId || machineIndex}-${odtId || odtIndex}-${paro?.IdParoTipo || paro?.idParoTipo || paroIndex}`,
								idParoTipo: this.toNumber(paro?.IdParoTipo ?? paro?.idParoTipo),
								idSubParoTipo: this.toNumber(paro?.IdSubParoTipo ?? paro?.idSubParoTipo),
								typeCode,
								typeName,
								subTypeCode,
								subTypeName,
								typeLabel: [typeCode, typeName].filter(Boolean).join(" - ") || `Paro ${paroIndex + 1}`,
								subTypeLabel: [subTypeCode, subTypeName].filter(Boolean).join(" - "),
								label: [typeCode, typeName].filter(Boolean).join(" - ") || `Paro ${paroIndex + 1}`,
								subLabel: [subTypeCode, subTypeName].filter(Boolean).join(" - "),
								startMs: this.toTimeMs(paro?.InicioParo ?? paro?.inicioParo),
								endMs: this.toTimeMs(paro?.FinParo ?? paro?.finParo),
								durationSec,
								count,
							};
						});
						return {
							uid: `restart-odt-${machineId || machineIndex}-${odtId || odtIndex}`,
							odtId,
							odtKey,
							odtLabel,
							totalReinicios: this.getRestartCount(odt),
							moldes,
							articulos,
							paros,
						};
					});
					return {
						uid: machineId > 0 ? `restart-machine-${machineId}` : `restart-machine-${machineIndex}`,
						id: machineId,
						machineName,
						machineModel,
						machineDisplay,
						totalReinicios: this.getRestartCount(row),
						odts,
					};
				})
				.sort((a, b) => {
					const diff = this.getRestartCount(b) - this.getRestartCount(a);
					if (diff !== 0) return diff;
					return `${a?.machineDisplay || a?.machineName || ""}`.localeCompare(`${b?.machineDisplay || b?.machineName || ""}`);
				});
		},
			openRestartMachineDetail(item) {
				const machineName = `${item?.machineName || ""}`.trim() || "-";
				const machineDisplay = `${item?.machineDisplay || ""}`.trim();
				this.selectedRestartMachine = item && typeof item === "object"
						? {
							uid: `${item?.uid || ""}`,
							machineName,
							machineDisplay: machineDisplay || machineName,
							totalReinicios: this.getRestartCount(item),
							odts: this.getRowArray(item, ["odts", "ODTs", "OdTs", "odTs"]),
						}
						: {
							uid: "",
							machineName: "-",
							machineDisplay: "-",
							totalReinicios: 0,
							odts: [],
						};
				this.restartDetailTab = 0;
				this.dialogs.restarts = false;
				this.$nextTick(() => {
					this.dialogs.restartDetail = true;
				});
			},
			goBackToRestartMachines() {
				this.dialogs.restartDetail = false;
				this.$nextTick(() => {
					this.dialogs.restarts = true;
				});
			},
			openCardDetail(cardKey) {
				if (cardKey === "active") this.dialogs.active = true;
				if (cardKey === "stopped") this.dialogs.stopped = true;
			if (cardKey === "idle") this.dialogs.idle = true;
			if (cardKey === "restarts") this.dialogs.restarts = true;
		},
		getProgrammedVisibilityStorageKey() {
			return "reporte-cumplimiento:gantt-teorico:machine-visibility";
		},
		getProgrammedOdtVisibilityStorageKey() {
			return "reporte-cumplimiento:gantt-teorico:odt-visibility";
		},
		getRealVisibilityStorageKey() {
			return "reporte-cumplimiento:gantt-real:machine-visibility";
		},
		readVisibilityMap(storageKey) {
			if (!storageKey || typeof window === "undefined") return null;
			try {
				const raw = window.localStorage.getItem(storageKey);
				if (!raw) return null;
				const parsed = JSON.parse(raw);
				return parsed && typeof parsed === "object" ? parsed : null;
			} catch (_error) {
				return null;
			}
		},
		applyMachineVisibilityPreference(rows, storageKey) {
			const visibilityMap = this.readVisibilityMap(storageKey);
			return this.toArray(rows).map((row) => {
				const machineKey = `${row?.machineKey || ""}`;
				if (!machineKey) return { ...row, visible: row?.visible !== false };
				if (!visibilityMap || !Object.prototype.hasOwnProperty.call(visibilityMap, machineKey)) {
					return { ...row, visible: row?.visible !== false };
				}
				return {
					...row,
					visible: visibilityMap[machineKey] !== false,
				};
			});
		},
		applyProgrammedOdtVisibilityPreference(rows) {
			const visibilityMap = this.readVisibilityMap(this.getProgrammedOdtVisibilityStorageKey());
			return this.toArray(rows).map((row) => {
				const details = this.toArray(row?.details).map((detail) => {
					const visibilityKey = `${detail?.visibilityKey || ""}`;
					if (!visibilityKey || !visibilityMap || !Object.prototype.hasOwnProperty.call(visibilityMap, visibilityKey)) {
						return { ...detail, visible: detail?.visible !== false };
					}
					return {
						...detail,
						visible: visibilityMap[visibilityKey] !== false,
					};
				});
				return {
					...row,
					details,
				};
			});
		},
		saveMachineVisibilityPreference(rows, storageKey) {
			if (!storageKey || typeof window === "undefined") return;
			const payload = {};
			this.toArray(rows).forEach((row) => {
				const machineKey = `${row?.machineKey || ""}`;
				if (!machineKey) return;
				payload[machineKey] = row?.visible !== false;
			});
			try {
				window.localStorage.setItem(storageKey, JSON.stringify(payload));
			} catch (_error) {
				// Ignora errores de escritura en localStorage
			}
		},
		saveProgrammedOdtVisibilityPreference(rows) {
			const storageKey = this.getProgrammedOdtVisibilityStorageKey();
			if (!storageKey || typeof window === "undefined") return;
			const payload = {};
			this.toArray(rows).forEach((row) => {
				this.toArray(row?.details).forEach((detail) => {
					const visibilityKey = `${detail?.visibilityKey || ""}`;
					if (!visibilityKey) return;
					payload[visibilityKey] = detail?.visible !== false;
				});
			});
			try {
				window.localStorage.setItem(storageKey, JSON.stringify(payload));
			} catch (_error) {
				// Ignora errores de escritura en localStorage
			}
		},
		toggleProgrammedMachineVisibility(machineKey) {
			if (!machineKey) return;
			this.programmedMachineRows = this.programmedMachineRows.map((row) => {
				if (`${row?.machineKey || ""}` !== `${machineKey}`) return row;
				return {
					...row,
					visible: row?.visible === false,
				};
			});
			const hidden =
				this.programmedMachineRows.find((row) => `${row?.machineKey || ""}` === `${machineKey}`)?.visible === false;
			if (hidden) {
				this.expandedProgrammedRows = this.toArray(this.expandedProgrammedRows).filter((item) => {
					const key = typeof item === "object" ? `${item?.machineKey || ""}` : `${item || ""}`;
					return key !== `${machineKey}`;
				});
			}
			this.saveMachineVisibilityPreference(this.programmedMachineRows, this.getProgrammedVisibilityStorageKey());
		},
		toggleProgrammedOdtVisibility(machineKey, visibilityKey) {
			if (!machineKey || !visibilityKey) return;
			this.programmedMachineRows = this.programmedMachineRows.map((row) => {
				if (`${row?.machineKey || ""}` !== `${machineKey}`) return row;
				const details = this.toArray(row?.details).map((detail) => {
					if (`${detail?.visibilityKey || ""}` !== `${visibilityKey}`) return detail;
					return {
						...detail,
						visible: detail?.visible === false,
					};
				});
				return {
					...row,
					details,
				};
			});
			this.saveProgrammedOdtVisibilityPreference(this.programmedMachineRows);
		},
		toggleRealMachineVisibility(machineKey) {
			if (!machineKey) return;
			this.realMachineRows = this.realMachineRows.map((row) => {
				if (`${row?.machineKey || ""}` !== `${machineKey}`) return row;
				return {
					...row,
					visible: row?.visible === false,
				};
			});
			const hidden = this.realMachineRows.find((row) => `${row?.machineKey || ""}` === `${machineKey}`)?.visible === false;
			if (hidden) {
				this.expandedRealRows = this.toArray(this.expandedRealRows).filter((item) => {
					const key = typeof item === "object" ? `${item?.machineKey || ""}` : `${item || ""}`;
					return key !== `${machineKey}`;
				});
			}
			this.saveMachineVisibilityPreference(this.realMachineRows, this.getRealVisibilityStorageKey());
		},
		summarizeExpectedColumn(values) {
			const normalized = this.toArray(values)
				.map((value) => `${value || ""}`.trim())
				.filter(Boolean);
			if (!normalized.length) return "-";
			const unique = Array.from(new Set(normalized));
			return unique.length === 1 ? unique[0] : "Múltiples";
		},
		escapeHtml(value) {
			const map = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				'"': "&quot;",
				"'": "&#39;",
			};
			return `${value ?? ""}`.replace(/[&<>"']/g, (char) => map[char] || char);
		},
		formatTooltipSummaryHtml(summary, items, maxItems = 4) {
			const safeSummary = `${summary || "-"}`.trim() || "-";
			const uniqueItems = Array.from(
				new Set(
					this.toArray(items)
						.map((value) => `${value || ""}`.trim())
						.filter(Boolean)
				)
			);
			const normalizedSummary = safeSummary.toLowerCase();
			const isMultiple = normalizedSummary === "múltiples" || normalizedSummary === "multiples";
			if (isMultiple && uniqueItems.length) {
				const visible = uniqueItems.slice(0, Math.max(1, this.toNumber(maxItems) || 4));
				const hiddenCount = Math.max(0, uniqueItems.length - visible.length);
				const list = visible
					.map((item) => `<li style="margin-left:14px;list-style:disc;">${this.escapeHtml(item)}</li>`)
					.join("");
				const extra = hiddenCount > 0
					? `<li style="margin-left:14px;list-style:disc;">+${this.formatNumber(hiddenCount)} más</li>`
					: "";
				return `<span>Múltiples</span><ul style="margin:2px 0 0 0;padding:0;">${list}${extra}</ul>`;
			}
			return this.escapeHtml(safeSummary);
		},
		resolveProgrammedMachineMeta(machine, machineIndex = 0) {
			const machineId = this.toNumber(
				machine?.idMaquina ??
				machine?.IdMaquina ??
				machine?.idMaquinaIns ??
				machine?.IdMaquinaIns
			);
			const machineLabel =
				machine?.modeloMaquina ||
				machine?.ModeloMaquina ||
				machine?.nombreMaquina ||
				machine?.NombreMaquina ||
				machine?.nombre ||
				machine?.Nombre ||
				(machineId > 0 ? `Maq ${machineId}` : `Maq ${machineIndex + 1}`);
			const machineKey = `programmed-machine-${machineId > 0 ? machineId : machineIndex}-${machineLabel}`;
			return { machineId, machineLabel: `${machineLabel}`, machineKey };
		},
		getProgrammedMachineSegments(machine) {
			const segments = [];
			const fragments = this.toArray(machine?.fragmentos || machine?.Fragmentos);
			if (fragments.length) {
				fragments.forEach((fragment, fragmentIndex) => {
					const startMs = this.toTimeMs(
						fragment?.inicio ||
						fragment?.Inicio ||
						fragment?.fechaInicioDeProduccion ||
						fragment?.FechaInicioDeProduccion
					);
					const endMs = this.toTimeMs(
						fragment?.fin ||
						fragment?.Fin ||
						fragment?.fechaFinProduccion ||
						fragment?.FechaFinProduccion
					);
					if (startMs <= 0 || endMs <= startMs) return;
					segments.push({
						odt: fragment,
						startMs,
						endMs,
						dayLabel: this.formatDateTime(startMs),
						fragmentType: this.getProgrammedFragmentTypeLabel(
							fragment?.tipoFragmento || fragment?.TipoFragmento
						),
						operations: this.toArray(fragment?.operaciones || fragment?.Operaciones),
						segmentIndex: fragmentIndex,
					});
				});
				return segments;
			}

			this.toArray(machine?.dias || machine?.Dias).forEach((day, dayIndex) => {
				const dayLabel = `${day?.fecha || day?.Fecha || ""}`.trim() || `Día ${dayIndex + 1}`;
				this.toArray(day?.odTs || day?.ODTs || day?.odts).forEach((odt, odtIndex) => {
					const startMs = this.toTimeMs(
						odt?.inicioEnDia ||
						odt?.InicioEnDia ||
						odt?.fechaInicioDeProduccion ||
						odt?.FechaInicioDeProduccion
					);
					const endMs = this.toTimeMs(
						odt?.finEnDia ||
						odt?.FinEnDia ||
						odt?.fechaFinProduccion ||
						odt?.FechaFinProduccion
					);
					if (startMs <= 0 || endMs <= startMs) return;
					segments.push({
						odt,
						startMs,
						endMs,
						dayLabel,
						fragmentType: this.getProgrammedFragmentTypeLabel(
							odt?.tipoFragmento || odt?.TipoFragmento
						),
						operations: this.toArray(odt?.operaciones || odt?.Operaciones),
						segmentIndex: `${dayIndex}-${odtIndex}`,
					});
				});
			});

			return segments;
		},
		buildProgrammedMachineRows(data) {
			const grafo = data?.grafoProgramado || data?.GrafoProgramado || {};
			const machines = this.toArray(grafo?.porMaquina || grafo?.PorMaquina);
			return machines
				.map((machine, machineIndex) => {
					const meta = this.resolveProgrammedMachineMeta(machine, machineIndex);
					const details = [];
					this.getProgrammedMachineSegments(machine).forEach((segment, segmentIndex) => {
						const odt = segment?.odt || {};
						const operations = this.toArray(segment?.operations);
						const startMs = this.toNumber(segment?.startMs);
						const endMs = this.toNumber(segment?.endMs);
						const durationFromPayload = this.toNumber(odt?.duracionSeg ?? odt?.DuracionSeg);
						const durationSec =
							durationFromPayload > 0
								? durationFromPayload
								: startMs > 0 && endMs > startMs
									? Math.round((endMs - startMs) / 1000)
									: 0;
						const visibilityKey = this.buildProgrammedSegmentVisibilityKey(
							meta.machineKey,
							odt,
							startMs,
							endMs,
							segmentIndex
						);
						const areaSummary = this.summarizeExpectedColumn(
							operations.map((op) => `${op?.area || op?.Area || "-"}`)
						);
						const moldSummary = this.summarizeExpectedColumn(
							operations.map(
								(op) =>
									`${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || "-"}`
							)
						);
						const articleSummary = this.summarizeExpectedColumn(
							operations.map(
								(op) =>
									`${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || "-"}`
							)
						);
						details.push({
							uid: `programmed-detail-${meta.machineKey}-${segment?.segmentIndex ?? segmentIndex}`,
							odtLabel: this.getOdtLabel(odt, segmentIndex),
							dayLabel: `${segment?.dayLabel || `Tramo ${segmentIndex + 1}`}`,
							fragmentType: `${segment?.fragmentType || "-"}`,
							areaSummary,
							moldSummary,
							articleSummary,
							startMs,
							endMs,
							durationSec,
							operationsCount: operations.length,
							visibilityKey,
							visible: true,
						});
					});
					details.sort((a, b) => {
						const aStart = this.toNumber(a?.startMs);
						const bStart = this.toNumber(b?.startMs);
						if (aStart !== bStart) return aStart - bStart;
						return `${a.odtLabel}`.localeCompare(`${b.odtLabel}`);
					});
					return {
						...meta,
						slackSec: this.toNumber(machine?.tiempoMuertoSeg ?? machine?.TiempoMuertoSeg),
						overlapSec: this.toNumber(machine?.segundosSolapados ?? machine?.SegundosSolapados),
						productionSec: this.toNumber(machine?.tiempoProduccionSeg ?? machine?.TiempoProduccionSeg),
						details,
						visible: true,
					};
				})
				.sort((a, b) => `${a.machineLabel}`.localeCompare(`${b.machineLabel}`));
		},

		buildProgrammedGanttBars(data) {
			const grafo = data?.grafoProgramado || data?.GrafoProgramado || {};
			const machines = this.toArray(grafo?.porMaquina || grafo?.PorMaquina);
			const rows = [];
			machines.forEach((machine, machineIndex) => {
				const meta = this.resolveProgrammedMachineMeta(machine, machineIndex);
				const colorIndexByOdt = new Map();
				let nextColorIndex = 0;
				this.getProgrammedMachineSegments(machine).forEach((segment, segmentIndex) => {
					const odt = segment?.odt || {};
					const operations = this.toArray(segment?.operations);
					const odtLabel = this.getOdtLabel(odt, segmentIndex);
					const startMs = this.toNumber(segment?.startMs);
					const endMs = this.toNumber(segment?.endMs);
					if (startMs <= 0 || endMs <= startMs) return;
					const odtColorKey = `${odtLabel || "-"}`;
					if (!colorIndexByOdt.has(odtColorKey)) {
						colorIndexByOdt.set(odtColorKey, nextColorIndex);
						nextColorIndex += 1;
					}
					const colorIndex = this.toNumber(colorIndexByOdt.get(odtColorKey));
					const areaSummary = this.summarizeExpectedColumn(
						operations.map((op) => `${op?.area || op?.Area || "-"}`)
					);
					const areaItems = Array.from(
						new Set(
							operations
								.map((op) => `${op?.area || op?.Area || ""}`.trim())
								.filter(Boolean)
						)
					);
					const moldSummary = this.summarizeExpectedColumn(
						operations.map(
							(op) =>
								`${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || "-"}`
						)
					);
					const moldItems = Array.from(
						new Set(
							operations
								.map((op) => `${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`.trim())
								.filter(Boolean)
						)
					);
					const articleSummary = this.summarizeExpectedColumn(
						operations.map(
							(op) =>
								`${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || "-"}`
						)
					);
					const articleItems = Array.from(
						new Set(
							operations
								.map((op) => `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim())
								.filter(Boolean)
						)
					);
					const tcDisplay = this.getTcDisplay(
						operations.map((op) => this.toNumber(op?.tc ?? op?.TC))
					);
					const piecesToProduce = operations.reduce(
						(sum, op) => sum + this.toNumber(op?.piezasProducir ?? op?.PiezasProducir),
						0
					);
					const piecesExpected = operations.reduce(
						(sum, op) =>
							sum +
							this.toNumber(
								op?.piezasEsperadas ??
								op?.PiezasEsperadas ??
								op?.piezasProducir ??
								op?.PiezasProducir
							),
						0
					);
					rows.push({
						x: `${meta.machineLabel}`,
						y: [startMs, endMs],
						odtLabel,
						dayLabel: `${segment?.dayLabel || `Tramo ${segmentIndex + 1}`}`,
						fragmentType: `${segment?.fragmentType || "-"}`,
						areaSummary,
						areaItems,
						moldSummary,
						moldItems,
						articleSummary,
						articleItems,
						operationsCount: operations.length,
						tcDisplay,
						piecesToProduce,
						piecesExpected,
						machineKey: meta.machineKey,
						odtVisibilityKey: this.buildProgrammedSegmentVisibilityKey(
							meta.machineKey,
							odt,
							startMs,
							endMs,
							segmentIndex
						),
						fillColor: this.getProgrammedOdtColor(colorIndex),
					});
				});
			});

			const orderedRows = rows.sort((a, b) => {
				const aStart = this.toNumber(a?.y?.[0]);
				const bStart = this.toNumber(b?.y?.[0]);
				if (aStart !== bStart) return aStart - bStart;
				return `${a.x}`.localeCompare(`${b.x}`);
			});
			return this.removeTrailingDeadTimeRows(orderedRows);
		},
		resolveRealMachineMeta(machine, machineIndex = 0) {
			const machineId = this.toNumber(
				machine?.idMaquina ??
				machine?.IdMaquina ??
				machine?.idMaquinaIns ??
				machine?.IdMaquinaIns
			);
			const machineLabel =
				machine?.modeloMaquina ||
				machine?.ModeloMaquina ||
				machine?.nombreMaquina ||
				machine?.NombreMaquina ||
				machine?.nombre ||
				machine?.Nombre ||
				(machineId > 0 ? `Maq ${machineId}` : `Maq ${machineIndex + 1}`);
			const machineKey = `real-machine-${machineId > 0 ? machineId : machineIndex}-${machineLabel}`;
			return { machineId, machineLabel: `${machineLabel}`, machineKey };
		},
		buildRealWeekMachineRows(data) {
			const ganttRealGenTres = data?.ganttRealGenTres || data?.GanttRealGenTres || {};
			const machinesGenTres = this.toArray(ganttRealGenTres?.porMaquina || ganttRealGenTres?.PorMaquina);
			if (machinesGenTres.length) {
				const distributeSecondsByWeights = (totalSeconds, weights) => {
					const safeTotal = Math.max(0, Math.round(this.toNumber(totalSeconds)));
					const safeWeights = this.toArray(weights).map((value) => Math.max(0, this.toNumber(value)));
					const count = safeWeights.length;
					if (!count) return [];
					const positiveWeightSum = safeWeights.reduce((sum, value) => sum + value, 0);
					if (positiveWeightSum <= 0) {
						const base = Math.floor(safeTotal / count);
						let remainder = safeTotal - base * count;
						return safeWeights.map((_w, index) => {
							const extra = remainder > 0 ? 1 : 0;
							remainder = Math.max(0, remainder - 1);
							return base + (index < count ? extra : 0);
						});
					}
					const baseAlloc = safeWeights.map((weight) => Math.floor((safeTotal * weight) / positiveWeightSum));
					let assigned = baseAlloc.reduce((sum, value) => sum + value, 0);
					let remainder = Math.max(0, safeTotal - assigned);
					for (let i = 0; i < baseAlloc.length && remainder > 0; i += 1) {
						baseAlloc[i] += 1;
						assigned += 1;
						remainder -= 1;
					}
					return baseAlloc;
				};

				return machinesGenTres
					.map((machine, machineIndex) => {
						const meta = this.resolveRealMachineMeta(machine, machineIndex);
						const fragments = this.toArray(machine?.fragmentos || machine?.Fragmentos)
							.map((fragment, fragmentIndex) => {
								const startMs = this.toTimeMs(
									fragment?.inicio ||
									fragment?.Inicio ||
									fragment?.inicioReal ||
									fragment?.InicioReal ||
									fragment?.inicioEsperado ||
									fragment?.InicioEsperado
								);
								const endMs = this.toTimeMs(
									fragment?.fin ||
									fragment?.Fin ||
									fragment?.finReal ||
									fragment?.FinReal ||
									fragment?.finEsperado ||
									fragment?.FinEsperado
								);
								if (startMs <= 0 || endMs <= startMs) return null;

								const rawType = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim().toLowerCase();
								const isDead =
									Boolean(fragment?.esTiempoMuerto ?? fragment?.EsTiempoMuerto) ||
									rawType === "tiempomuerto";
								const isRed = Boolean(fragment?.esRojo ?? fragment?.EsRojo);
								const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
								const odtKey = `${fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
								const odtLabel = odtKey || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
								const operationsRaw = this.toArray(fragment?.operaciones || fragment?.Operaciones)
									.map((op, opIndex) => {
										const expectedPieces = this.toNumber(op?.piezasEsperadas ?? op?.PiezasEsperadas);
										const okPieces = this.toNumber(op?.piezasOk ?? op?.PiezasOk);
										const missingFromPayload = this.toNumber(op?.piezasFaltantes ?? op?.PiezasFaltantes);
										const missingPieces =
											missingFromPayload > 0
												? missingFromPayload
												: Math.max(0, expectedPieces - okPieces);
										return {
											uid: `real-gentres-opbase-${meta.machineKey}-${fragmentIndex}-${this.toNumber(op?.idOperacion ?? op?.IdOperacion) || opIndex}`,
											area: `${op?.area || op?.Area || "-"}`.trim() || "-",
											mold: `${op?.claveMolde || op?.ClaveMolde || "-"}`.trim() || "-",
											article: `${op?.articulo || op?.Articulo || "-"}`.trim() || "-",
											tc: this.toNumber(op?.tc ?? op?.TC),
											piecesExpected: expectedPieces,
											piecesOk: okPieces,
											piecesMissing: missingPieces,
										};
									});
								return {
									uid: `real-gentres-fragment-${meta.machineKey}-${fragmentIndex}`,
									rawType,
									isDead,
									isRed,
									fragmentType: this.getRealFragmentTypeLabel(rawType, { isDead, isRed }),
									odtLabel,
									startMs,
									endMs,
									operationsRaw,
									durationSec: Math.max(0, Math.round((endMs - startMs) / 1000)),
								};
							})
							.filter(Boolean)
							.sort((a, b) => {
								const byStart = this.toNumber(a.startMs) - this.toNumber(b.startMs);
								if (byStart !== 0) return byStart;
								return this.toNumber(a.endMs) - this.toNumber(b.endMs);
							});

						const shiftedSec = fragments
							.filter((fragment) => fragment?.isDead)
							.reduce((sum, fragment) => sum + this.toNumber(fragment?.durationSec), 0);
						const advanceSec = fragments
							.filter((fragment) =>
								!fragment?.isDead &&
								(
									fragment?.fragmentType === "Producción" ||
									fragment?.fragmentType === "Cambio de Molde y ajuste de procesos"
								)
							)
							.reduce((sum, fragment) => sum + this.toNumber(fragment?.durationSec), 0);
						const delaySec = fragments
							.filter(
								(fragment) =>
									!fragment?.isDead &&
									(
										fragment?.fragmentType === "Extra" ||
										fragment?.fragmentType === "Retraso"
									)
							)
							.reduce((sum, fragment) => sum + this.toNumber(fragment?.durationSec), 0);

						const operations = fragments
							.filter((fragment) => !fragment?.isDead)
							.flatMap((fragment, fragmentIndex) => {
								const fragmentOps = this.toArray(fragment?.operationsRaw);
								const isProduction =
									fragment?.fragmentType === "Producción" ||
									fragment?.fragmentType === "Cambio de Molde y ajuste de procesos";
								const isDelay =
									fragment?.fragmentType === "Extra" ||
									fragment?.fragmentType === "Retraso";
								const safeDuration = this.toNumber(fragment?.durationSec);

								if (!fragmentOps.length) {
									return [
										{
											uid: `real-gentres-op-${meta.machineKey}-${fragmentIndex}`,
											odtLabel: fragment?.odtLabel || "-",
											area: "-",
											mold: "-",
											article: fragment?.fragmentType || "Producción",
											machineModel: meta.machineLabel,
											tc: 0,
											piecesToProduce: 0,
											expectedUntil: 0,
											okUntil: 0,
											missingPieces: 0,
											fragmentType: fragment?.fragmentType || "Producción",
											productionSec: isProduction ? safeDuration : 0,
											delaySec: isDelay ? safeDuration : 0,
											startMs: this.toNumber(fragment?.startMs),
											endMs: this.toNumber(fragment?.endMs),
										},
									];
								}

								const weights = fragmentOps.map((op) => this.toNumber(op?.piecesExpected));
								const allocatedSeconds = distributeSecondsByWeights(safeDuration, weights);
								return fragmentOps.map((op, opIndex) => {
									const opSec = this.toNumber(allocatedSeconds?.[opIndex]);
									return {
										uid: `real-gentres-op-${meta.machineKey}-${fragmentIndex}-${opIndex}`,
										odtLabel: fragment?.odtLabel || "-",
										area: op?.area || "-",
										mold: op?.mold || "-",
										article: op?.article || "-",
										machineModel: meta.machineLabel,
										tc: this.toNumber(op?.tc),
										piecesToProduce: this.toNumber(op?.piecesExpected),
										expectedUntil: this.toNumber(op?.piecesExpected),
										okUntil: this.toNumber(op?.piecesOk),
										missingPieces: this.toNumber(op?.piecesMissing),
										fragmentType: fragment?.fragmentType || "Producción",
										productionSec: isProduction ? opSec : 0,
										delaySec: isDelay ? opSec : 0,
										startMs: this.toNumber(fragment?.startMs),
										endMs: this.toNumber(fragment?.endMs),
									};
								});
							});

						return {
							...meta,
							shiftedSec,
							errorSec: 0,
							delaySec,
							advanceSec,
							operations,
							visible: true,
						};
					})
					.sort((a, b) => `${a.machineLabel}`.localeCompare(`${b.machineLabel}`));
			}

			const ganttRealGenDos = data?.ganttRealGenDos || data?.GanttRealGenDos || {};
			const machinesGenDos = this.toArray(ganttRealGenDos?.porMaquina || ganttRealGenDos?.PorMaquina);
			if (machinesGenDos.length) {
				const pickNumber = (source, keys) => {
					for (const key of keys) {
						const value = this.toNumber(source?.[key]);
						if (value > 0) return value;
					}
					return 0;
				};
				const inferBreakdownFromPieces = (fragment, durationSec) => {
					if (durationSec <= 0) return { advanceSec: 0, delaySec: 0 };
					const okPieces = pickNumber(fragment, ["piezasOk", "PiezasOk"]);
					const expectedPieces = pickNumber(fragment, [
						"piezasEsperadasHastaConsulta",
						"PiezasEsperadasHastaConsulta",
						"piezasObjetivo",
						"PiezasObjetivo",
					]);
					let missingPieces = pickNumber(fragment, ["piezasFaltantes", "PiezasFaltantes"]);
					if (missingPieces <= 0 && expectedPieces > 0) {
						missingPieces = Math.max(0, expectedPieces - okPieces);
					}
					const total = okPieces + missingPieces;
					if (total <= 0) return { advanceSec: 0, delaySec: 0 };
					const advanceSec = Math.max(0, Math.round((durationSec * okPieces) / total));
					const delaySec = Math.max(0, durationSec - advanceSec);
					return { advanceSec, delaySec };
				};

				return machinesGenDos
					.map((machine, machineIndex) => {
						const meta = this.resolveRealMachineMeta(machine, machineIndex);
						const fragments = this.toArray(machine?.fragmentos || machine?.Fragmentos)
							.map((fragment, fragmentIndex) => {
								const startMs = this.toTimeMs(
									fragment?.inicioReal ||
									fragment?.InicioReal ||
									fragment?.inicioEsperado ||
									fragment?.InicioEsperado
								);
								const endMs = this.toTimeMs(
									fragment?.finReal ||
									fragment?.FinReal ||
									fragment?.finEsperado ||
									fragment?.FinEsperado
								);
								if (startMs <= 0 || endMs <= startMs) return null;
								const durationSec = Math.max(0, Math.round((endMs - startMs) / 1000));
								const rawType = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim().toLowerCase();
								const isDead =
									Boolean(fragment?.esTiempoMuerto ?? fragment?.EsTiempoMuerto) ||
									rawType === "tiempomuerto";
								const isTheoretical = Boolean(
									fragment?.esProduccionTeorica ?? fragment?.EsProduccionTeorica
								);
								const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
								const odtKey = `${fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
								const odtLabel = odtKey || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
								const expectedPieces = pickNumber(fragment, [
									"piezasEsperadasHastaConsulta",
									"PiezasEsperadasHastaConsulta",
									"piezasObjetivo",
									"PiezasObjetivo",
								]);
								const okPieces = pickNumber(fragment, ["piezasOk", "PiezasOk"]);
								let missingPieces = Math.max(0, expectedPieces - okPieces);
								let advanceSec = 0;
								let delaySec = 0;
								let lateSec = 0;
								let theoreticalSec = 0;

								if (!isDead && !isTheoretical) {
									advanceSec = pickNumber(fragment, [
										"avanceSeg",
										"AvanceSeg",
										"segundosAvance",
										"SegundosAvance",
										"segundosProduccion",
										"SegundosProduccion",
									]);
									delaySec = pickNumber(fragment, [
										"desfaseSeg",
										"DesfaseSeg",
										"segundosDesfazados",
										"SegundosDesfazados",
										"tiempoDesfaseSeg",
										"TiempoDesfaseSeg",
									]);
									lateSec = pickNumber(fragment, [
										"retrasoSeg",
										"RetrasoSeg",
										"segundosRetraso",
										"SegundosRetraso",
										"tiempoRetrasoSeg",
										"TiempoRetrasoSeg",
									]);
									if (advanceSec <= 0 && delaySec <= 0) {
										if (rawType === "retraso" || lateSec > 0) {
											lateSec = Math.max(lateSec, durationSec);
										} else {
											const inferred = inferBreakdownFromPieces(fragment, durationSec);
											advanceSec = inferred.advanceSec;
											delaySec = inferred.delaySec;
										}
									}
									const known = advanceSec + delaySec + lateSec;
									if (known > durationSec && known > 0) {
										const scale = durationSec / known;
										advanceSec = Math.round(advanceSec * scale);
										delaySec = Math.round(delaySec * scale);
										lateSec = Math.max(0, durationSec - advanceSec - delaySec);
									} else if (known < durationSec) {
										const remainder = durationSec - known;
										if (lateSec > 0 || rawType === "retraso") lateSec += remainder;
										else if (delaySec > 0 || missingPieces > 0) delaySec += remainder;
										else advanceSec += remainder;
									}
								} else if (isTheoretical) {
									theoreticalSec = durationSec;
								}

								return {
									uid: `real-gendos-fragment-${meta.machineKey}-${fragmentIndex}`,
									odtLabel,
									isDead,
									isTheoretical,
									rawType,
									startMs,
									endMs,
									durationSec,
									advanceSec: Math.max(0, Math.round(advanceSec)),
									delaySec: Math.max(0, Math.round(delaySec)),
									lateSec: Math.max(0, Math.round(lateSec)),
									theoreticalSec: Math.max(0, Math.round(theoreticalSec)),
									tc: this.toNumber(fragment?.tc ?? fragment?.TC),
									piecesToProduce: pickNumber(fragment, ["piezasObjetivo", "PiezasObjetivo"]),
									expectedUntil: expectedPieces,
									okUntil: okPieces,
									missingPieces,
									operationRef: this.toNumber(fragment?.idOperacionReferencia ?? fragment?.IdOperacionReferencia),
								};
							})
							.filter(Boolean)
							.sort((a, b) => {
								const byStart = this.toNumber(a.startMs) - this.toNumber(b.startMs);
								if (byStart !== 0) return byStart;
								return `${a.odtLabel}`.localeCompare(`${b.odtLabel}`);
							});

						const shiftedSec = fragments
							.filter((fragment) => fragment?.isDead)
							.reduce((sum, fragment) => sum + this.toNumber(fragment?.durationSec), 0);
						const advanceSec = fragments
							.filter((fragment) => !fragment?.isDead && !fragment?.isTheoretical)
							.reduce((sum, fragment) => sum + this.toNumber(fragment?.advanceSec), 0);
						const delaySec = fragments
							.filter((fragment) => !fragment?.isDead && !fragment?.isTheoretical)
							.reduce(
								(sum, fragment) =>
									sum + this.toNumber(fragment?.delaySec) + this.toNumber(fragment?.lateSec),
								0
							);

						const operations = fragments
							.filter((fragment) => !fragment?.isDead && !fragment?.isTheoretical)
							.map((fragment, fragmentIndex) => ({
								uid: `real-gendos-op-${meta.machineKey}-${fragmentIndex}`,
								odtLabel: fragment?.odtLabel || "-",
								area: "-",
								mold: "-",
								article: this.toNumber(fragment?.operationRef) > 0 ? `Op ${fragment.operationRef}` : "-",
								machineModel: meta.machineLabel,
								tc: this.toNumber(fragment?.tc),
								piecesToProduce: this.toNumber(fragment?.piecesToProduce),
								expectedUntil: this.toNumber(fragment?.expectedUntil),
								okUntil: this.toNumber(fragment?.okUntil),
								missingPieces: this.toNumber(fragment?.missingPieces),
								fragmentType: this.getRealFragmentTypeLabel(fragment?.rawType, {
									isDead: fragment?.isDead,
									isTheoretical: fragment?.isTheoretical,
								}),
								productionSec: this.toNumber(fragment?.advanceSec),
								delaySec: this.toNumber(fragment?.delaySec) + this.toNumber(fragment?.lateSec),
								startMs: this.toNumber(fragment?.startMs),
								endMs: this.toNumber(fragment?.endMs),
							}));

						return {
							...meta,
							shiftedSec,
							errorSec: 0,
							delaySec,
							advanceSec,
							operations,
							visible: true,
						};
					})
					.sort((a, b) => `${a.machineLabel}`.localeCompare(`${b.machineLabel}`));
			}

			const grafo = data?.grafoReal || data?.GrafoReal || {};
			const machines = this.toArray(grafo?.porMaquina || grafo?.PorMaquina);
			return machines
				.map((machine, machineIndex) => {
					const meta = this.resolveRealMachineMeta(machine, machineIndex);
					const operationMap = new Map();
					this.toArray(machine?.dias || machine?.Dias).forEach((day, dayIndex) => {
						this.toArray(day?.odTs || day?.ODTs || day?.odts).forEach((odt, odtIndex) => {
							const odtId = this.toNumber(odt?.idTrabajoOrden ?? odt?.IdTrabajoOrden);
							const odtLabel = this.getOdtLabel(odt, odtIndex);
							this.toArray(odt?.operaciones || odt?.Operaciones).forEach((op, opIndex) => {
								const operationId = this.toNumber(op?.idOperacion ?? op?.IdOperacion);
								const startMs = this.toTimeMs(op?.fechaInicioProduccion || op?.FechaInicioProduccion);
								const endMs = this.toTimeMs(op?.fechaFinProduccion || op?.FechaFinProduccion);
								const opKey = `${odtId || odtIndex}-${operationId || opIndex}-${startMs}-${endMs}`;
								if (operationMap.has(opKey)) return;
								operationMap.set(opKey, {
									uid: `real-op-${meta.machineKey}-${odtId || odtIndex}-${operationId || opIndex}-${dayIndex}`,
									odtLabel,
									area: `${op?.area || op?.Area || "-"}`.trim() || "-",
									mold: `${op?.claveMolde || op?.ClaveMolde || "-"}`.trim() || "-",
									article: `${op?.articulo || op?.Articulo || "-"}`.trim() || "-",
									machineModel: `${op?.modeloMaquina || op?.ModeloMaquina || meta.machineLabel || "-"}`.trim() || "-",
									tc: this.toNumber(op?.tc ?? op?.TC),
									piecesToProduce: this.toNumber(op?.piezasProducir ?? op?.PiezasProducir),
									expectedUntil: this.toNumber(op?.piezasEsperadasHastaConsulta ?? op?.PiezasEsperadasHastaConsulta),
									okUntil: this.toNumber(op?.piezasOkHastaConsulta ?? op?.PiezasOkHastaConsulta),
									missingPieces: this.toNumber(op?.piezasFaltantes ?? op?.PiezasFaltantes),
									fragmentType: "Producción",
									productionSec: this.toNumber(op?.segundosProduccion ?? op?.SegundosProduccion ?? op?.tiempoProduccionSeg ?? op?.TiempoProduccionSeg),
									delaySec: this.toNumber(op?.segundosDesfazados ?? op?.SegundosDesfazados),
									startMs,
									endMs,
								});
							});
						});
					});
					const operations = Array.from(operationMap.values()).sort((a, b) => {
						const byStart = this.toNumber(a.startMs) - this.toNumber(b.startMs);
						if (byStart !== 0) return byStart;
						return `${a.odtLabel}`.localeCompare(`${b.odtLabel}`);
					});
					const totalOpProductionSec = operations.reduce((sum, op) => sum + this.toNumber(op?.productionSec), 0);
					const totalOpDelaySec = operations.reduce((sum, op) => sum + this.toNumber(op?.delaySec), 0);
					const machineDelaySec = this.toNumber(machine?.tiempoDesfaseSeg ?? machine?.TiempoDesfaseSeg);
					const machineAdvanceSec = this.toNumber(machine?.tiempoAvanceSeg ?? machine?.TiempoAvanceSeg);
					return {
						...meta,
						shiftedSec: this.toNumber(machine?.tiempoDesplazadoSeg ?? machine?.TiempoDesplazadoSeg),
						errorSec: this.toNumber(machine?.tiempoErrorSeg ?? machine?.TiempoErrorSeg),
						delaySec: Math.max(machineDelaySec, totalOpDelaySec),
						advanceSec: Math.max(machineAdvanceSec, totalOpProductionSec),
						operations,
						visible: true,
					};
				})
				.sort((a, b) => `${a.machineLabel}`.localeCompare(`${b.machineLabel}`));
		},
		buildRealWeekGanttBars(data) {
			const ganttRealGenTres = data?.ganttRealGenTres || data?.GanttRealGenTres || {};
			const machinesGenTres = this.toArray(ganttRealGenTres?.porMaquina || ganttRealGenTres?.PorMaquina);
			if (machinesGenTres.length) {
				const rows = [];
				machinesGenTres.forEach((machine, machineIndex) => {
					const meta = this.resolveRealMachineMeta(machine, machineIndex);
					this.toArray(machine?.fragmentos || machine?.Fragmentos).forEach((fragment, fragmentIndex) => {
						const startMs = this.toTimeMs(
							fragment?.inicio ||
							fragment?.Inicio ||
							fragment?.inicioReal ||
							fragment?.InicioReal ||
							fragment?.inicioEsperado ||
							fragment?.InicioEsperado
						);
						const endMs = this.toTimeMs(
							fragment?.fin ||
							fragment?.Fin ||
							fragment?.finReal ||
							fragment?.FinReal ||
							fragment?.finEsperado ||
							fragment?.FinEsperado
						);
						if (startMs <= 0 || endMs <= startMs) return;

						const rawType = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim().toLowerCase();
						const isDead =
							Boolean(fragment?.esTiempoMuerto ?? fragment?.EsTiempoMuerto) ||
							rawType === "tiempomuerto";
						const isRed = Boolean(fragment?.esRojo ?? fragment?.EsRojo);
						const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
						const odtKey = `${fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
						const odtLabel = odtKey || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
						const operationsRaw = this.toArray(fragment?.operaciones || fragment?.Operaciones);
						const piecesExpected = operationsRaw.reduce(
							(sum, op) => sum + this.toNumber(op?.piezasEsperadas ?? op?.PiezasEsperadas),
							0
						);
						const piecesOk = operationsRaw.reduce(
							(sum, op) => sum + this.toNumber(op?.piezasOk ?? op?.PiezasOk),
							0
						);
						const piecesMissing = operationsRaw.reduce((sum, op) => {
							const expected = this.toNumber(op?.piezasEsperadas ?? op?.PiezasEsperadas);
							const ok = this.toNumber(op?.piezasOk ?? op?.PiezasOk);
							const missingFromPayload = this.toNumber(op?.piezasFaltantes ?? op?.PiezasFaltantes);
							const missing = missingFromPayload > 0 ? missingFromPayload : Math.max(0, expected - ok);
							return sum + missing;
						}, 0);
						const articlesSummary = this.summarizeExpectedColumn(
							operationsRaw.map((op) => `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`)
						);
						const articleItems = Array.from(
							new Set(
								operationsRaw
									.map((op) => `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim())
									.filter(Boolean)
							)
						);
						const moldsSummary = this.summarizeExpectedColumn(
							operationsRaw.map((op) => `${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`)
						);
						const moldItems = Array.from(
							new Set(
								operationsRaw
									.map((op) => `${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`.trim())
									.filter(Boolean)
							)
						);
						const cavitiesCount = operationsRaw.length;
						const tcDisplay = this.getTcDisplay(
							operationsRaw.map((op) => op?.tc ?? op?.TC),
							fragment?.tc ?? fragment?.TC
						);
						const articleTcItems = Array.from(
							new Map(
								operationsRaw
									.map((op) => {
										const article = `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim();
										const tc = this.toNumber(op?.tc ?? op?.TC);
										return [article, { article, tc }];
									})
									.filter(([article]) => Boolean(article))
							).values()
						);
						const timeType = this.getRealFragmentTypeLabel(rawType, { isDead, isRed });
						let fillColor = "#2e9d53";
						if (timeType === "Tiempo muerto") fillColor = "#2f80d6";
						else if (timeType === "Retraso") fillColor = "#d64545";
						else if (timeType === "Extra") fillColor = "#f0ac22";
						else if (timeType === "Cambio de Molde y ajuste de procesos") fillColor = "#2e9d53";
						let piecesEquivalent = 0;
						if (timeType === "Producción" || timeType === "Cambio de Molde y ajuste de procesos") {
							piecesEquivalent = piecesOk;
						} else if (timeType === "Extra" || timeType === "Retraso") {
							piecesEquivalent = piecesMissing;
						}
						if (piecesEquivalent <= 0 && !isDead) {
							const tcCandidates = operationsRaw
								.map((op) => this.toNumber(op?.tc ?? op?.TC))
								.filter((value) => value > 0);
							const tcAvg =
								tcCandidates.length > 0
									? tcCandidates.reduce((sum, value) => sum + value, 0) / tcCandidates.length
									: 0;
							if (tcAvg > 0) {
								piecesEquivalent = Number(
									((Math.max(0, Math.round((endMs - startMs) / 1000)) / tcAvg)).toFixed(1)
								);
							}
						}

						rows.push({
							uid: `real-gentres-bar-${meta.machineKey}-${fragmentIndex}`,
							x: `${meta.machineLabel}`,
							y: [startMs, endMs],
							odtLabel,
							articlesSummary,
							articleItems,
							moldsSummary,
							moldItems,
							articleTcItems,
							piecesExpected,
							piecesDone: piecesOk,
							dayLabel: this.formatDateTime(startMs),
							machineKey: meta.machineKey,
							timeType,
							piecesEquivalent,
							cavitiesCount,
							tcDisplay,
							fillColor,
						});
					});
				});

				const orderedRows = rows.sort((a, b) => {
					const aStart = this.toNumber(a?.y?.[0]);
					const bStart = this.toNumber(b?.y?.[0]);
					if (aStart !== bStart) return aStart - bStart;
					return `${a.x}`.localeCompare(`${b.x}`);
				});
				return this.removeTrailingDeadTimeRows(orderedRows);
			}

			const ganttRealGenDos = data?.ganttRealGenDos || data?.GanttRealGenDos || {};
			const machinesGenDos = this.toArray(ganttRealGenDos?.porMaquina || ganttRealGenDos?.PorMaquina);
			if (machinesGenDos.length) {
				const rows = [];
				const resolveGenDosVisual = (fragment) => {
					const rawLabel = `${fragment?.tipoFragmento || fragment?.TipoFragmento || ""}`.trim();
					const rawType = rawLabel.toLowerCase();
					const isDead =
						Boolean(fragment?.esTiempoMuerto ?? fragment?.EsTiempoMuerto) ||
						rawType === "tiempomuerto";
					const isTheoretical = Boolean(fragment?.esProduccionTeorica ?? fragment?.EsProduccionTeorica);
					const isMoldChangeType =
						rawType === "cambio de molde y ajuste de procesos" ||
						rawType.includes("cambio de molde");
					if (isDead) return { timeType: "Tiempo muerto", fillColor: "#2f80d6" };
					if (isTheoretical) return null;
					if (rawType === "retraso") return { timeType: "Retraso", fillColor: "#d64545" };
					if (rawType === "extra" || rawType === "desfase") return { timeType: "Extra", fillColor: "#f0ac22" };
					if (isMoldChangeType) {
						return { timeType: "Cambio de Molde y ajuste de procesos", fillColor: "#2e9d53" };
					}
					if (rawType === "odt" || rawType === "produccion") {
						return { timeType: "Producción", fillColor: "#2e9d53" };
					}
					return { timeType: "Producción", fillColor: "#2e9d53" };
				};

				machinesGenDos.forEach((machine, machineIndex) => {
					const meta = this.resolveRealMachineMeta(machine, machineIndex);
					this.toArray(machine?.fragmentos || machine?.Fragmentos).forEach((fragment, fragmentIndex) => {
						const startMs = this.toTimeMs(
							fragment?.inicioReal ||
							fragment?.InicioReal ||
							fragment?.inicioEsperado ||
							fragment?.InicioEsperado
						);
						const endMs = this.toTimeMs(
							fragment?.finReal ||
							fragment?.FinReal ||
							fragment?.finEsperado ||
							fragment?.FinEsperado
						);
						if (startMs <= 0 || endMs <= startMs) return;

						const odtId = this.toNumber(fragment?.idTrabajoOrden ?? fragment?.IdTrabajoOrden);
						const odtKey = `${fragment?.claveODT || fragment?.ClaveODT || ""}`.trim();
						const odtLabel = odtKey || (odtId > 0 ? `ODT ${odtId}` : "Sin ODT");
						const operationsRaw = this.toArray(fragment?.operaciones || fragment?.Operaciones);
						const piecesExpectedFromOps = operationsRaw.reduce(
							(sum, op) => sum + this.toNumber(op?.piezasEsperadas ?? op?.PiezasEsperadas),
							0
						);
						const piecesDoneFromOps = operationsRaw.reduce(
							(sum, op) => sum + this.toNumber(op?.piezasOk ?? op?.PiezasOk),
							0
						);
						const piecesExpected =
							piecesExpectedFromOps > 0
								? piecesExpectedFromOps
								: this.toNumber(
									fragment?.piezasEsperadasHastaConsulta ??
									fragment?.PiezasEsperadasHastaConsulta ??
									fragment?.piezasObjetivo ??
									fragment?.PiezasObjetivo
								);
						const piecesDone =
							piecesDoneFromOps > 0
								? piecesDoneFromOps
								: this.toNumber(fragment?.piezasOk ?? fragment?.PiezasOk);
						const articlesSummary = this.summarizeExpectedColumn(
							operationsRaw.map(
								(op) => `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`
							)
						);
						const articleItems = Array.from(
							new Set(
								operationsRaw
									.map((op) => `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim())
									.filter(Boolean)
							)
						);
						const moldsSummary = this.summarizeExpectedColumn(
							operationsRaw.map(
								(op) => `${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`
							)
						);
						const moldItems = Array.from(
							new Set(
								operationsRaw
									.map((op) => `${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`.trim())
									.filter(Boolean)
							)
						);
						const cavitiesCount = operationsRaw.length;
						const tcDisplay = this.getTcDisplay(
							operationsRaw.map((op) => op?.tc ?? op?.TC),
							fragment?.tc ?? fragment?.TC
						);
						const articleTcItems = Array.from(
							new Map(
								operationsRaw
									.map((op) => {
										const article = `${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim();
										const tc = this.toNumber(op?.tc ?? op?.TC);
										return [article, { article, tc }];
									})
									.filter(([article]) => Boolean(article))
							).values()
						);
						const visual = resolveGenDosVisual(fragment);
						if (!visual) return;
						rows.push({
							uid: `real-gendos-bar-${meta.machineKey}-${fragmentIndex}`,
							x: `${meta.machineLabel}`,
							y: [startMs, endMs],
							odtLabel,
							dayLabel: this.formatDateTime(startMs),
							machineKey: meta.machineKey,
							timeType: visual.timeType,
							fillColor: visual.fillColor,
							articlesSummary,
							articleItems,
							moldsSummary,
							moldItems,
							articleTcItems,
							piecesExpected,
							piecesDone,
							cavitiesCount,
							tcDisplay,
						});
					});
				});

				const orderedRows = rows.sort((a, b) => {
					const aStart = this.toNumber(a?.y?.[0]);
					const bStart = this.toNumber(b?.y?.[0]);
					if (aStart !== bStart) return aStart - bStart;
					return `${a.x}`.localeCompare(`${b.x}`);
				});
				return this.removeTrailingDeadTimeRows(orderedRows);
			}

			const grafo = data?.grafoReal || data?.GrafoReal || {};
			const machines = this.toArray(grafo?.porMaquina || grafo?.PorMaquina);
			const rows = [];

			const pickNumber = (source, keys) => {
				for (const key of keys) {
					const value = this.toNumber(source?.[key]);
					if (value > 0) return value;
				}
				return 0;
			};

			const inferBreakdownFromPieces = (okPieces, missingPieces, expectedPieces, durationSec) => {
				if (durationSec <= 0) return { advanceSec: 0, delaySec: 0 };
				let safeOk = Math.max(0, okPieces);
				let safeMissing = Math.max(0, missingPieces);
				if (safeMissing <= 0 && expectedPieces > 0) {
					safeMissing = Math.max(0, expectedPieces - safeOk);
				}
				const total = safeOk + safeMissing;
				if (total <= 0) return { advanceSec: 0, delaySec: 0 };

				let advanceSec = Math.round((durationSec * safeOk) / total);
				let delaySec = Math.max(0, durationSec - advanceSec);
				if (advanceSec < 0) advanceSec = 0;
				if (delaySec < 0) delaySec = 0;
				return { advanceSec, delaySec };
			};

			machines.forEach((machine, machineIndex) => {
				const meta = this.resolveRealMachineMeta(machine, machineIndex);
				const days = this.toArray(machine?.dias || machine?.Dias);
				const odtMap = new Map();

				const resolveOdtKey = (odt, odtIndex = 0) => {
					const odtId = this.toNumber(odt?.idTrabajoOrden ?? odt?.IdTrabajoOrden);
					const odtLabel = this.getOdtLabel(odt, odtIndex);
					return `${odtId || 0}-${odtLabel}`;
				};

				days.forEach((day, dayIndex) => {
					const dayLabel = `${day?.fecha || day?.Fecha || ""}`.trim();
					this.toArray(day?.odTs || day?.ODTs || day?.odts).forEach((odt, odtIndex) => {
						const odtLabel = this.getOdtLabel(odt, odtIndex);
						const startMs = this.toTimeMs(
							odt?.inicioEnDia ||
							odt?.InicioEnDia ||
							odt?.fechaInicioDeProduccion ||
							odt?.FechaInicioDeProduccion
						);
						const endMs = this.toTimeMs(
							odt?.finEnDia ||
							odt?.FinEnDia ||
							odt?.fechaFinProduccion ||
							odt?.FechaFinProduccion
						);
						if (startMs <= 0 || endMs <= startMs) return;
						const odtKey = resolveOdtKey(odt, odtIndex);
						const odtStartMs = this.toTimeMs(
							odt?.fechaInicioDeProduccion ||
							odt?.FechaInicioDeProduccion ||
							odt?.inicioEnDia ||
							odt?.InicioEnDia
						);
						const odtEndMs = this.toTimeMs(
							odt?.fechaFinProduccion ||
							odt?.FechaFinProduccion ||
							odt?.finEnDia ||
							odt?.FinEnDia
						);
						const entry = odtMap.get(odtKey) || {
							odtKey,
							odtLabel,
							startGlobalMs: odtStartMs || startMs,
							endGlobalMs: odtEndMs || endMs,
							slices: [],
							opSeen: new Set(),
							articleSet: new Set(),
							moldSet: new Set(),
							tc: 0,
							odtAdvanceSec: 0,
							odtProductionSec: 0,
							odtDelaySec: 0,
							opAdvanceSec: 0,
							opProductionSec: 0,
							opDelaySec: 0,
							okPieces: 0,
							missingPieces: 0,
							expectedPieces: 0,
						};

						if (odtStartMs > 0 && odtStartMs < entry.startGlobalMs) entry.startGlobalMs = odtStartMs;
						if (odtEndMs > 0 && odtEndMs > entry.endGlobalMs) entry.endGlobalMs = odtEndMs;

						entry.slices.push({
							startMs,
							endMs,
							durationSec: Math.max(0, Math.round((endMs - startMs) / 1000)),
							dayLabel: dayLabel || `Día ${dayIndex + 1}`,
						});

						// Si el backend en algún momento agrega valores directamente en ODT, se respetan.
						entry.odtAdvanceSec = Math.max(entry.odtAdvanceSec, pickNumber(odt, [
							"segundosAvance",
							"SegundosAvance",
							"tiempoAvanceSeg",
							"TiempoAvanceSeg",
						]));
						entry.odtProductionSec = Math.max(entry.odtProductionSec, pickNumber(odt, [
							"segundosProduccion",
							"SegundosProduccion",
							"tiempoProduccionSeg",
							"TiempoProduccionSeg",
						]));
						entry.odtDelaySec = Math.max(entry.odtDelaySec, pickNumber(odt, [
							"segundosDesfase",
							"SegundosDesfase",
							"tiempoDesfaseSeg",
							"TiempoDesfaseSeg",
							"segundosDesfazados",
							"SegundosDesfazados",
							"tiempoFaltanteSeg",
							"TiempoFaltanteSeg",
						]));
						entry.tc = Math.max(entry.tc, pickNumber(odt, ["tc", "TC"]));
						entry.okPieces += pickNumber(odt, [
							"piezasOkHastaConsulta",
							"PiezasOkHastaConsulta",
							"piezasOk",
							"PiezasOk",
							"ok",
							"OK",
						]);
						entry.missingPieces += pickNumber(odt, [
							"piezasFaltantes",
							"PiezasFaltantes",
							"faltantes",
							"Faltantes",
							"piezasDesfase",
							"PiezasDesfase",
						]);
						entry.expectedPieces += pickNumber(odt, [
							"piezasEsperadasHastaConsulta",
							"PiezasEsperadasHastaConsulta",
							"piezasEsperadas",
							"PiezasEsperadas",
							"esperadas",
							"Esperadas",
						]);

						// Se usan operaciones solo para consolidar totales de la ODT (no para tramos por operación).
						this.toArray(odt?.operaciones || odt?.Operaciones).forEach((op, opIndex) => {
							const opId = this.toNumber(op?.idOperacion ?? op?.IdOperacion);
							const opStart = this.toTimeMs(op?.fechaInicioProduccion || op?.FechaInicioProduccion);
							const opEnd = this.toTimeMs(op?.fechaFinProduccion || op?.FechaFinProduccion);
							const opKey = `${opId || opIndex}-${opStart}-${opEnd}`;
							if (entry.opSeen.has(opKey)) return;
							entry.opSeen.add(opKey);
							entry.articleSet.add(
								`${op?.articulo || op?.Articulo || op?.nombreArticulo || op?.NombreArticulo || ""}`.trim()
							);
							entry.moldSet.add(
								`${op?.claveMolde || op?.ClaveMolde || op?.nombreMolde || op?.NombreMolde || ""}`.trim()
							);

							entry.opAdvanceSec += pickNumber(op, [
								"segundosAvance",
								"SegundosAvance",
								"tiempoAvanceSeg",
								"TiempoAvanceSeg",
							]);
							entry.opProductionSec += pickNumber(op, [
								"segundosProduccion",
								"SegundosProduccion",
								"tiempoProduccionSeg",
								"TiempoProduccionSeg",
							]);
							entry.opDelaySec += pickNumber(op, [
								"segundosDesfase",
								"SegundosDesfase",
								"tiempoDesfaseSeg",
								"TiempoDesfaseSeg",
								"segundosDesfazados",
								"SegundosDesfazados",
								"tiempoFaltanteSeg",
								"TiempoFaltanteSeg",
							]);

							entry.okPieces += pickNumber(op, [
								"piezasOkHastaConsulta",
								"PiezasOkHastaConsulta",
								"piezasOk",
								"PiezasOk",
								"ok",
								"OK",
							]);
							entry.missingPieces += pickNumber(op, [
								"piezasFaltantes",
								"PiezasFaltantes",
								"faltantes",
								"Faltantes",
								"piezasDesfase",
								"PiezasDesfase",
							]);
							entry.expectedPieces += pickNumber(op, [
								"piezasEsperadasHastaConsulta",
								"PiezasEsperadasHastaConsulta",
								"piezasEsperadas",
								"PiezasEsperadas",
								"esperadas",
								"Esperadas",
							]);
							entry.tc = Math.max(entry.tc, pickNumber(op, ["tc", "TC"]));
						});

						odtMap.set(odtKey, entry);
					});
				});

				const odtEntries = Array.from(odtMap.values()).map((entry) => {
					const totalSliceDurationSec = entry.slices.reduce(
						(sum, slice) => sum + this.toNumber(slice?.durationSec),
						0
					);
					const globalDurationSec =
						entry.endGlobalMs > entry.startGlobalMs
							? Math.round((entry.endGlobalMs - entry.startGlobalMs) / 1000)
							: 0;
					const baseDurationSec = Math.max(totalSliceDurationSec, globalDurationSec);

					let advanceSec = Math.max(
						entry.odtProductionSec,
						entry.opProductionSec,
						entry.odtAdvanceSec,
						entry.opAdvanceSec
					);
					let delaySec = Math.max(entry.odtDelaySec, entry.opDelaySec);

					if (advanceSec <= 0 && delaySec <= 0 && baseDurationSec > 0) {
						const inferred = inferBreakdownFromPieces(
							entry.okPieces,
							entry.missingPieces,
							entry.expectedPieces,
							baseDurationSec
						);
						advanceSec = inferred.advanceSec;
						delaySec = inferred.delaySec;
					}

					return {
						...entry,
						totalSliceDurationSec,
						baseDurationSec,
						advanceSec: Math.max(0, Math.round(advanceSec)),
						delaySec: Math.max(0, Math.round(delaySec)),
						articleItems: Array.from(entry.articleSet || []),
						moldItems: Array.from(entry.moldSet || []),
						articlesSummary: this.summarizeExpectedColumn(Array.from(entry.articleSet || [])),
						moldsSummary: this.summarizeExpectedColumn(Array.from(entry.moldSet || [])),
					};
				});

				if (!odtEntries.length) return;

				const pushRow = (
					startMs,
					endMs,
					odtLabel,
					dayLabel,
					timeType,
					fillColor,
					piecesEquivalent = 0,
					details = {}
				) => {
					if (startMs <= 0 || endMs <= startMs) return;
					rows.push({
						x: `${meta.machineLabel}`,
						y: [startMs, endMs],
						odtLabel,
						dayLabel,
						machineKey: meta.machineKey,
						timeType,
						piecesEquivalent,
						articlesSummary: `${details?.articlesSummary || "-"}`.trim() || "-",
						articleItems: this.toArray(details?.articleItems),
						moldsSummary: `${details?.moldsSummary || "-"}`.trim() || "-",
						moldItems: this.toArray(details?.moldItems),
						piecesExpected: this.toNumber(details?.piecesExpected),
						piecesDone: this.toNumber(details?.piecesDone),
						cavitiesCount: this.toNumber(details?.cavitiesCount),
						tcDisplay: `${details?.tcDisplay || "-"}`.trim() || "-",
						fillColor,
					});
				};

				const timelineSlices = [];
				odtEntries.forEach((entry) => {
					const sortedSlices = this.toArray(entry?.slices).sort((a, b) => {
						if (a.startMs !== b.startMs) return a.startMs - b.startMs;
						return a.endMs - b.endMs;
					});
					let remainingDuration = sortedSlices.reduce(
						(sum, slice) => sum + this.toNumber(slice?.durationSec),
						0
					);
					let remainingAdvance = Math.max(0, this.toNumber(entry?.advanceSec));
					let remainingDelay = Math.max(0, this.toNumber(entry?.delaySec));

					sortedSlices.forEach((slice, index) => {
						const isLast = index === sortedSlices.length - 1;
						const sliceDuration = Math.max(0, this.toNumber(slice?.durationSec));

						let advanceForSlice = 0;
						if (remainingAdvance > 0 && sliceDuration > 0) {
							if (isLast || remainingDuration <= 0) {
								advanceForSlice = remainingAdvance;
							} else {
								advanceForSlice = Math.round((remainingAdvance * sliceDuration) / remainingDuration);
							}
						}
						advanceForSlice = Math.max(0, Math.min(advanceForSlice, sliceDuration));
						remainingAdvance = Math.max(0, remainingAdvance - advanceForSlice);

						const availableAfterAdvance = Math.max(0, sliceDuration - advanceForSlice);
						let delayForSlice = 0;
						if (remainingDelay > 0 && availableAfterAdvance > 0) {
							if (isLast || remainingDuration <= 0) {
								delayForSlice = remainingDelay;
							} else {
								delayForSlice = Math.round((remainingDelay * sliceDuration) / remainingDuration);
							}
						}
						delayForSlice = Math.max(0, Math.min(delayForSlice, availableAfterAdvance));
						remainingDelay = Math.max(0, remainingDelay - delayForSlice);

						const known = advanceForSlice + delayForSlice;
						if (known < sliceDuration) {
							const remainder = sliceDuration - known;
							if (this.toNumber(entry?.delaySec) > 0 || this.toNumber(entry?.missingPieces) > 0) {
								delayForSlice += remainder;
							} else if (this.toNumber(entry?.advanceSec) > 0 || this.toNumber(entry?.okPieces) > 0) {
								advanceForSlice += remainder;
							}
						}

						timelineSlices.push({
							startMs: slice.startMs,
							endMs: slice.endMs,
							durationSec: sliceDuration,
							odtLabel: entry.odtLabel,
							dayLabel: slice.dayLabel,
							articlesSummary: entry.articlesSummary,
							articleItems: this.toArray(entry?.articleItems),
							moldsSummary: entry.moldsSummary,
							moldItems: this.toArray(entry?.moldItems),
							piecesExpected: this.toNumber(entry?.expectedPieces),
							piecesDone: this.toNumber(entry?.okPieces),
							tc: this.toNumber(entry?.tc),
							cavitiesCount: this.toNumber(entry?.opSeen?.size),
							tcDisplay: this.getTcDisplay([this.toNumber(entry?.tc)]),
							okPieces: this.toNumber(entry?.okPieces),
							missingPieces: this.toNumber(entry?.missingPieces),
							odtAdvanceTotalSec: this.toNumber(entry?.advanceSec),
							odtDelayTotalSec: this.toNumber(entry?.delaySec),
							advanceSec: advanceForSlice,
							delaySec: delayForSlice,
						});

						remainingDuration = Math.max(0, remainingDuration - sliceDuration);
					});
				});

				const sortedTimeline = timelineSlices.sort((a, b) => {
					if (a.startMs !== b.startMs) return a.startMs - b.startMs;
					if (a.endMs !== b.endMs) return a.endMs - b.endMs;
					return `${a.odtLabel}`.localeCompare(`${b.odtLabel}`);
				});

				let lastEndMs = 0;
				sortedTimeline.forEach((slice) => {
					// Azul solo cuando hay hueco entre una ODT y la siguiente.
					if (lastEndMs > 0 && slice.startMs > lastEndMs) {
						pushRow(lastEndMs, slice.startMs, "Sin ODT", "Separación entre ODT", "Tiempo muerto", "#2f80d6");
					}

					const sliceDurationSec = Math.max(
						0,
						Math.round(
							this.toNumber(slice?.durationSec) ||
							Math.max(0, Math.round((this.toNumber(slice?.endMs) - this.toNumber(slice?.startMs)) / 1000))
						)
					);
					let advanceSec = Math.max(0, Math.round(this.toNumber(slice?.advanceSec)));
					let delaySec = Math.max(0, Math.round(this.toNumber(slice?.delaySec)));

					// Ajuste para que nunca se pase del ancho del tramo.
					const knownTotal = advanceSec + delaySec;
					if (knownTotal > sliceDurationSec && knownTotal > 0) {
						const scale = sliceDurationSec / knownTotal;
						advanceSec = Math.round(advanceSec * scale);
						delaySec = Math.max(0, sliceDurationSec - advanceSec);
					}

					let cursorMs = slice.startMs;
					const sliceEndMs = slice.endMs;

					const pushBySeconds = (seconds, type, color) => {
						const sec = Math.max(0, Math.round(seconds));
						if (sec <= 0 || cursorMs >= sliceEndMs) return 0;
						const segmentEnd = Math.min(sliceEndMs, cursorMs + sec * 1000);
						if (segmentEnd <= cursorMs) return 0;
						const tc = this.toNumber(slice?.tc);
						let piecesEquivalent = 0;
						if (tc > 0) {
							piecesEquivalent = Number((sec / tc).toFixed(1));
						} else if (type === "Producción") {
							const base = Math.max(1, this.toNumber(slice?.odtAdvanceTotalSec));
							piecesEquivalent = Number(((this.toNumber(slice?.okPieces) * sec) / base).toFixed(1));
						} else if (type === "Extra") {
							const base = Math.max(1, this.toNumber(slice?.odtDelayTotalSec));
							piecesEquivalent = Number(((this.toNumber(slice?.missingPieces) * sec) / base).toFixed(1));
						}
						pushRow(
							cursorMs,
							segmentEnd,
							slice.odtLabel,
							slice.dayLabel,
							type,
							color,
							piecesEquivalent,
							{
								articlesSummary: slice.articlesSummary,
								articleItems: slice.articleItems,
								moldsSummary: slice.moldsSummary,
								moldItems: slice.moldItems,
								piecesExpected: slice.piecesExpected,
								piecesDone: slice.piecesDone,
								cavitiesCount: slice.cavitiesCount,
								tcDisplay: slice.tcDisplay,
							}
						);
						const used = Math.max(0, Math.round((segmentEnd - cursorMs) / 1000));
						cursorMs = segmentEnd;
						return used;
					};

					pushBySeconds(advanceSec, "Producción", "#2e9d53");
					pushBySeconds(delaySec, "Extra", "#f0ac22");

					lastEndMs = Math.max(lastEndMs, slice.endMs);
				});
			});
			const orderedRows = rows.sort((a, b) => {
				const aStart = this.toNumber(a?.y?.[0]);
				const bStart = this.toNumber(b?.y?.[0]);
				if (aStart !== bStart) return aStart - bStart;
				return `${a.x}`.localeCompare(`${b.x}`);
			});
			return this.removeTrailingDeadTimeRows(orderedRows);
		},
		setSummaryCards(data, catalog) {
			const activeMachines = this.getDataArray(data, ["maquinasEnUso", "MaquinasEnUso"]);
			const idleMachines = this.getDataArray(data, ["maquinasSinUso", "MaquinasSinUso"]);
			const restartMachines = this.getDataArray(data, ["historialArranquesV2", "HistorialArranquesV2"]);
			const machinesWithLostPiecesWithoutOdt = this.getDataArray(data, [
				"maquinasConPiezasPerdidasUltimos5Min",
				"MaquinasConPiezasPerdidasUltimos5Min",
			]);
			const stopWithPieces = this.getDataArray(data, [
				"maquinasConParoEnCursoConPiezas",
				"MaquinasConParoEnCursoConPiezas",
			]);
			const stopWithoutPieces = this.getDataArray(data, [
				"maquinasConParoEnCursoSinPiezas",
				"MaquinasConParoEnCursoSinPiezas",
			]);
			// Fallback de compatibilidad para payloads anteriores sin separación de paro.
			const fallbackStops =
				stopWithPieces.length || stopWithoutPieces.length
					? []
					: this.getDataArray(data, [
						"maquinasConParoEnCurso",
						"MaquinasConParoEnCurso",
						"maquinasConparoEnCurso",
						"MaquinasConparoEnCurso",
					]);

			const stopWithPiecesRows = stopWithPieces.length ? stopWithPieces : fallbackStops;
			const stopWithoutPiecesRows = stopWithoutPieces;

			const stopWithPiecesIds = this.buildMachineIdSet(stopWithPiecesRows);
			const stopWithoutPiecesIds = this.buildMachineIdSet(stopWithoutPiecesRows);
			const allStopIds = new Set([...stopWithPiecesIds, ...stopWithoutPiecesIds]);

			const activeFilteredRows = this.toArray(activeMachines).filter((row) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				return id <= 0 || !allStopIds.has(id);
			});
			const idleFilteredRows = this.toArray(idleMachines).filter((row) => {
				const id = this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns);
				return id <= 0 || !allStopIds.has(id);
			});

			const machinesWithLostPiecesWithoutOdtCount = this.toArray(machinesWithLostPiecesWithoutOdt).length;
			const activeCount = this.buildUniqueCount(activeFilteredRows) + machinesWithLostPiecesWithoutOdtCount;
			const paroCount = this.buildUniqueCount([...stopWithPiecesRows, ...stopWithoutPiecesRows]);
			const paroWithPiecesCount = this.buildUniqueCount(stopWithPiecesRows);
			const noActivityCount = this.buildUniqueCount(stopWithoutPiecesRows);
			const idleCount = this.buildUniqueCount(idleFilteredRows);
			const totalMachinesFromPayload = this.toNumber(data?.totalMaquinas ?? data?.TotalMaquinas);
			const totalMachines = totalMachinesFromPayload > 0 ? totalMachinesFromPayload : catalog.size;
			const totalMachinesWithAdjustedTheoreticalOdtNow = this.toNumber(
				data?.totalMaquinasConOdtTeoricaAjustadaEnAhora ??
				data?.TotalMaquinasConOdtTeoricaAjustadaEnAhora
			);
			const activeDetail = this.buildMachineDetails(activeFilteredRows);
			const idleDetail = this.buildMachineDetails(idleFilteredRows);
			const stopDetail = this.buildStoppedDetails([...stopWithPiecesRows, ...stopWithoutPiecesRows]);
			const noActivityDetail = this.buildMachineDetails(stopWithoutPiecesRows);
			const restartDetail = this.buildRestartDetails(restartMachines);
			const piecesWithoutOdtDetail = this.toArray(machinesWithLostPiecesWithoutOdt).map((row, index) => ({
				uid: `pieces-without-odt-${this.toNumber(row?.IdMaquinaIns ?? row?.idMaquinaIns)}-${index}`,
				nombreInstancia: `${row?.NombreInstancia ?? row?.nombreInstancia ?? "-"}`.trim() || "-",
			}));
			const restartsCount = restartDetail.reduce((total, row) => total + this.getRestartCount(row), 0);

			this.cardCounters = {
				active: activeCount,
				withProgram: totalMachines,
				stopped: paroCount,
				stoppedWithPieces: paroWithPiecesCount,
				noActivity: noActivityCount,
				idle: idleCount,
				restarts: restartsCount,
				total: totalMachines,
			};
			this.cardDetails = {
				active: activeDetail,
				stopped: stopDetail,
				noActivity: noActivityDetail,
				idle: idleDetail,
				restarts: restartDetail,
				piecesWithoutOdt: piecesWithoutOdtDetail,
			};

			this.summaryCards = [
				{
					key: "active",
					title: "Maquinas activas",
					primaryValue: `${activeCount}`,
					secondaryValue: `${totalMachinesWithAdjustedTheoreticalOdtNow}`,
					caption: "Con actividad",
					icon: "mdi-cog-outline",
					tone: "blue",
				},
				// {
				// 	key: "idle",
				// 	title: "Máquinas sin orden de trabajo activa",
				// 	primaryValue: `${idleCount}`,
				// 	secondaryValue: "",
				// 	caption: "No aparecen con actividad",
				// 	icon: "mdi-speedometer",
				// 	tone: "slate",
				// },
				// {
				// 	key: "stopped",
				// 	title: "Maquinas en paro",
				// 	primaryValue: `${paroCount}`,
				// 	secondaryValue: "",
				// 	caption: "Con o sin actividad",
				// 	icon: "mdi-alert-outline",
				// 	tone: "amber",
				// },
			];
		},
			applyReporteData(data) {
				const ganttTiempoReal = data?.ganttTiempoReal || data?.GanttTiempoReal || {};
				const fechaFinJornadaRaw = `${ganttTiempoReal?.fechaFinJornada || ganttTiempoReal?.FechaFinJornada || data?.fechaFinJornada || data?.FechaFinJornada || ""}`.trim();
				this.fechaFinJornada = fechaFinJornadaRaw || null;
				const machineCatalog = this.buildMachineCatalog(data);
				this.setSummaryCards(data, machineCatalog);
			const programmedRowsWithMachineVisibility = this.applyMachineVisibilityPreference(
				this.buildProgrammedMachineRows(data),
				this.getProgrammedVisibilityStorageKey()
			);
			this.programmedMachineRows = this.applyProgrammedOdtVisibilityPreference(programmedRowsWithMachineVisibility);
			this.programmedGanttBars = this.buildProgrammedGanttBars(data);
			this.realMachineRows = this.applyMachineVisibilityPreference(
				this.buildRealWeekMachineRows(data),
				this.getRealVisibilityStorageKey()
			);
			this.realWeekGanttBars = this.buildRealWeekGanttBars(data);
			this.combinedUnifiedBars = this.buildCombinedUnifiedGanttBars(data);
			this.expandedProgrammedRows = [];
			this.expandedRealRows = [];
		},
		async getMaquinasEstatus() {
			const endpoint = `/MaquinaInstancias/MaquinasUsoSemanaActual${this.buildFechaConsultaQuery()}`;
			const response = await axios.get(endpoint);
			const rawPayload = response?.data;
			const normalizedPayload = this.normalizeResponse(response);
			if (normalizedPayload && typeof normalizedPayload === "object") {
				const safeRaw = rawPayload && typeof rawPayload === "object" ? rawPayload : {};
				// Conserva campos en raíz del response (p. ej. fechaConsulta y totales)
				// además del objeto normalizado usado por el resto de la vista.
				return { ...safeRaw, ...normalizedPayload };
			}
			return rawPayload && typeof rawPayload === "object" ? rawPayload : {};
		},
		formatDuration(totalSeconds) {
			const safeSeconds = Math.max(0, Math.round(this.toNumber(totalSeconds)));
			const totalMinutes = Math.floor(safeSeconds / 60);
			const days = Math.floor(totalMinutes / 1440);
			const remainingAfterDays = totalMinutes % 1440;
			const hours = Math.floor(remainingAfterDays / 60);
			const minutes = remainingAfterDays % 60;
			return `${days}d ${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
		},
		formatDurationHoursOnly(totalSeconds) {
			const totalHours = Math.max(0, this.toNumber(totalSeconds)) / 3600;
			return `${totalHours.toLocaleString("en-US", {
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			})} h`;
		},
		formatHoursMinutes(totalSeconds) {
			const safeSeconds = Math.max(0, Math.round(this.toNumber(totalSeconds)));
			const hours = Math.floor(safeSeconds / 3600);
			const minutes = Math.floor((safeSeconds % 3600) / 60);
			return `${hours}h ${String(minutes).padStart(2, "0")}m`;
		},
		formatNumber(value) {
			const n = this.toNumber(value);
			const isInteger = Math.abs(n - Math.trunc(n)) < 0.000001;
			return n.toLocaleString("en-US", {
				minimumFractionDigits: 0,
				maximumFractionDigits: isInteger ? 0 : 1,
			});
		},
	},
	mounted() {
		const nowWeek = this.getIsoWeekInfo(new Date());
		this.programmedWeekYear = nowWeek.isoYear;
		if (this.toNumber(this.programmedWeekNumber) <= 0) {
			this.programmedWeekNumber = nowWeek.isoWeek;
		}
		if (this.active) this.ensureData(true);
		this._syncFullscreenReporte = () => this.syncFullscreenReporte();
		document.addEventListener("fullscreenchange", this._syncFullscreenReporte);
		document.addEventListener("webkitfullscreenchange", this._syncFullscreenReporte);
		document.addEventListener("MSFullscreenChange", this._syncFullscreenReporte);
		this.syncFullscreenReporte();
	},
	beforeDestroy() {
		if (!this._syncFullscreenReporte) return;
		document.removeEventListener("fullscreenchange", this._syncFullscreenReporte);
		document.removeEventListener("webkitfullscreenchange", this._syncFullscreenReporte);
		document.removeEventListener("MSFullscreenChange", this._syncFullscreenReporte);
	},
};
</script>

<style scoped>
.cp-fullscreen-root:fullscreen,
.cp-fullscreen-root:-webkit-full-screen {
	background: #ffffff;
	overflow: auto;
}

.cp-fullscreen-root:fullscreen .cp-refresh-countdown,
.cp-fullscreen-root:-webkit-full-screen .cp-refresh-countdown {
	display: none !important;
}

.cp-fullscreen-root:fullscreen .cp-refresh-button,
.cp-fullscreen-root:-webkit-full-screen .cp-refresh-button {
	display: none !important;
}

.cp-header {
	border-bottom: 1px solid #dfe6f1;
	margin-bottom: 18px;
	padding-bottom: 14px;
}

.cp-title {
	color: #16243a;
	font-family: "Montserrat", "Segoe UI", sans-serif;
	font-size: clamp(2rem, 2.8vw, 3.2rem);
	font-weight: 700;
	letter-spacing: 0.2px;
	margin: 0;
}

.cp-top-layout {
	align-items: start;
	display: grid;
	gap: 20px;
	grid-template-columns: minmax(0, 1fr);
}

.cp-left-stack {
	display: flex;
	flex-direction: column;
	gap: 14px;
	max-width: none;
	width: 100%;
}

.cp-kpi-grid {
	display: grid;
	align-items: stretch;
	gap: 14px;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.cp-kpi-card {
	background: linear-gradient(180deg, #f8fbff 0%, #f2f6fc 100%);
	border: 1px solid #c4d5ea;
	border-radius: 22px;
	box-shadow: none;
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: flex-start;
	min-height: 168px;
	padding: 14px 16px 12px;
}

.cp-kpi-card--blue {
	border-color: #8fc1f3;
}

.cp-kpi-card--amber {
	border-color: #f0be82;
}

.cp-kpi-card--slate {
	border-color: #f0b2b7;
}

.cp-kpi-card--violet {
	border-color: #c7b8f6;
}

.cp-kpi-card--green {
	border-color: #8fd9a8;
}

.cp-kpi-top {
	align-items: center;
	display: flex;
	justify-content: space-between;
}

.cp-kpi-top-main {
	align-items: center;
	display: flex;
	gap: 12px;
	min-width: 0;
}

.cp-kpi-eye-btn {
	height: 26px !important;
	margin-left: 8px;
	width: 26px !important;
}

.cp-kpi-eye-icon {
	color: #9aa6b8 !important;
	font-size: 1.1rem !important;
}

.cp-kpi-icon-pack {
	align-items: center;
	border-radius: 16px;
	box-shadow: none;
	display: inline-flex;
	height: 52px;
	justify-content: center;
	width: 52px;
}

.cp-kpi-icon-pack--blue {
	background: linear-gradient(145deg, #d8e9fb, #c6def7);
}

.cp-kpi-icon-pack--amber {
	background: linear-gradient(145deg, #fde7c7, #f8d8a4);
}

.cp-kpi-icon-pack--slate {
	background: linear-gradient(145deg, #f6d9dd, #f2c8cd);
}

.cp-kpi-icon-pack--violet {
	background: linear-gradient(145deg, #ece6ff, #ddd2ff);
}

.cp-kpi-icon-pack--green {
	background: linear-gradient(145deg, #d7f5e3, #bff0cf);
}

.cp-kpi-icon-main {
	color: #2e8aed !important;
	font-size: 1.45rem !important;
}

.cp-kpi-icon-pack--amber .cp-kpi-icon-main {
	color: #f28d00 !important;
}

.cp-kpi-icon-pack--slate .cp-kpi-icon-main {
	color: #ee5159 !important;
}

.cp-kpi-icon-pack--violet .cp-kpi-icon-main {
	color: #6d50d7 !important;
}

.cp-kpi-icon-pack--green .cp-kpi-icon-main {
	color: #2ea44f !important;
}

.cp-kpi-title {
	color: #1c2639;
	font-size: clamp(1.05rem, 1.1vw, 1.3rem);
	font-weight: 700;
	line-height: 1.15;
	margin: 0;
	text-align: left;
}

.cp-kpi-value-row {
	align-items: baseline;
	display: flex;
	gap: 8px;
	justify-content: center;
	margin: 8px 0 4px;
	text-align: center;
	width: 100%;
}

.cp-kpi-value-main {
	font-size: 52px !important;
	font-weight: 800;
	line-height: 0.9;
	margin: 0;
}

.cp-kpi-value-main--blue {
	color: #2d84da;
}

.cp-kpi-value-main--amber {
	color: #f08b00;
}

.cp-kpi-value-main--slate {
	color: #ee5159;
}

.cp-kpi-value-main--violet {
	color: #6d50d7;
}

.cp-kpi-value-main--green {
	color: #2ea44f;
}
.cp-kpi-value-secondary {
	color: #667791;
	font-size: 27px !important;
	font-weight: 700;
	line-height: 1;
	margin: 0;
}

.cp-kpi-caption {
	color: #657993;
	font-size: clamp(0.9rem, 0.95vw, 1rem);
	font-weight: 500;
	line-height: 1.1;
	margin: auto 0 0;
}

.cp-progress-toggle {
	background: #e7edf6;
	border: 1px solid #c6d4e8;
	border-radius: 999px;
	color: #3a4f6b;
	cursor: pointer;
	font-size: 0.85rem;
	font-weight: 700;
	padding: 4px 12px;
	transition: all 0.2s ease;
}

.cp-progress-toggle--active {
	background: #2f6db0;
	border-color: #255a94;
	color: #ffffff;
}

.cp-gantt-switch {
	display: flex;
	gap: 8px;
	margin-bottom: 10px;
}

.cp-gantt-switch--main {
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 8px;
}

.cp-main-gantt-head {
	gap: 10px;
}

.cp-main-gantt-actions {
	align-items: center;
	display: inline-flex;
	gap: 8px;
	margin-left: auto;
}

.cp-toggle-week-btn {
	flex-shrink: 0;
}

.cp-toggle-table-btn {
	flex-shrink: 0;
}

.cp-gantt-order-note {
	color: #5d6f88;
	font-size: 0.76rem;
	font-weight: 600;
	letter-spacing: 0.01em;
}

.cp-gantt-limit-control {
	align-items: center;
	display: inline-flex;
	gap: 6px;
	margin-left: auto;
}

.cp-gantt-limit-label {
	color: #445a77;
	font-size: 0.76rem;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.cp-gantt-limit-select {
	background: #ffffff;
	border: 1px solid #c8d4e5;
	border-radius: 10px;
	color: #253b57;
	font-size: 0.78rem;
	font-weight: 700;
	height: 30px;
	min-width: 94px;
	outline: none;
	padding: 0 10px;
}

.cp-gantt-limit-select:focus {
	border-color: #2f6db0;
	box-shadow: 0 0 0 2px rgba(47, 109, 176, 0.15);
}

.cp-gantt-limit-input {
	background: #ffffff;
	border: 1px solid #c8d4e5;
	border-radius: 10px;
	color: #253b57;
	font-size: 0.78rem;
	font-weight: 700;
	height: 30px;
	min-width: 118px;
	outline: none;
	padding: 0 10px;
}

.cp-gantt-limit-input:focus {
	border-color: #2f6db0;
	box-shadow: 0 0 0 2px rgba(47, 109, 176, 0.15);
}

.cp-week-form-grid {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cp-week-form-grid--inline {
	grid-template-columns: repeat(2, minmax(180px, 1fr));
}

.cp-week-form-field {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.cp-week-form-label {
	color: #435a78;
	font-size: 0.8rem;
	font-weight: 700;
}

.cp-week-form-select {
	background: #ffffff;
	border: 1px solid #c8d4e5;
	border-radius: 10px;
	color: #253b57;
	font-size: 0.82rem;
	font-weight: 700;
	height: 34px;
	outline: none;
	padding: 0 10px;
}

.cp-week-form-select:focus {
	border-color: #2f6db0;
	box-shadow: 0 0 0 2px rgba(47, 109, 176, 0.15);
}

.cp-week-range-line {
	color: #314864;
	display: flex;
	flex-wrap: wrap;
	font-size: 0.86rem;
	gap: 10px 18px;
	margin-top: 10px;
}

.cp-week-machines-row {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 8px 12px;
	margin-top: 10px;
}

.cp-week-machines-row--inline {
	margin-bottom: 10px;
	margin-top: 0;
}

.cp-week-machines-label {
	color: #445a77;
	font-size: 0.8rem;
	font-weight: 700;
}

.cp-week-machines-controls {
	display: inline-flex;
	gap: 6px;
}

.cp-week-loading-text {
	color: #5d6f88;
	font-size: 0.82rem;
	font-weight: 700;
}

.cp-week-endpoint-note {
	color: #5d6f88;
	font-size: 0.8rem;
	line-height: 1.35;
	margin-top: 10px;
}

.cp-week-dialog-gantt {
	margin-top: 10px;
}

.cp-programmed-layout {
	margin-top: 14px;
}

.cp-real-layout {
	margin-top: 14px;
}

.cp-panel--programmed {
	padding: 12px 12px 10px;
}

.cp-oee-ring {
	align-items: center;
	background:
		radial-gradient(circle at 26% 22%, rgba(173, 246, 255, 0.7) 0%, rgba(81, 194, 255, 0.28) 25%, rgba(29, 118, 216, 0.42) 58%, rgba(10, 48, 113, 0.96) 100%);
	border: 6px solid #c8d5e9;
	border-radius: 50%;
	box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.78), 0 14px 28px rgba(9, 34, 74, 0.24);
	display: flex;
	height: clamp(220px, 24vw, 320px);
	justify-content: center;
	width: clamp(220px, 24vw, 320px);
}

.cp-oee-core {
	align-items: center;
	border: 2px solid rgba(255, 255, 255, 0.8);
	border-radius: 50%;
	box-shadow: inset 0 0 22px rgba(92, 233, 255, 0.42);
	color: #eef8ff;
	display: flex;
	flex-direction: column;
	height: 84%;
	justify-content: center;
	width: 84%;
}

.cp-oee-label {
	font-size: clamp(2rem, 2.6vw, 3.4rem);
	font-weight: 700;
	line-height: 1;
	margin: 0;
}

.cp-oee-value {
	font-size: clamp(2.8rem, 4vw, 4.8rem);
	font-weight: 800;
	line-height: 1;
	margin: 10px 0 0;
}

.cp-panel {
	background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
	border: 1px solid #d8e2ef;
	border-radius: 14px;
	box-shadow: 0 8px 18px rgba(24, 43, 70, 0.09);
	padding: 12px;
}

.cp-panel-head {
	color: #1f2f46;
	font-size: clamp(1.15rem, 1.45vw, 1.7rem);
	font-weight: 700;
	margin-bottom: 10px;
}

.cp-panel-head-row {
	align-items: center;
	display: flex;
	justify-content: space-between;
}

.cp-real-legend {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 8px 14px;
	margin: -4px 0 10px;
}

.cp-real-legend-item {
	align-items: center;
	color: #3d5574;
	display: inline-flex;
	font-size: 0.82rem;
	font-weight: 600;
	gap: 6px;
}

.cp-real-legend-dot {
	border-radius: 999px;
	display: inline-block;
	height: 10px;
	width: 10px;
}

.cp-real-legend-dot--production {
	background: #2e9d53;
}

.cp-real-legend-dot--setup {
	background: #2e9d53;
}

.cp-real-legend-dot--dead {
	background: #2f80d6;
}

.cp-real-legend-dot--delay {
	background: #f0ac22;
}

.cp-real-legend-dot--late {
	background: #d64545;
}

.cp-combined-legend {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 8px 14px;
	margin: -4px 0 10px;
}

.cp-combined-legend-item {
	align-items: center;
	color: #3d5574;
	display: inline-flex;
	font-size: 0.8rem;
	font-weight: 600;
	gap: 6px;
}

.cp-combined-legend-dot {
	border-radius: 999px;
	display: inline-block;
	height: 10px;
	width: 10px;
}

.cp-combined-legend-dot--timeoff {
	background: #ffffff;
	border: 1px solid #cdd8e5;
}

.cp-combined-legend-dot--setup-change {
	background: #63b46a;
}

.cp-combined-legend-dot--setup-adjust {
	background: #63b46a;
}

.cp-combined-legend-dot--restartable {
	background: #8b5e3c;
}

.cp-combined-legend-dot--production {
	background: #63b46a;
}

.cp-combined-legend-dot--delay-low {
	background: #f0ac22;
}

.cp-combined-legend-dot--delay-mid {
	background: #e67e22;
}

.cp-combined-legend-dot--extra {
	background: #d64545;
}

.cp-combined-legend-dot--inop {
	background: #d64545;
}

.cp-combined-loading {
	margin-bottom: 8px;
}

.cp-top-reload-loading {
	margin-bottom: 10px;
}

.cp-section-eye-btn {
	height: 26px !important;
	width: 26px !important;
}

.cp-section-eye-icon {
	color: #9aa6b8 !important;
	font-size: 1.1rem !important;
}

.cp-detail-dialog {
	border-radius: 16px;
}

.cp-detail-title {
	color: #22354f;
	font-size: 1.05rem;
	font-weight: 700;
}

.cp-detail-summary {
	color: #324865;
	display: flex;
	flex-wrap: wrap;
	font-size: 0.92rem;
	gap: 12px 24px;
	margin-bottom: 10px;
}

.cp-detail-table-wrap {
	border: 1px solid #e3ebf5;
	border-radius: 10px;
	overflow: auto;
}

.cp-gantt-wrap {
	background: #ffffff;
	border: 1px solid #e3ebf5;
	border-radius: 10px;
	padding: 10px;
}

.cp-detail-subtitle {
	color: #314864;
	font-size: 0.92rem;
	font-weight: 700;
	margin: 12px 0 8px;
}

.cp-detail-table {
	border-collapse: collapse;
	min-width: 600px;
	width: 100%;
}

.cp-detail-table--gantt {
	min-width: 1520px;
}

.cp-detail-table--restart {
	min-width: 1320px;
}

.cp-detail-table--restart-operation {
	min-width: 720px;
}

.cp-expected-datatable {
	min-width: 760px;
}

.cp-expected-datatable ::v-deep table {
	min-width: 760px;
}

.cp-expected-datatable ::v-deep th,
.cp-expected-datatable ::v-deep td {
	border-bottom: 1px solid #edf2f8;
	font-size: 0.88rem;
	padding: 8px 10px;
}

.cp-expected-datatable ::v-deep th {
	background: #f4f8fd;
	color: #314864;
	font-weight: 700;
}

.cp-ops-cell {
	background: #f9fbff;
	padding: 10px !important;
}

.cp-ops-wrap {
	border: 1px solid #e3ebf5;
	border-radius: 8px;
	overflow: auto;
}

.cp-ops-table {
	border-collapse: collapse;
	min-width: 760px;
	width: 100%;
}

.cp-ops-table th,
.cp-ops-table td {
	border-bottom: 1px solid #edf2f8;
	font-size: 0.84rem;
	padding: 7px 9px;
	text-align: left;
}

.cp-ops-visibility-cell {
	text-align: center !important;
	width: 40px;
}

.cp-odt-eye-btn {
	height: 20px !important;
	width: 20px !important;
}

.cp-ops-table th {
	background: #f2f7fe;
	color: #314864;
	font-weight: 700;
}

.cp-detail-table th,
.cp-detail-table td {
	border-bottom: 1px solid #edf2f8;
	font-size: 0.88rem;
	padding: 8px 10px;
	text-align: left;
}

.cp-detail-table th {
	background: #f4f8fd;
	color: #314864;
	font-weight: 700;
}

.cp-cell-list {
	margin: 0;
	padding-left: 16px;
}

.cp-cell-list li {
	line-height: 1.25;
	margin: 0;
}

.cp-restart-action-cell {
	text-align: center !important;
	width: 140px;
}

.cp-restart-detail-dialog {
	background: linear-gradient(180deg, #f9fbff 0%, #ffffff 34%);
	border: 1px solid #dfe8f3;
	box-shadow: 0 18px 48px rgba(38, 59, 86, 0.16);
	overflow: hidden;
}

.cp-restart-detail-body {
	padding-top: 4px;
}

.cp-restart-detail-summary {
	margin-bottom: 14px;
}

.cp-restart-odt-list {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	margin-top: 10px;
}

.cp-restart-odt-card {
	background: linear-gradient(180deg, rgba(245, 249, 255, 0.96) 0%, #ffffff 100%);
	border: 1px solid #dce6f1;
	border-radius: 14px;
	box-shadow: 0 6px 18px rgba(35, 56, 83, 0.06);
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 14px 15px;
}

.cp-restart-odt-label {
	color: #21344c;
	font-size: 0.96rem;
	font-weight: 800;
	letter-spacing: 0.01em;
}

.cp-restart-odt-count {
	color: #4b5d75;
	font-size: 0.86rem;
	line-height: 1.35;
}

.cp-restart-tabs {
	margin-bottom: 12px;
}

.cp-restart-tabs ::v-deep .v-tab {
	letter-spacing: 0;
	max-width: none;
	min-width: 160px;
	text-transform: none;
}

.cp-restart-single-odt {
	color: #324865;
	font-size: 0.9rem;
	font-weight: 700;
	margin-bottom: 12px;
}

.cp-restart-selected-odt {
	display: flex;
	flex-direction: column;
	gap: 14px;
}

.cp-restart-odt-summary-row {
	align-items: flex-start;
	display: flex;
	flex-wrap: wrap;
	gap: 10px 16px;
	justify-content: space-between;
}

.cp-restart-odt-label--active {
	font-size: 1.02rem;
}

.cp-restart-meta-grid {
	display: grid;
	gap: 12px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cp-restart-meta-card {
	background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
	border: 1px solid #dfe8f3;
	border-radius: 14px;
	padding: 14px 15px;
}

.cp-restart-meta-title {
	color: #22354f;
	font-size: 0.92rem;
	font-weight: 800;
	margin-bottom: 10px;
}

.cp-restart-chip-list {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.cp-restart-chip {
	align-items: center;
	background: #e9f4ee;
	border: 1px solid #cfe7d8;
	border-radius: 999px;
	color: #20533d;
	display: inline-flex;
	font-size: 0.82rem;
	font-weight: 700;
	line-height: 1.2;
	padding: 6px 10px;
}

.cp-restart-chip--article {
	background: #eef4fb;
	border-color: #d4e0ef;
	color: #234064;
}

.cp-restart-chart-card {
	grid-column: 1 / -1;
}

.cp-restart-chart-wrap {
	overflow: hidden;
}

.cp-restart-sort-controls {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 10px;
}

.cp-restart-sort-label {
	color: #324865;
	font-size: 0.88rem;
	font-weight: 700;
}

.cp-detail-empty--compact {
	margin-top: 2px;
}

.cp-detail-empty {
	color: #6d7f97;
	font-size: 0.92rem;
	padding: 4px 0 2px;
}

@media (max-width: 1160px) {

	.cp-top-layout {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 860px) {
	.cp-main-gantt-head {
		align-items: flex-start;
		flex-direction: column;
	}

	.cp-main-gantt-actions {
		margin-left: 0;
	}

	.cp-gantt-order-note {
		flex-basis: 100%;
	}

	.cp-gantt-limit-control {
		margin-left: 0;
	}

	.cp-kpi-grid {
		grid-template-columns: 1fr;
		grid-auto-rows: auto;
	}

	.cp-kpi-card {
		min-height: 156px;
	}

	.cp-kpi-value-main {
		font-size: 37px !important;
	}

	.cp-kpi-value-secondary {
		font-size: 20px !important;
	}

	.cp-week-form-grid {
		grid-template-columns: 1fr;
	}

	.cp-week-machines-row {
		align-items: flex-start;
		flex-direction: column;
	}

	.cp-restart-meta-grid {
		grid-template-columns: 1fr;
	}
}
</style>
